/*!
 * Bootstrap tabs v3.4.1 (https://getbootstrap.com/) 
 * Copyright 2011-2020 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(t){"use strict";var e=t.fn.jquery.split(" ")[0].split(".");if(e[0]<2&&e[1]<9||1==e[0]&&9==e[1]&&e[2]<1||e[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(t){"use strict";function e(e){return this.each(function(){var n=t(this),r=n.data("bs.tab");r||n.data("bs.tab",r=new a(this)),"string"==typeof e&&r[e]()})}var a=function(e){this.element=t(e)};a.VERSION="3.4.1",a.TRANSITION_DURATION=150,a.prototype.show=function(){var e=this.element,a=e.closest("ul:not(.dropdown-menu)"),n=e.data("target");if(n||(n=e.attr("href"),n=n&&n.replace(/.*(?=#[^\s]*$)/,"")),!e.parent("li").hasClass("active")){var r=a.find(".active:last a"),i=t.Event("hide.bs.tab",{relatedTarget:e[0]}),s=t.Event("show.bs.tab",{relatedTarget:r[0]});if(r.trigger(i),e.trigger(s),!s.isDefaultPrevented()&&!i.isDefaultPrevented()){var o=t(document).find(n);this.activate(e.closest("li"),a),this.activate(o,o.parent(),function(){r.trigger({type:"hidden.bs.tab",relatedTarget:e[0]}),e.trigger({type:"shown.bs.tab",relatedTarget:r[0]})})}}},a.prototype.activate=function(e,n,r){function i(){s.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),e.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),o?(e[0].offsetWidth,e.addClass("in")):e.removeClass("fade"),e.parent(".dropdown-menu").length&&e.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),r&&r()}var s=n.find("> .active"),o=r&&t.support.transition&&(s.length&&s.hasClass("fade")||!!n.find("> .fade").length);s.length&&o?s.one("bsTransitionEnd",i).emulateTransitionEnd(a.TRANSITION_DURATION):i(),s.removeClass("in")};var n=t.fn.tab;t.fn.tab=e,t.fn.tab.Constructor=a,t.fn.tab.noConflict=function(){return t.fn.tab=n,this};var r=function(a){a.preventDefault(),e.call(t(this),"show")};t(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',r).on("click.bs.tab.data-api",'[data-toggle="pill"]',r)}(jQuery);

let baseApiUrl = 'https://4w0ydc0g8e.execute-api.eu-central-1.amazonaws.com/api';
let wsBaseApiUrl = baseApiUrl + '/ws';
let m2mBaseApiUrl = baseApiUrl + '/m2m';

function init_productcarouselwoo(sync1, sync2){

  sync1.owlCarousel({
    onChanged: doChange,
    singleItem : true,
    slideSpeed : 1000,
    items : 1,
    navigation: false,
    dots: false,
    pagination: false,
//     afterAction : syncPosition,
    autoHeight: true,
    responsiveRefreshRate : 200,
//     navigationText: ['<i class="tfa tfa-chevron-left-white"></i>','<i class="tfa tfa-chevron-right"></i>'],
    lazyLoad: true
  });

  sync2.owlCarousel({
    theme : 'woocommerce-thumbnails',
    items : sync2.data('items'),
    responsiveClass:true,
    responsive:{
      0:{
        items:3,
      },
      385:{
        items:4,
      },
      480:{
        items:5,
      },
      568:{
        items:6,
      },
      768:{
        items:4,
      },
      991:{
        items:5,
      },
      1200:{
        items:6,
      }
    },
    nav: false,
    dots: false,
    navigation: true,
    navigationText: false,
    pagination:false,
    responsiveRefreshRate : 100,
    afterInit : function(el){
      el.find(".owl-item").eq(0).addClass("synced");
    },
    lazyLoad: true
  });

  sync2.on("click", ".owl-item", function(e){
    e.preventDefault();
    var number = $(this).index();
    sync1.trigger('to.owl.carousel', number);
  });

  function syncPosition(el){
    var current = this.currentItem;

    sync2
        .find(".owl-item")
        .removeClass("synced")
        .eq(current)
        .addClass("synced");
    if(sync2.data("owlCarousel") !== undefined){
      center(current)
    }
  }
  function center(number){
    var sync2visible = sync2.data("owlCarousel").owl.visibleItems;

    var num = number;
    var found = false;

    for(var i in sync2visible){
      if(num === sync2visible[i]){
        var found = true;
      }
    }

    if(found===false){
      if(num>sync2visible[sync2visible.length-1]){
        sync2.trigger("owl.goTo", num - sync2visible.length+2)
      }else{
        if(num - 1 === -1){
          num = 0;
        }
        sync2.trigger("owl.goTo", num);
      }
    } else if(num === sync2visible[sync2visible.length-1]){
      sync2.trigger("owl.goTo", sync2visible[1])
    } else if(num === sync2visible[0]){
      sync2.trigger("owl.goTo", num-1)
    }
  }


}

function doChange(e) {
  active_image = e.item.index;
}

(function($){
  init_productcarouselwoo($("#sync1"), $("#sync2"));
})(jQuery);


/*!
 * @name        easyzoom
 * @author       <>
 * @modified    Friday, May 15th, 2020
 * @version     2.5.2
 */
!function(t,e){"use strict";"function"==typeof define&&define.amd?define(["jquery"],function(t){e(t)}):"object"==typeof module&&module.exports?module.exports=t.EasyZoom=e(require("jquery")):t.EasyZoom=e(t.jQuery)}(this,function(o){"use strict";var c,l,d,p,u,f,i={loadingNotice:"Loading image",errorNotice:"The image could not be loaded",errorDuration:2500,linkAttribute:"href",preventClicks:!0,beforeShow:o.noop,beforeHide:o.noop,onShow:o.noop,onHide:o.noop,onMove:o.noop};function s(t,e){this.$target=o(t),this.opts=o.extend({},i,e,this.$target.data()),void 0===this.isOpen&&this._init()}
return s.prototype._init=function(){
  this.$link=this.$target.find("a"),
    this.$image=this.$target.find("img"),
    this.$flyout=o('<div class="easyzoom-flyout" />'),
    this.$notice=o('<div class="easyzoom-notice" />'),
    this.$target.on({
    	"mousemove.easyzoom touchmove.easyzoom":o.proxy(this._onMove,this),
//     	"mouseleave.easyzoom touchend.easyzoom":o.proxy(this._onLeave,this),
    	"mouseenter.easyzoom touchstart.easyzoom":o.proxy(this._onEnter,this)
  	}),
    this.opts.preventClicks&&this.$target.on("click.easyzoom",function(t){t.preventDefault()})
  },
  s.prototype.show=function(t,e){var i=this;if(!1!==this.opts.beforeShow.call(this)){if(!this.isReady)return this._loadImage(this.$link.attr(this.opts.linkAttribute),function(){!i.isMouseOver&&e||i.show(t)});this.$target.append(this.$flyout);var o=this.$target.outerWidth(),s=this.$target.outerHeight(),h=this.$flyout.width(),n=this.$flyout.height(),a=this.$zoom.width(),r=this.$zoom.height();c=Math.ceil(a-h),l=Math.ceil(r-n),c<0&&(c=0),l<0&&(l=0),d=c/o,p=l/s,this.isOpen=!0,this.opts.onShow.call(this),t&&this._move(t)}},s.prototype._onEnter=function(t){var e=t.originalEvent.touches;this.isMouseOver=!0,e&&1!=e.length||(t.preventDefault(),this.show(t,!0))},s.prototype._onMove=function(t){this.isOpen&&(t.preventDefault(),this._move(t))},s.prototype._onLeave=function(){this.isMouseOver=!1,this.isOpen&&this.hide()},s.prototype._onLoad=function(t){t.currentTarget.width&&(this.isReady=!0,this.$notice.detach(),this.$flyout.html(this.$zoom),this.$target.removeClass("is-loading").addClass("is-ready"),t.data.call&&t.data())},s.prototype._onError=function(){var t=this;this.$notice.text(this.opts.errorNotice),this.$target.removeClass("is-loading").addClass("is-error"),this.detachNotice=setTimeout(function(){t.$notice.detach(),t.detachNotice=null},this.opts.errorDuration)},s.prototype._loadImage=function(t,e){var i=new Image;this.$target.addClass("is-loading").append(this.$notice.text(this.opts.loadingNotice)),this.$zoom=o(i).on("error",o.proxy(this._onError,this)).on("load",e,o.proxy(this._onLoad,this)),i.style.position="absolute",i.src=t},s.prototype._move=function(t){if(0===t.type.indexOf("touch")){var e=t.touches||t.originalEvent.touches;u=e[0].pageX,f=e[0].pageY}else u=t.pageX||u,f=t.pageY||f;var i=this.$target.offset(),o=u-i.left,s=f-i.top,h=Math.ceil(o*d),n=Math.ceil(s*p);if(h<0||n<0||c<h||l<n)this.hide();else{var a=-1*n,r=-1*h;this.$zoom.css({top:a,left:r}),this.opts.onMove.call(this,a,r)}},s.prototype.hide=function(){this.isOpen&&!1!==this.opts.beforeHide.call(this)&&(this.$flyout.detach(),this.isOpen=!1,this.opts.onHide.call(this))},s.prototype.swap=function(t,e,i){this.hide(),this.isReady=!1,this.detachNotice&&clearTimeout(this.detachNotice),this.$notice.parent().length&&this.$notice.detach(),this.$target.removeClass("is-loading is-ready is-error"),this.$image.attr({src:t,srcset:o.isArray(i)?i.join():i}),this.$link.attr(this.opts.linkAttribute,e)},s.prototype.teardown=function(){this.hide(),this.$target.off(".easyzoom").removeClass("is-loading is-ready is-error"),this.detachNotice&&clearTimeout(this.detachNotice),delete this.$link,delete this.$zoom,delete this.$image,delete this.$notice,delete this.$flyout,delete this.isOpen,delete this.isReady},o.fn.easyZoom=function(e){return this.each(function(){var t=o.data(this,"easyZoom");t?void 0===t.isOpen&&t._init():o.data(this,"easyZoom",new s(this,e))})},s});

if (typeof $.fn.easyZoom !== "undefined" ) {
//   if ( typeof window.orientation == "undefined" && navigator.userAgent.indexOf('IEMobile') === -1 ) { // mobile / tablet device
    $('.easyzoom').easyZoom();
//   }
}


/* product calculators */
if (shopifyProduct.type.indexOf("Fabric") !== -1) {
  calculatorFabric();
} else if (shopifyProduct.type.indexOf("Curtains-RM-Eyelet") !== -1) {
  calculatorRmEyelet();
} else if (shopifyProduct.type.indexOf("Curtains-RM-PencilPleat") !== -1) {
  calculatorRmPencilPleat();
} else if (shopifyProduct.type.indexOf("CurtainPole") !== -1) {
  calculatorCurtainPole();
} else if (shopifyProduct.type.indexOf("Tracks") !== -1) {
  calculatorTracks();
}

function calculatorFabric() {
  var roundByPurpose = function(value) {
    //     return $("#purpose").val()=="romanblinds" ? Math.ceil(value) : Math.round(value);
    return  Math.ceil(value);
  }

  var updateCalc = function() {
    var dropdownQuantity = parseInt($(".dropdown_quantity").text() || 0);
    var fabricWidth = parseInt($("#fabric_width").val() || 0);
    var patternRepeat = parseInt($("#pattern_repeat").val() || 0);

    var trackWidth = parseInt( $("#a").val() || 0 );
    var fullness = $("#purpose").val()=="romanblinds" ? 1 : $("#b").val();
    var drops = (100 * trackWidth * fullness / fabricWidth) / 100;
    drops = roundByPurpose(drops);
    var fullnessResult = drops * fabricWidth / trackWidth;
    fullnessResult = roundByPurpose(fullnessResult * 10) / 10;

    var finishedLength = parseInt($("#e").val() || 0);
    var hemSize = parseInt($("#f").val() || 0);
    var totalRepeat = Math.ceil( (finishedLength + hemSize) / patternRepeat );

    var meters = (totalRepeat * patternRepeat * drops) / 100;
    meters = roundByPurpose(meters * 10) / 10;
    meters = Math.ceil(meters);

    $("._width").text(trackWidth);
    $("._fullness").text(fullness);
    $("._drops").text(drops);
    $("._fullness2").text(fullnessResult);
    $("._hemSize").text(hemSize);
    $("._meters").text(meters);

    if (meters > dropdownQuantity) {
      $(".calculator_quantity_error").removeClass("hidden");
      $(".calculator_result").addClass("hidden");
    } else {
      $(".calculator_quantity_error").addClass("hidden");
      $(".calculator_result").removeClass("hidden");
    }

    $("input[name=quantity]").val(meters);
  }

  var  changePurpose = function() {
    var purpose = $("#purpose").val();
    switch (purpose) {
      case "romanblinds":
        $("#curtains_fullness").addClass("hidden");
        $(".curtains-label").addClass("hidden");
        $(".blinds-label").removeClass("hidden");
        break;
      case "curtains":
      default:
        $("#curtains_fullness").removeClass("hidden");
        $(".curtains-label").removeClass("hidden");
        $(".blinds-label").addClass("hidden");
    }
  }


  $('#b, #f').on('change', function(event){
    updateCalc();
  });

  $('#a, #e').on('input', function(event){
    updateCalc();
  });

  $(document).ready(function() {
    $("#b, #f").slider();

    $('#b, #f').on('change', function(event){
      updateCalc();
    });

    $('#a, #e').on('input', function(event){
      updateCalc();
    });

    $("#purpose").on("change", function() {
      changePurpose();
      updateCalc();
    });
    setTimeout(function(){
      updateCalc();
    }, 100)

  });
}

function calculatorRmEyelet() {
  $(".calculator-form").on("input", function(){
    var checked = document.querySelector('[name="units"]:checked');
    var unit_multiplier = parseFloat( $(checked).val() * 1 );
    var width = parseFloat( $("#width").val() * unit_multiplier ).toFixed(2);
    var drop = parseFloat( $("#drop").val() * unit_multiplier ).toFixed(2);
    var curtain_notes = "Note: This recommendation is for eyelet curtains only and is based on a fullness ratio of 1.5 times the pole width. For curtain drop we always round up (not down) to the nearest available size. This is to ensure your curtains sit below (not above) your finished length position.";

    if (width <= 85) {
      var curtain_width_drop = "The sizes you entered may require one of our made to measure options.";
      var curtain_size = "";
      var curtain_type = "";
    } else if (drop <= 115) {
      var curtain_width_drop = "The sizes you entered may require one of our made to measure options.";
      var curtain_size = "";
      var curtain_type = "";
    } else if (width <= 153.01 && drop <= 137.16) {
      var curtain_width_drop = "46 Wide, 54 Drop";
      var curtain_size = "If available, please choose the 46x54 option";
      var curtain_type = curtain_notes;
    } else if (width <= 153.01 && drop <= 182.88) {
      var curtain_width_drop = "46 Wide, 72 Drop";
      var curtain_size = "If available, please choose the 46x72 option";
      var curtain_type = curtain_notes;
    } else if (width <= 153.01 && drop <= 228.6) {
      var curtain_width_drop = "46 Wide, 90 Drop";
      var curtain_size = "If available, please choose the 46x90 option";
      var curtain_type = curtain_notes;
    } else if (width <= 153.01 && drop <= 274.32) {
      var curtain_width_drop = "46 Wide, 108 Drop";
      var curtain_size = "If available, please choose the 46x108 option";
      var curtain_type = curtain_notes;
    } else if (width <= 221.01 && drop <= 137.16) {
      var curtain_width_drop = "66 Wide, 54 Drop";
      var curtain_size = "If available, please choose the 66x54 option";
      var curtain_type = curtain_notes;
    } else if (width <= 221.01 && drop <= 182.88) {
      var curtain_width_drop = "66 Wide, 72 Drop";
      var curtain_size = "If available, please choose the 66x72 option";
      var curtain_type = curtain_notes;
    } else if (width <= 221.01 && drop <= 228.6) {
      var curtain_width_drop = "66 Wide, 90 Drop";
      var curtain_size = "If available, please choose the 66x90 option";
      var curtain_type = curtain_notes;
    } else if (width <= 221.01 && drop <= 274.32) {
      var curtain_width_drop = "66 Wide, 108 Drop";
      var curtain_size = "If available, please choose the 66x108 option";
      var curtain_type = curtain_notes;
    } else if (width <= 300 && drop <= 137.16) {
      var curtain_width_drop = "90 Wide, 54 Drop";
      var curtain_size = "If available, please choose the 90x54 option";
      var curtain_type = curtain_notes;
    } else if (width <= 300 && drop <= 182.88) {
      var curtain_width_drop = "90 Wide, 72 Drop";
      var curtain_size = "If available, please choose the 90x72 option";
      var curtain_type = curtain_notes;
    } else if (width <= 300 && drop <= 228.6) {
      var curtain_width_drop = "90 Wide, 90 Drop";
      var curtain_size = "If available, please choose the 90x90 option";
      var curtain_type = curtain_notes;
    } else if (width <= 300 && drop <= 274.32) {
      var curtain_width_drop = "90 Wide, 108 Drop";
      var curtain_size = "If available, please choose the 90x108 option";
      var curtain_type = curtain_notes;
    }  else if (width > 300 || drop > 274.32 ) {
      var curtain_width_drop = "The sizes you entered may require one of our made to measure options.";
      var curtain_size = "";
      var curtain_type = "";
    } else {
      var curtain_width_drop = "The sizes you entered may require one of our made to measure options.";
      var curtain_size = "";
      var curtain_type = "";
    }

    $("._curtain_width_drop").text(curtain_width_drop);
    $("._curtain_size").text(curtain_size);
    $("._curtain_type").text(curtain_type);
  });
}

function calculatorRmPencilPleat() {

  $(".calculator-form").on("input", function(){
    var checked = document.querySelector('[name="units"]:checked');
    var unit_multiplier = parseFloat( $(checked).val() * 1 );
    var width = parseFloat( $("#width").val() * unit_multiplier ).toFixed(2);
    var drop = parseFloat( $("#drop").val() * unit_multiplier ).toFixed(2);
    var curtain_notes = "Note: This recommendation is for pencil pleat curtains only and is based on a fullness ratio of double the rail width. For curtain drop we always round up (not down) to the nearest available size. This is to ensure your curtains sit below (not above) your finished length position.";

    if (width <= 65) {
      var curtain_width_drop = "The sizes you entered may require one of our made to measure options.";
      var curtain_size = "";
      var curtain_type = "";
    } else if (drop <= 115) {
      var curtain_width_drop = "The sizes you entered may require one of our made to measure options.";
      var curtain_size = "";
      var curtain_type = "";
    } else if (width <= 124.01 && drop <= 137.16) {
      var curtain_width_drop = "46 Wide, 54 Drop";
      var curtain_size = "If available, please choose the 46x54 option";
      var curtain_type = curtain_notes;
    } else if (width <= 124.01 && drop <= 182.88) {
      var curtain_width_drop = "46 Wide, 72 drop";
      var curtain_size = "If available, please choose the 46x72 option";
      var curtain_type = curtain_notes;
    } else if (width <= 124.01 && drop <= 228.6) {
      var curtain_width_drop = "46 Wide, 90 drop";
      var curtain_size = "If available, please choose the 46x90 option";
      var curtain_type = curtain_notes;
    } else if (width <= 124.01 && drop <= 274.32) {
      var curtain_width_drop = "46 Wide, 108 drop";
      var curtain_size = "If available, please choose the 46x108 option";
      var curtain_type = curtain_notes;
    } else if (width <= 175.01 && drop <= 137.16) {
      var curtain_width_drop = "66 Wide, 54 drop";
      var curtain_size = "If available, please choose the 66x54 option";
      var curtain_type = curtain_notes;
    } else if (width <= 175.01 && drop <= 182.88) {
      var curtain_width_drop = "66 Wide, 72 drop";
      var curtain_size = "If available, please choose the 66x72 option";
      var curtain_type = curtain_notes;
    } else if (width <= 175.01 && drop <= 228.6) {
      var curtain_width_drop = "66 Wide, 90 drop";
      var curtain_size = "If available, please choose the 66x90 option";
      var curtain_type = curtain_notes;
    } else if (width <= 175.01 && drop <= 274.32) {
      var curtain_width_drop = "66 Wide, 108 drop";
      var curtain_size = "If available, please choose the 66x108 option";
      var curtain_type = curtain_notes;
    } else if (width <= 240 && drop <= 137.16) {
      var curtain_width_drop = "90 Wide, 54 drop";
      var curtain_size = "If available, please choose the 90x54 option";
      var curtain_type = curtain_notes;
    } else if (width <= 240 && drop <= 182.88) {
      var curtain_width_drop = "90 Wide, 72 drop";
      var curtain_size = "If available, please choose the 90x72 option";
      var curtain_type = curtain_notes;
    } else if (width <= 240 && drop <= 228.6) {
      var curtain_width_drop = "90 Wide, 90 drop";
      var curtain_size = "If available, please choose the 90x90 option";
      var curtain_type = curtain_notes;
    } else if (width <= 240 && drop <= 274.32) {
      var curtain_width_drop = "90 Wide, 108 drop";
      var curtain_size = "If available, please choose the 90x108 option";
      var curtain_type = curtain_notes;
    } else if (width > 240 || drop > 274.32 ) {
      var curtain_width_drop = "The sizes you entered may require one of our made to measure options.";
      var curtain_size = "";
      var curtain_type = "";
    } else {
      var curtain_width_drop = "The sizes you entered may require one of our made to measure options.";
      var curtain_size = "";
      var curtain_type = "";
    }

    $("._curtain_width_drop").text(curtain_width_drop);
    $("._curtain_size").text(curtain_size);
    $("._curtain_type").text(curtain_type);
  });
}

function calculatorCurtainPole() {
  $(".calculator-form").on("input", function(){
    var poles_checked = document.querySelector('[name="poleunits"]:checked');
    var poles_unit = parseFloat( $(poles_checked).val() * 1 );
    var pole_width = parseFloat( $("#polewidth").val() * poles_unit ).toFixed(2);
    var pole_notes = "Note: If the size suggested isn't available, then please opt for the next biggest size, as longer poles can be shortened to fit your window measurements. Also, should this pole come in two halves, then please shorten each piece by an equal amount on the outer edges.";


    if (pole_width <= 90) {
      var pole_size = "If available, please choose the 120cm option";
      var pole_notes = pole_notes;
      var pole_overhang = 15;
      var pole_trim = 120 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else if (pole_width <= 95 ) {
      var pole_size = "If available, please choose the 125cm option";
      var pole_notes = pole_notes;
      var pole_overhang = 15;
      var pole_trim = 125 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else if (pole_width <= 120 ) {
      var pole_size = "If available, please choose the 150cm option";
      var pole_notes = pole_notes;
      var pole_overhang = 15;
      var pole_trim = 150 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else if (pole_width <= 140) {
      var pole_size = "If available, please choose the 180cm option";
      var pole_notes = pole_notes;
      var pole_overhang = 20;
      var pole_trim = 180 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else if (pole_width <= 160 ) {
      var pole_size = "If available, please choose the 200cm option.";
      var pole_notes = pole_notes;
      var pole_overhang = 20;
      var pole_trim = 200 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else if (pole_width <= 200 ) {
      var pole_size = "If available, please choose the 240cm option";
      var pole_notes = pole_notes;
      var pole_overhang = 20;
      var pole_trim = 240 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else if (pole_width <= 210 ) {
      var pole_size = "If available, please choose the 250cm option";
      var pole_notes = pole_notes;
      var pole_overhang = 20;
      var pole_trim = 250 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else if (pole_width <= 260 ) {
      var pole_size = "If available, please choose the 300cm option";
      var pole_notes = pole_notes;
      var pole_overhang = 20;
      var pole_trim = 300 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else if (pole_width <= 310 ) {
      var pole_size = "If available, please choose the 360cm option";
      var pole_notes = pole_notes;
      var pole_overhang = 25;
      var pole_trim = 360 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else if (pole_width <= 350 ) {
      var pole_size = "If available, please choose the 400cm option";
      var pole_notes = pole_notes;
      var pole_overhang = 25;
      var pole_trim = 400 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else if (pole_width <= 370 ) {
      var pole_size = "If available, please choose the 420cm option";
      var pole_notes = pole_notes;
      var pole_overhang = 25;
      var pole_trim = 420 - pole_overhang - pole_overhang - pole_width;
      var pole_trim = pole_trim.toFixed(1);
    } else {
      var pole_size = "The sizes you entered, do not currently match an available size for our curtain poles.";
      var pole_notes = "";
      var pole_trim = "0";
    }

    if (pole_trim >= 1) {
      var pole_trim_suggestion = "This is based on the measurements you entered plus ".concat(pole_overhang).concat("cm added to either side of the pole, for your curtains to be drawn back. You may still need to shorten this pole by ").concat(pole_trim).concat("cm");
    }
    else if (pole_width > 370 ) {
      var pole_trim_suggestion = "";
    }
    else {
      var pole_trim_suggestion = "This is based on the measurements you entered plus ".concat(pole_overhang).concat("cm added to either side of the pole, for your curtains to be drawn back.");
    }

    $("._pole_size").text(pole_size);
    $("._pole_notes").text(pole_notes);
    $("._pole_trim_suggestion").text(pole_trim_suggestion);
  });
}

function calculatorTracks() {
  $(".calculator-form").on("input", function(){
    var tracks_checked = document.querySelector('[name="trackunits"]:checked');
    var tracks_unit = parseFloat( $(tracks_checked).val() * 1 );
    var track_width = parseFloat( $("#trackwidth").val() * tracks_unit ).toFixed(2);
    var track_notes = "Note: If the size suggested isn't available, then please opt for the next biggest size, as longer tracks can be shortened to fit your window measurements. Also, should this track come in two halves, then please shorten each piece by an equal amount on the outer edges.";


    if (track_width <= 90) {
      var track_size = "If available, please choose the 120cm option";
      var track_notes = track_notes;
      var track_overhang = 15;
      var track_trim = 120 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 95 ) {
      var track_size = "If available, please choose the 125cm option";
      var track_notes = track_notes;
      var track_overhang = 15;
      var track_trim = 125 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 120 ) {
      var track_size = "If available, please choose the 150cm option";
      var track_notes = track_notes;
      var track_overhang = 15;
      var track_trim = 150 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 145) {
      var track_size = "If available, please choose the 175cm option";
      var track_notes = track_notes;
      var track_overhang = 15;
      var track_trim = 175 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 150) {
      var track_size = "If available, please choose the 180cm option";
      var track_notes = track_notes;
      var track_overhang = 15;
      var track_trim = 180 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 160 ) {
      var track_size = "If available, please choose the 200cm option";
      var track_notes = track_notes;
      var track_overhang = 20;
      var track_trim = 200 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 170 ) {
      var track_size = "If available, please choose the 210cm option";
      var track_notes = track_notes;
      var track_overhang = 20;
      var track_trim = 210 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 185 ) {
      var track_size = "If available, please choose the 225cm option";
      var track_notes = track_notes;
      var track_overhang = 20;
      var track_trim = 225 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 200 ) {
      var track_size = "If available, please choose the 240cm option";
      var track_notes = track_notes;
      var track_overhang = 20;
      var track_trim = 240 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 210 ) {
      var track_size = "If available, please choose the 250cm option";
      var track_notes = track_notes;
      var track_overhang = 20;
      var track_trim = 250 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 230 ) {
      var track_size = "If available, please choose the 270cm option";
      var track_notes = track_notes;
      var track_overhang = 20;
      var track_trim = 270 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 235 ) {
      var track_size = "If available, please choose the 275cm option";
      var track_notes = track_notes;
      var track_overhang = 20;
      var track_trim = 275 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 260 ) {
      var track_size = "If available, please choose the 300cm option";
      var track_notes = track_notes;
      var track_overhang = 20;
      var track_trim = 300 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 310 ) {
      var track_size = "If available, please choose the 350cm option";
      var track_notes = track_notes;
      var track_overhang = 20;
      var track_trim = 350 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 350 ) {
      var track_size = "If available, please choose the 400cm option";
      var track_notes = track_notes;
      var track_overhang = 25;
      var track_trim = 400 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else if (track_width <= 450 ) {
      var track_size = "If available, please choose the 500cm option";
      var track_notes = track_notes;
      var track_overhang = 25;
      var track_trim = 500 - track_overhang - track_overhang - track_width;
      var track_trim = track_trim.toFixed(1);
    } else {
      var track_size = "The sizes you entered, do not currently match an available size for our curtain tracks.";
      var track_notes = "";
      var track_trim = "0";
    }

    if (track_trim >= 1) {
      var track_trim_suggestion = "This is based on the measurements you entered plus ".concat(track_overhang).concat("cm added to either side of the track, for your curtains to be drawn back. You may still need to shorten this track by ").concat(track_trim).concat("cm");
    }
    else if (track_width > 450 ) {
      var track_trim_suggestion = "";
    }
    else {
      var track_trim_suggestion = "This is based on the measurements you entered plus ".concat(track_overhang).concat("cm added to either side of the track, for your curtains to be drawn back.");
    }

    $("._track_size").text(track_size);
    $("._track_notes").text(track_notes);
    $("._track_trim_suggestion").text(track_trim_suggestion);
  });
}
/* end product calculators */

/* price match function */
function placeOption(obj) {
  var value = obj.value;
  if (value == "Choose option") {
    return;
  }
  var productDetailsElement = document.getElementById("ContactFormProduct");
  var productDetailsValue = productDetailsElement.value;
  productDetailsValue = productDetailsValue.substring(0, productDetailsValue.lastIndexOf(": ") + 2) + value;
  productDetailsElement.value = productDetailsValue;
}
$(document).ready(function(){
  $("#PriceMatchSubmit").on("click", function(){

    $(".price-match-error-message").addClass("hidden");
    var valid = true;

    var selectedProduct = $("#PriceMatchVariant option:selected:not([disabled])").text();
    if (!selectedProduct.length) {
      valid = false;
      $(".error-variant").removeClass("hidden");
    }

    var selectedQuantity = $("#PriceMatchQuantity option:selected:not([disabled])").text();
    if (!selectedQuantity.length) {
      valid = false;
      $(".error-quantity").removeClass("hidden");
    }

    var competitorLink = $("#ContactFormCompetitor").val();
    if (!competitorLink.length) {
      valid = false;
      $(".error-competitor").removeClass("hidden");
    }

    var customerEmail = $("#ContactFormEmail").val();
    var re = /\S+@\S+\.\S+/;
    if (!customerEmail.length || !re.test(customerEmail)) {
      valid = false;
      $(".error-customer-email").removeClass("hidden");
    }

    var customerMessage = $("#ContactFormMessage").val();
    if (!customerMessage.length) {
      valid = false;
      $(".error-customer-message").removeClass("hidden");
    }

    if (!valid) {
      return;
    }

    var product = selectedProduct + " - Quantity: " + selectedQuantity;
    var data = {
      email: $("#ContactFormEmail").val(),
      subject: "Price match for: " + $("#ContactFormProductTitle").val(),
      body: product + "<br/><br/>" + "Competitor link: " + competitorLink + "<br/><br/>" + $("#ContactFormMessage").val()
    };
    $.ajax({
      url: `${wsBaseApiUrl}/freshdesk`,
      type: "post",
      data: data,
      beforeSend: function(){
        $("#PriceMatchSubmit, .success-message, .error-message").addClass("hidden");
        $(".loader").removeClass("hidden");
      },
      success: function(){
        $("#PriceMatchForm, .loader, .error-message").addClass("hidden");
        $(".success-message").removeClass("hidden");
      },
      error: function(xhr, text){
        console.log('xhr: ' + xhr.responseText + '  ||  ' + text);
        $("#PriceMatchSubmit, .loader, .success-message").addClass("hidden");
        $(".error-message").removeClass("hidden");
        setTimeout(function(){
          $(".loader, .success-message, .error-message").addClass("hidden");
          $("#PriceMatchSubmit").removeClass("hidden");
        }, 1000);
      }
    });
  });
});
/* end price match function */

/* ekomi-reviews */
var Reviews = {

  productId: null,

  ui: {},

  initialize: function() {
    if (document.querySelector('.review-cap') === null) {
      //no reviews, no need to query
      return;
    }
    this.productId = shopifyProduct.id;
    this.setInteractiveElements();
    this.renderReviews();
  },

  setInteractiveElements: function() {
    this.ui.noReviewsTitle = $(".spr-summary");
    this.ui.reviewsContainer = $(".spr-reviews");
    this.ui.reviewSummary = $(".review-summary");
    this.ui.reviewSummary2 = $(".js-reviews-header");
    this.ui.reviewsTab = $(".js-reviews-tab");
  },

  renderReviews: function() {
    var that = this,
        label = "review";
    that.loadReviewsData().then( function( result ) {
      // that.renderReviewsItems( result.reviews );
      // that.renderSummaryCaption( result );
      that.renderStructuredData( result.reviews );
    });
  },

  renderReviewsItems: function( reviews ) {
    var i;
    for( i in reviews ) {
      this.ui.reviewsContainer.append( this.reviewItemTemplate( reviews[i] ) );
    }
    if( !i ) {
      this.ui.noReviewsTitle.removeClass("hidden").show();
    }
  },

  loadReviewsData: function() {
    return $.getJSON(`${wsBaseApiUrl}/ekomi_review/` + this.productId);
  },

  scrollTo: function() {
    var hook = $("div.woocommerce-tabs");

    $("a[href='#product-reviews']").click();
    $("html, body").animate({
      scrollTop: hook.offset().top - 100
    }, 1000, 'swing');
  },

  renderSummaryCaption: function( data ) {
    var reviewsNumber = parseInt( data.reviews_number, 10),
        reviewsRate = parseFloat( data.average_rate),
        label, template, i, target, type;

    if( this.ui.reviewSummary.length != 0 ) {
      target = this.ui.reviewSummary;
      type = "m2m";
    } else if( this.ui.reviewSummary2.length != 0 ) {
      target = this.ui.reviewSummary2;
      type = "variant";
    } else {
      return;
    }

    if( reviewsNumber === 0 || reviewsRate <= 3) {
      this.ui.reviewsTab.hide();
      template = '<span>&nbsp;</span>';
      target.closest('.PopupBtn_Pointer').removeAttr('onclick');
      target.closest('.product-page-reviews').addClass('no-review');
    } else {
      template = this.generateTemplate( data, type );
    }

    var jQtemplate = $( template );
    target.empty().append( jQtemplate );
    jQtemplate.find(".scroll-to").on("click", this.scrollTo );

  },

  generateTemplate: function( data, type ) {
    var template, label,
        reviewsNumber = parseInt( data.reviews_number, 10);

    if( reviewsNumber == 1 ) {
      label = reviewsNumber + " " + "review";
    } else {
      label = reviewsNumber + " " + "reviews";
    }

    if(type == "m2m") {
      template = '<span class="spr-badge" id="spr_badge_' + shopifyProduct.id + '" data-rating="' + data.average_rate +'">' +
          '<span class="spr-starrating spr-badge-starrating">';
      for( i = 1 ; i <= 5 ; ++i ) {
        template += this.renderStarItem( data.average_rate, i );
      }
      template += '</span>' +
          '<span class="spr-badge-caption">' + label + '</span>' +
          '</span>';
    } else if( type == "variant" ) {
      template = '<span>';

      for( i = 1 ; i <= 5 ; ++i ) {
        template += this.renderStarItem( data.average_rate, i );
      }

      template += '</span>' +
          '<span class="rating-number">' + label + '</span>';

    }

    return template;
  },

  renderStarItem: function( rate, starNumber ) {
    if( rate >= starNumber ) {
      return '<i aria-hidden="true" class="tfa tfa-star"></i>';
    }
    var diff = ( starNumber - parseFloat(rate) ) * 10;
    

    if( diff % 10 !== 0 ) {
      return '<i aria-hidden="true" class="tfa tfa-star-half-o"></i>';
    } else {
      return '<i aria-hidden="true" class="tfa tfa-star-o"></i>';
    }
  },

  reviewItemTemplate: function( reviewDetails ) {
    if(reviewDetails.review == null) {
      reviewDetails.review = reviewDetails.rating + " stars";
    }
    
    var i,
        template = '<div class="spr-review">' +
            '<div class="spr-review-header">' +
            '<span class="spr-starratings spr-review-header-starratings" style="color: #a4ba19; margin-right: 15px;">';

    for( i = 0; i < reviewDetails.rating; ++i ) {
      template += '<i class="tfa tfa-star" style=""></i>';
    }
    template += '</span>' +
        '<span class="spr-review-header-byline">Reviewed on: <strong>' + reviewDetails.date_reviewed + '</strong></span>' +
        '</div>' +
        '<div class="spr-review-content">' +
        '<p class="spr-review-content-body-bigger">' + reviewDetails.review + '</p>' +
        '</div></div>';
    return template;
  },

  renderStructuredData: function(reviews) {
    if (reviews.length == 0) {
      return;
    }
    var struDataElement = document.querySelector('script[type="application/ld+json"]');
    var struDataText = struDataElement.innerText.trim();
    var struReviews = [];
    for( i in reviews ) {
      var reviewItem = reviews[i];
      var userName = reviewItem.user_name;
      if (userName.trim().length == 0) {
        userName = 'anonymous';
      }
      var struReviewItem= {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": userName,
        },
        "datePublished": reviewItem.date_published,
        "reviewBody": reviewItem.review,
        // "name": "product",
        "reviewRating": {
          "@type": "Rating",
          "bestRating": "5",
          "ratingValue": reviewItem.rating,
          "worstRating": "1"
        }
      }
      struReviews.push(struReviewItem);
    }

    var struReviewsObj = {"review": struReviews};
    var struReviewsJson = JSON.stringify(struReviewsObj);
    var struReviewsJsonPrepared = struReviewsJson.slice(1, -1); //remove curly parentheses from start and end
    struDataText = struDataText.slice(0, -1); //remove last character - '}'
    struDataText += ',' + struReviewsJsonPrepared + '}';

    // struDataElement.innerText  = struDataText;
    struDataElement.textContent  = struDataText;
  }

};

$(function() {
  Reviews.initialize();
});
/* end ekomi-reviews */





/* colour choices */
if (availableColoursTemplate.toLowerCase() == "on") {
  var Colours = {

    sku: null,

    ui: {},

    initialize: function() {
      this.sku = shopifyProduct.sku;
      this.setInteractiveElements();
      this.renderColours();
    },

    setInteractiveElements: function() {
      this.ui.colourChoicesContainer = $(".colour-choices-container:not(.klevu-recs-container)");
      this.ui.coloursContainer = $(".other-colours");
    },

    renderColours: function() {
      var that=this;
      that.loadColoursData().then( function(result) {
        that.renderColourItems(result);
      }).then( function(){
        var carouselOptions = {
          responsiveClass:true,
          responsive:{
            0:{
              items:2,
            },
            568:{
              items:3,
            },
            768:{
              items:4,
            },
            992:{
              items:3,
            },
            1200:{
              items:3,
            }
          },
          nav: false,
          dots: false,
          rewind: false,

        };
        var autoplayOptions = {
          loop:true,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true
        };
        
        var itemsCount = that.ui.coloursContainer.find(".other-item").length;
        if (itemsCount > 2) {
          $.extend(carouselOptions.responsive["0"], autoplayOptions);
        }
        if (itemsCount > 3) {
          $.extend(carouselOptions.responsive["568"], autoplayOptions);
        }
        if (itemsCount > 4) {
          $.extend(carouselOptions.responsive["768"], autoplayOptions);
        }
        if (itemsCount > 5) {
          $.extend(carouselOptions.responsive["992"], autoplayOptions);
        }
        if (itemsCount > 6) {
          $.extend(carouselOptions.responsive["1200"], autoplayOptions);
        }
        
        $('.other-colours').owlCarousel(carouselOptions);
        
      });
    },

    loadColoursData: function() {
      return $.getJSON(`${wsBaseApiUrl}/colour_choice/` + this.sku);
    },

    renderColourItems: function(colours) {
      var i;
      for( i in colours ) {
        this.ui.coloursContainer.append( this.colourItemTemplate( colours[i] ) );
      }
      if( !i ) {
        this.ui.colourChoicesContainer.addClass("hidden");
        $(".klevu-recs-container").removeClass("col-md-6").addClass("klevu-recs-full");
        $(".kcResultsInner").addClass("owl-carousel");
      }
    },

    colourItemTemplate: function(item) {
      var item_img200x = item.image.replace(/\.([^\.]*)$/, "_200x."+"$1"),
          item_url = item.url.replace(/\?variant=\d+$/, "");

      var template = '<div class="other-item">' +
          '<div class="product-content">' +
          '<div class="product-image">' +
          '<a href="'+item_url+'" style="background-image: url(\''+item_img200x+'\')">' +
          '</a>' +
          '</div>' +
          '<div class="product-attribute" style="text-align:center; background-color:#f6f6f6;">' +
          '<div class="available-colours-title">' +
          '<a href="'+item_url+'">'+item.title+'</a>' +
          '</div>' +
//           '<div class="product-price">' +
//           '<span class="amout" style="font-size:15px;">' +
//           '<a href="'+item_url+'">' +
//           '<span>From £'+item.price+'</span>' +
//           '</a>' +
//           '</span>' +
//           '</div>' +
          '</div>' +
          '</div>' +

          '</div>';

      var image = new Image();
      image.src = item_img200x;
      image.onload = function() {
        // image exists and is loaded, so nothing to do here
      }
      image.onerror = function() {
        // image did not load, replace src to original
        $('img[src="' + item_img200x + '"]').attr('src', item.image);
      }

      return template;
    }

  };

  $(function() {
    Colours.initialize();
  });

}
/* end colour choices */



/* additional links */
$(document).ready(function(){
  $(".tab-scroll").on("click", function(e){
    e.preventDefault();
    var target = $("a[href='" + $(this).attr("data-target") + "']");
    target.tab("show");
    $('html, body').animate({ scrollTop: target.offset().top}, 1000);
    history.pushState(null, null, $(this).attr("href"));
  });
});
/* end additional links */



function hideAllDeliverySections() {
  $(".section_next_day").addClass("hidden");
  $(".section_pre_order").addClass("hidden");
  $(".section_lead_time").addClass("hidden");
  $(".section_unavailable").addClass("hidden");
  $("#preorder-advice-property").attr("disabled", "disabled");
}




// JS Delivery Date Stuff
var usable_dates = [];
var bank_holidays = next_day_variables.bank_holidays;
var delivery_delay = next_day_variables.delivery_delays;
const day = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

var increaseNextDay = parseInt($(".section-increase-next-day").text()) || 0;
if (increaseNextDay) {
  delivery_delay += 2;
}

function create_dates() {
  var today = new Date();
  //today.setDate(today.getDate() - 4);
  //today.setHours(15);

  // Creating an array of weekdays, starting from the next day
  
  var temp_index = 1;
  
  for(i=0;i<50;i++) {
    var temp_date = new Date();
    temp_date.setDate(today.getDate() + temp_index);
    if(temp_date.getDay() == 6) {
      temp_date.setDate(temp_date.getDate() + 2);
      temp_index = temp_index + 2;
    }
    if(temp_date.getDay() == 0) {
      temp_date.setDate(temp_date.getDate() + 1);
      temp_index = temp_index + 1;
    }
    usable_dates.push(temp_date);
    temp_index = temp_index + 1;
  }

  // Restructuring the bank holidays array
  var temp_bank_holidays;
    temp_bank_holidays = bank_holidays.split("|");
    for(i=0;i<temp_bank_holidays.length;i++) {
        if(temp_bank_holidays[i] == "") {
            temp_bank_holidays.splice(i,1);
        }
    }
    bank_holidays = temp_bank_holidays;
  
  // Removing the bank holidays from the usable_dates array 
  for(z=0;z<bank_holidays.length;z++) {
    for(i=0;i<usable_dates.length;i++) {
      var a = bank_holidays[z];
      a = a.split('/').reverse().join('/');
      a = new Date(a);
      if(usable_dates[i].getDate() == a.getDate() && usable_dates[i].getMonth() == a.getMonth() && usable_dates[i].getFullYear() == a.getFullYear()) {
        usable_dates.splice(i, 1);
        break;
      }
    }
  }
  
  // Adding the delivery delay to the usable_dates array (removing elements)
  
  if(delivery_delay > 0) {
    usable_dates.splice(0, delivery_delay);
  }
  
  if(today.getDay() == 6 || today.getDay() == 0 || today.getHours() >= 15) {
    usable_dates.splice(0, 1);
  }
}

const nth = function(d) {
  // getOrdinalSuffix
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:  return "st";
    case 2:  return "nd";
    case 3:  return "rd";
    default: return "th";
  }
};

create_dates();

var dateToDisplay = day[usable_dates[0].getDay()] + " " + usable_dates[0].getDate() + nth(usable_dates[0].getDate()) + " " + month[usable_dates[0].getMonth()];
if(document.getElementById("next_day_date")) {
  document.getElementById("next_day_date").innerHTML = dateToDisplay;
}
if(document.getElementById("next_day_date_popup")) {
  document.getElementById("next_day_date_popup").innerHTML = dateToDisplay;
}


/* product with variants */
if (buyingOptionsVariantTemplate.toLowerCase() == "on") {

  var initialCartButtonText = $(".add .btn-addtocart-b").html();

  var changeVariant = function() {
    var values = document.getElementById('variants-list').value.split('|');
    var optVariantId         = values[0]; // {{variant.id}}
    var optRrp               = values[1]; // {%- if VariantCompare == "£0.00" -%}£££{%- else -%}{{VariantCompare}}{% endif %}
    var optPrice             = values[2]; // {{VariantPrice}}
    var optInStock           = parseInt(values[3]); // {{VariantOurStock}}
    var optMaxQuantity       = parseInt(values[4]); // {{TotalStock}}
    var optIncomingTimestamp = parseInt(values[5]); // {{IncomingTimestamp}} Stock Due Date
    var optPreOrderStock     = values[6]; // {{PreOrderStock}} Stock for pre order, set in StockRules-Variant
    var optSku               = values[7];
    var optIsAccessory       = typeof(values[8])!=='undefined' && values[8] == 'accessory';
    var deliveryMessage = "";
    var optInitialStock = optMaxQuantity - optPreOrderStock;

    // Dynamic discount percentage (percentage on inside of discount circle changes when a different variant is selected)
    // console.log("RRP: " + optRrp);
    // temporarily disabled
    /*
    if(optRrp == "£££") {
      $("#image_discount_circle").hide();
    } else {
      $("#image_discount_circle").show();
      if(optRrp.includes("£") && optPrice.includes("£")) {
        if(optRrp.includes("££") == false) {
          var float_price = optPrice.replace("£", "");
          var float_rrp = optRrp.replace("£", "");
      
          float_price = parseFloat(float_price);
          float_rrp = parseFloat(float_rrp);
          
          var discount = float_price / float_rrp;
  
          discount = discount * 100;
          discount = 100 - discount;
          discount = Math.floor(discount);
          discount = (discount).toFixed(0);
          
          if(isNaN(discount) == false) {
            $("#discount-from-price").text(discount + "%");
          }
        }
      }
    }
    */

    var currentTimeStamp = parseInt(Date.now()/1000);
    var cutOffTimeStamp = currentTimeStamp + 2419200; // + 4 weeks
    var dateFromIncomingDateTimestamp = new Date(optIncomingTimestamp * 1000);
    var incomingDate = dateFromIncomingDateTimestamp.toLocaleDateString('en-GB');
    var currentDate = new Date().toLocaleDateString('en-GB');
    var incomingDateDate = dateFromIncomingDateTimestamp.getDate();
    incomingDateDate += nth(incomingDateDate) + " " + dateFromIncomingDateTimestamp.toLocaleDateString('en-GB', {'month':'short'});

    var wasPriceElement = document.getElementById("was-price");
    
    document.getElementById('mobile-variant-id').value = optVariantId; // variantid
    wasPriceElement.innerHTML = optRrp; // rrp
    
    if (optRrp == '£££') {
      wasPriceElement.parentNode.classList.add("hidden");
    } else {
      wasPriceElement.parentNode.classList.remove("hidden");
    }
      
    document.getElementById("now-price").innerHTML = optPrice; // price
    document.getElementById("price_in_3").innerHTML = "£" + (Math.floor(optPrice.replace(/\u00A3/g, '') / 3 * 100) / 100).toFixed(2); // Klarna price in 3

    var vipPrice = document.querySelector(".klarna_accent .vip-price");
    if (vipPrice != null) {
      vipPrice.innerHTML = "£" + (Math.floor(optPrice.replace(/\u00A3/g, '') * 100) / 100).toFixed(2);
    }

    var vipPriceBaner = document.querySelector(".banner-product-vip");
    if (vipPriceBaner != null) {
      if (typeof(optSku) != 'undefined') {
        vipPriceBaner.style.visibility = "visible";
      } else {
        vipPriceBaner.style.visibility = "hidden";
      }
    }
    
    $(".stock_due_date").text(incomingDateDate);

    if (optMaxQuantity > 10) {
      document.getElementById("in-stock").innerHTML = parseInt(optMaxQuantity)>0 ? ('<i class="tfa tfa-check" aria-hidden="true"></i> 10+ In Stock') : (' ');
    } else {
      document.getElementById("in-stock").innerHTML = parseInt(optMaxQuantity)>0 ? ('<i class="tfa tfa-check" aria-hidden="true"></i>' + parseInt(optMaxQuantity) + ' In Stock') : (' ');
    }

    document.getElementById("max-quantity").value = optMaxQuantity;

    // if (optInStock > 0) {
    //   $(".delivery_box_no_border.lower").show();
    //   $(".delivery_box_no_border.upper").hide();
    // } else {
    //   $(".delivery_box_no_border.upper").show();
    //   $(".delivery_box_no_border.lower").hide();
    // }

    hideAllDeliverySections();
    $(".add .quantity, .add .btn-addtocart-b").removeClass("hidden").removeAttr("disabled", "disabled");
    if (optInStock > 0) {
      $("#tf_variant_price").removeClass("hidden");
      $(".buying-options-variant-btn .section_next_day").removeClass("hidden");
    } else if (optMaxQuantity > 0 && optPreOrderStock == 0) {
      $("#tf_variant_price").removeClass("hidden");
      $(".buying-options-variant-btn .section_lead_time").removeClass("hidden");
    } else if (optIncomingTimestamp > currentTimeStamp && optIncomingTimestamp < cutOffTimeStamp) {
      $("#tf_variant_price").removeClass("hidden");
      $(".buying-options-variant-btn .section_pre_order").removeClass("hidden");
      $("#preorder-advice-property").removeAttr("disabled").val("This item has an estimated dispatch date of  " + incomingDateDate + ".");
    } else {
      $(".section_unavailable").removeClass("hidden");
      $("#tf_variant_price").addClass("hidden");
      $(".add .quantity, .add .btn-addtocart-b").addClass("hidden").attr("disabled", "disabled");
    }

    $("#Quantity.variant-quantity").off("change").on("change", function(){
      if ($(this).val() > optInStock) {
        hideAllDeliverySections();
        if (optIncomingTimestamp > currentTimeStamp && $(this).val() > optInitialStock) {
          $(".section_pre_order").removeClass("hidden");
          $("#preorder-advice-property").removeAttr("disabled").val("This item has an estimated dispatch date of  " + incomingDateDate + ".");
        } else {
          $(".section_lead_time").removeClass("hidden");
        }
        // $(".delivery_box_no_border.upper").show();
        // $(".delivery_box_no_border.lower").hide();
      } else {
        hideAllDeliverySections();
        $(".section_next_day").removeClass("hidden");
        // $(".delivery_box_no_border.lower").show();
        // $(".delivery_box_no_border.upper").hide();
      }
    });

    var replaceUrl = changeUrlParameter(window.location.href, 'variant', optVariantId);
    history.replaceState(null, null, replaceUrl);

    var stockIntervalCounter = 0;
    var stockInterval = setInterval(function(){
      if (!ourStockLocationNames || !ourStockLocationNames.length) {
        fillSidebarValues(optInStock, optInitialStock);
        document.getElementById('Quantity').dispatchEvent(new Event('change'));
        clearInterval(stockInterval);
        return;
      }
      if (++stockIntervalCounter > 50) {
        fillSidebarValues(optInStock, optInitialStock);
        document.getElementById('Quantity').dispatchEvent(new Event('change'));
        clearInterval(stockInterval);
        return;
      }
      if (typeof(jtcProductInventoryInfo) == 'undefined' || !jtcProductInventoryInfo || !jtcProductInventoryInfo.data.variants || !jtcProductInventoryInfo.data.variants[optVariantId]) {
        return;
      }
      var variantLocationData = jtcProductInventoryInfo.data.variants[optVariantId];
      var ourStockResult = 0;
      var totalStockResult = 0;
      for (var i in variantLocationData.locations) {
        var location = variantLocationData.locations[i];
        if (ourStockLocationNames.includes(location.name)) {
          ourStockResult += location.stock;
        }
        totalStockResult += location.stock;
        // console.log('optVariantId, location.name, location.stock, ourStockResult: ', optVariantId, location.name, location.stock, ourStockResult); 
      }
      optInStock = ourStockResult;
      fillSidebarValues(optInStock, optInitialStock);
      if (optMaxQuantity > 0) {
        document.getElementById('Quantity').dispatchEvent(new Event('change'));
      }
      clearInterval(stockInterval);
    }, 100);

    if (optIsAccessory) {
      // prepare short basket modal for accessories
      document.querySelector('.terrys-basket-modal .short-modal').classList.remove('hidden');
      document.querySelector('.terrys-basket-modal .long-modal').classList.add('hidden');
    } else {
      // prepare long basket modal if accessory data in it is filled
      if (document.getElementById('modal-accessory-variant-id').value.length > 0) {
        document.querySelector('.terrys-basket-modal .short-modal').classList.add('hidden');
        document.querySelector('.terrys-basket-modal .long-modal').classList.remove('hidden');
      } else {
        document.querySelector('.terrys-basket-modal .short-modal').classList.remove('hidden');
        document.querySelector('.terrys-basket-modal .long-modal').classList.add('hidden');
      }
    }

  }; //changeVariant




  var fillSidebarValues = function(inStock, initialTotalStock) {
    document.querySelectorAll('.sidebar-our-stock').forEach((el) => {
      el.innerHTML = inStock;
    });
    document.querySelectorAll('.sidebar-total-stock').forEach((el) => {
      el.innerHTML = initialTotalStock;
    });
    document.querySelectorAll('.PopupSideBar .stock-message').forEach((el) => {
      el.classList.add('hidden');
    });
    if (initialTotalStock == 0) {
      document.querySelector('#VariantDeliveryPreOrder .no-stock').classList.remove('hidden');
    } else {
      document.querySelector('#VariantDeliveryPreOrder .in-stock').classList.remove('hidden');
    }
    if (inStock == 0) {
      document.querySelector('#VariantDeliveryLeadTime .no-stock').classList.remove('hidden');
    } else {
      document.querySelector('#VariantDeliveryLeadTime .in-stock').classList.remove('hidden');
    }
  }

  var refill = function(){
    var variantData = document.getElementById('variants-list').value.split('|');
    var maxQuantity = parseInt(variantData[4]);
    var incomingTimestamp = parseInt(variantData[5]);
    var currentTimeStamp = parseInt(Date.now()/1000);
    var cutOffTimeStamp = currentTimeStamp + 2419200; // + 4 weeks
    
    var max = maxQuantity;
    if (max == 0) {
      if (incomingTimestamp > currentTimeStamp && incomingTimestamp < cutOffTimeStamp) {
        max = 10;
      // } else {
      //   max = shopifyProduct.firstQuantity;
      }
    }
    var $select = $(".mobile-quantity");
    $select.empty();
    for (var i = shopifyProduct.dropdownFrom; i <= max; i++){
      $select.append($('<option></option>').val(i).html(i))
    }
  };



  var renderAccessories = function() {
    loadAccessories().then( function(result) {
      var modalFilled = false;
      for (var acc in result.accessories) {
        if (result.accessories.hasOwnProperty(acc)) {
          renderAccessory(result.accessories[acc]);
          if (
            !modalFilled 
            && shopifyProduct.type.toLowerCase().lastIndexOf('curtains-rm',0) === 0 
            && result.accessories[acc].title.toLowerCase().includes('cushion')
            && result.accessories[acc].total_stock > 0
            && result.accessories[acc].image_src.length > 0
          ) {
            //product type starts with "curtains-rm" AND accessory title contains "cushion" AND accessory total stock > 0 AND accessory has image
            renderAccessoryModal(result.accessories[acc]);
            modalFilled = true;
          }
        }
      }
    });
  };



  var loadAccessories = function() {
    return $.getJSON(`${wsBaseApiUrl}/accessories/` + shopifyProduct.sku);
  };



  var renderAccessory = function(acc) {
    var el = $("#variants-list-desktop ul:has(form):first").clone().appendTo("#variants-list-desktop");
    el.addClass("cloned");

    var title = acc.title;
    if (title.length < 3 || title.length > 50) {
      title = acc.sku;
    }
    el.find('li.size strong').text(title);
    el.find('li:nth-of-type(2) del').text("£" + acc.rrp);
    el.find('li:nth-of-type(3) strong').text("£" + acc.price);

    var quantity = el.find(".select-product");
    var leadTime = document.querySelector('.lead_time').innerHtml;

    quantity.removeClass().addClass(acc.variant_id+"-1-"+acc.total_stock).addClass("select-product");
    quantity.empty();
    for (var i=1; i<=acc.total_stock; i++) {
      quantity.append($('<option></option>').val(i).html(i));
    }

    el.find('li:nth-of-type(6) input[name="id"]').val(acc.variant_id);

    var in_stock = acc.stock > 0 ? '<div><strong>' + acc.stock + '</strong> In Stock</div>' : '<div style="font-size:13px">'+leadTime+'</div>';
    el.find(".product-desktop li").html(in_stock);

    acc.stock_due_date = acc.stock_due_date===null ? 0 : (new Date(acc.stock_due_date).getTime())/1000;

    // mobile
    var preOrderStock = 0;
    var opt_html = acc.title.trim() + " £" + acc.price;
    if (acc.total_stock <= 0) {
      if (acc.stock_due_date > parseInt(Date.now()/1000)) {
        var stockDueDate = new Date(acc.stock_due_date * 1000);
        opt_html += " - Stock Due: " + stockDueDate.toLocaleDateString('en-GB');
        preOrderStock = 10;
      } else {
        opt_html += " - Currently Unavailable";
      }
    }
    var actual_rrp;
    if (parseFloat(acc.rrp) <= parseFloat(acc.price)) {
      actual_rrp = "£££";
    } else {
      actual_rrp = "£" + acc.rrp;
    }
    var opt = [acc.variant_id, actual_rrp, "£"+acc.price, acc.stock, acc.total_stock, acc.stock_due_date, preOrderStock,'','accessory'].join("|");
    $(".product-detail-inner-dropdown select").append( $('<option></option>').val(opt).html(opt_html) );
  };

  var selectVariant = function(){
    var selectedVariant = '';
    var queryString = window.location.search.slice(1).split('#')[0];
    if (queryString.length) {
      var queryParams = queryString.split('&');
      for (var i=0; i<queryParams.length; i++){
        var param = queryParams[i].split('=');
        if (param[0].toLowerCase() == 'variant'){
          selectedVariant = param[1];
          break;
        }
      }
    }
    if (does_variant_exist(selectedVariant)) {
      $("#variants-list").val( $("#variants-list option[value^='" + selectedVariant + "|']").val() ).change();
    } else {
      var options = $("#variants-list option");
      var options_counter
      
      for (var i=0; i < options.length; i++) {
        var optValue = options[i].value;
        var values = optValue.split("|");
        var availability = parseInt(values[4]);
        
        if (availability > 0) {
          setTimeout(function(){
            $("#variants-list").val( optValue ).change();
          }, 100);
          break;
        } 
        setTimeout(function(){
          $("#variants-list").val(options[0].value).change();
        }, 100);
      }
    }
  };

  var renderAccessoryModal = function(acc) {
    if (acc.image_src.length > 0) {
      document.querySelector(".modal-basket-accessory .accessory-image img").src = acc.image_src;
    }
    document.querySelector(".modal-basket-accessory .buying-options-variant-price").innerText = '£' + acc.price;
    if (acc.rrp > 0) {
      document.querySelector(".modal-basket-accessory .was-price-value").innerText = '£' + acc.rrp;
      document.querySelector(".modal-basket-accessory .was-price").classList.remove('hidden');
    }
    var quantity = acc.total_stock;
    if (quantity == 0) {
      quantity = 20;
    }
    var quantityElement = document.querySelector('.modal-basket-accessory .accessory-quantity-select');
    quantityElement.innerText = null;
    for (var i=1; i <= quantity; i++) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.innerHTML = i;
      quantityElement.appendChild(opt);
    }
    document.getElementById('modal-accessory-variant-id').value = acc.variant_id;

    document.querySelector('.terrys-basket-modal .short-modal').classList.add('hidden');
    document.querySelector('.terrys-basket-modal .long-modal').classList.remove('hidden');
  };

  selectVariant();
  renderAccessories();
  changeVariant();
  refill();

}
/* end product with variants */

function does_variant_exist(selectedVariant) {
  var does_exist = false;
  
  var options = $("#variants-list option");
  for (var i = 0; i < options.length; i++) {
    var optValue = options[i].value;
    var values = optValue.split("|");
    var variant = parseInt(values[0]);
    if(variant == selectedVariant) {
      does_exist = true;
      return does_exist;
    }
  }

  return does_exist;
}


/* m2m curtain accessories */
if (m2mCurtainAccesoriesTemplate.toLowerCase() == "on") {

  var renderAccessories = function() {
    loadAccessories().then( function(result) {
      var tiebacks = [],
          cushions = [];

      for (var acc in result.accessories) {
        if (result.accessories.hasOwnProperty(acc)) {
          var accessory = result.accessories[acc];
          if (/\/cush[^\/]*$/i.test(accessory["sku"]) || /cushion/i.test(accessory["title"])) {
            cushions.push(accessory);
          }
          if (/\/tb[^\/]*$/i.test(accessory["sku"]) || /tieback/i.test(accessory["title"]) ) {
            tiebacks.push(accessory);
          }
        }
      }

      if (tiebacks.length == 0 && cushions.length == 0) {
        $(".no-accessories-text").removeClass("hidden");
        return;
      }

      renderTiebacks(tiebacks);

      renderCushions(cushions);

    });
  }

  var loadAccessories = function() {
    return $.getJSON(`${m2mBaseApiUrl}/accessories/` + shopifyProduct.sku);
  }

  var renderTiebacks = function(tiebacks) {
    if (tiebacks.length < 1) {
      return;
    } else if (tiebacks.length == 1) {
      $(".tieback-title").text(tiebacks[0].title);
      $(".tieback-price .price").text("£" + tiebacks[0].price);
      $(".tieback-form input[name='id']").val(tiebacks[0].variantid);
      $(".product-detail-inner-dropdown").addClass("hidden");
      $(".tieback-price").css("margin-bottom", "58px");
    } else {

      var $options = $(".tieback-options");
      for (var i in tiebacks) {
        if (tiebacks.hasOwnProperty(i)) {
          var tb = tiebacks[i],
              optionVal = tb.sku +"|" + tb.variantid + "|" + tb.title + "|" + tb.price + "|" + tb.rrp,
              optionHtml = tb.title;
          $options.append($('<option></option>').val(optionVal).html(optionHtml));
        }
      }

      populateTiebackOption();

      $options.on("change", populateTiebackOption );
    }

    $(".tiebacks-block").removeClass("hidden");
  }

  var populateTiebackOption = function() {
    var tb = $(".tieback-options").val().split("|");
    $(".tieback-title").text(tb[2]);
    $(".tieback-form input[name='id']").val(tb[1]);
    $(".tieback-price .price").text("£" + tb[3]);
  }

  var renderCushions = function(cushions) {
    if (cushions.length < 1) {
      return;
    }

    $(".cushion-title").text(cushions[0].title);
    $(".cushion-price .price").text("£" + cushions[0].price);
    $(".cushion-form input[name='id']").val(cushions[0].variantid);

    $(".cushion-block").removeClass("hidden");
  }

  renderAccessories();

}
/* end m2m curtain accessories */




var deliveryApi = {

  apiUrl: `${wsBaseApiUrl}/delivery/`,
  
  payload: {},
  
  data: {},
  
//   validationRegExp: /^\d{4}-\d{2}-\d{2}$/,
  validationRegExp: /^\d{1,2}$/,
  
  deliveryBlock: $(".delivery_box_new_m2m"),
  
  getData: function(){
    return $.getJSON(this.apiUrl + this.payload.sku);
  },
  
  populateDateData: function(block) {
    var deliveryBlockTitle = $(block + " .delivery_box_question"),
        deliveryBlockDate = $(block + " .delivery_box_date"),
        dateOptions = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'},
        dateFormatted = new Date(this.data.expected_delivery).toLocaleString('en-gb', dateOptions)
    
    deliveryBlockTitle.html("Estimated delivery date:");
    deliveryBlockDate.html(dateFormatted);
  },
  
  populateDaysData: function(block, isBespoke) {
    if (this.deliveryBlock.hasClass("delivery_box_preorder")) {
      var deliveryBlockLeadTime = $(block + " .preorder-leadtime")
      deliveryBlockLeadTime.html(this.data.days_dispatch + " working days");
    } else {
      var deliveryBlockTitle = $(block + " .delivery_box_question"),
          deliveryBlockDate = $(block + " .delivery_box_date");
      if (deliveryBlockDate.parent().hasClass("delivery_fixed")) {
        return;
      }
      if ((!isBespoke && earlyJanStatus) || (isBespoke && earlyJanStatusBespoke)) {
        deliveryBlockTitle.html("Early January Dispatch:");
      } else {
        deliveryBlockTitle.html("Dispatched in:");
      }
      deliveryBlockDate.html(this.data.days_dispatch + " working days");
    }
  },
  
  init: function(sku, block, isBespoke = false) {
    var that = this;
    this.payload.sku = sku;
    this.getData().then(function(result){
//       if ( !result.expected_delivery || !that.validationRegExp.test(result.expected_delivery) ) {
      if ( !result.days_dispatch || !that.validationRegExp.test(result.days_dispatch) ) {
        console.log("wrong delivery result: ", result);
        return;
      }
      that.data = result;
//       that.populateDateData(block);
      that.populateDaysData(block, isBespoke);
    }).always(function(){
      that.deliveryBlock.removeClass("hidden");
    });
  }

} //deliveryApi





var cmInInch = 2.54;

function inchesNumberToString(val, method){
  var wholePart = Math.floor(val);
  var fraction = val - wholePart;
  var fracIn = "0";
  switch (method) {
    case 'lowest':
      if (fraction >= 0.25 && fraction < 0.5) {
        fracIn = "1/4";
      } else if (fraction >= 0.5 && fraction < 0.75) {
        fracIn = "1/2";
      } else if (fraction >= 0.75 && fraction < 1) {
        fracIn = "3/4";
      }
      break;
    case 'largest':
      if (fraction > 0 && fraction <= 0.25) {
        fracIn = "1/4";
      } else if (fraction > 0.25 && fraction <= 0.5) {
        fracIn = "1/2";
      } else if (fraction > 0.5 && fraction <= 0.75) {
        fracIn = "3/4";
      } else if (fraction > 0.75) {
        wholePart += 1;
      }
      break;
    default:
      if (fraction > 0.125 && fraction <= 0.375) {
        fracIn = "1/4";
      } else if (fraction > 0.375 && fraction <= 0.625) {
        fracIn = "1/2";
      } else if (fraction > 0.625 && fraction <= 0.875) {
        fracIn = "3/4";
      } else if (fraction > 0.875) {
        wholePart += 1;
      }
      break;
  }
  var result = wholePart;
  if (fracIn !== "0") {
    result = wholePart + " " + fracIn;
  } 
  return result;
}
function inchesNumberToStringForCurtains(val, method){
  var wholePart = Math.floor(val);
  var fraction = val - wholePart;
  var fracIn = "0";
  switch (method) {
    case 'lowest':
      if (fraction >= 0.5) {
        fracIn = "1/2";
      }
      break;
    case 'largest':
      if (fraction > 0 && fraction <= 0.5) {
        fracIn = "1/2";
      } else if (fraction > 0.5) {
        wholePart += 1;
      }
      break;
    default:
      if (fraction > 0.25 && fraction <= 0.75) {
        fracIn = "1/2";
      } else if (fraction > 0.75) {
        wholePart += 1;
      }
      break;
  }
  var result = wholePart;
  if (fracIn !== "0") {
    result = wholePart + " " + fracIn;
  } 
  return result;
}

function inchesStringToNumber(string){
  var parts = string.split(" ");
  var result = parseInt(parts[0]);
  if (parts.length > 1) {
    var fraction = parts[1];
    switch (fraction) {
      case "1/4":
        result += 0.25;
        break;
      case "1/2":
        result += 0.5;
        break;
      case "3/4":
        result += 0.75;
        break;
    }
  }
  return result;
}

function customRound(val, method) {
  var res;
  switch (method) {
    case 'floor':
      res = Math.floor(val);
      break;
    case 'ceil':
      res = Math.ceil(val);
      break;
    default:
      res = Math.round(val);
  }
  return res;
}

function cm2in(val, method, product) {
  val = parseFloat(val) / cmInInch;
  var result = val;
  if (typeof(product) !== "undefined" && product == "curtains") {
    result = inchesNumberToStringForCurtains(val, method);
  } else {
    result = inchesNumberToString(val, method);
  }
  return result;
}

function in2cm(val, decimals, method) {
  var result = parseFloat(val) * cmInInch;
  if (typeof decimals === "undefined") {
    return result;
  }
  if (typeof method === 'undefined' ) {
    method = 'round';
  }
  if (parseInt(decimals) == 0) {
    return customRound(result, method);
  }
  var factor = parseInt(decimals) * 10;
  result = customRound(result * factor, method) / factor;
  return result;
}







/* buying options curtains */
if (buyingOptionsCurtainsTemplate.toLowerCase() == "on") {
  
  $(".tf-product-widths input").keyup(function(event) {
    if (event.keyCode === 13) {
      $(".calculate-custom-price").trigger("click");
      event.preventDefault();
    }
  });

  var measurementUnitsSelector = 'input.unit-radio';
  
  var vipPriceBaner = document.querySelector(".banner-product-vip");
  document.querySelector("li[role='accessory-product'] a").addEventListener("click", function(){
    if (vipPriceBaner != null) {
      vipPriceBaner.style.visibility = "hidden";
    }
  });
  document.querySelector("li[role='main-product'] a").addEventListener("click", function(){
    if (vipPriceBaner != null) {
      vipPriceBaner.style.visibility = "visible";
    }
  });


  var setFirstCurtainLenghtDynamicText = function(heading) {
    var container = $('.text-note');
    if(container.html().length == 0) {
      setCurtainLenghtDynamicText(heading);
    }
  };

  var setCurtainLenghtDynamicText = function( heading ) {
    var container = $('.text-note');
    var text = '';
    if( heading === 'pencil') {
      text = 'Make sure you supply length measurement from either: ';
      text += 'the <strong>TOP OF THE CURTAIN TRACK</strong> (if using a curtain track) ';
      text += ' <strong>OR</strong>';
      text += ' the <strong>BOTTOM OF THE CURTAIN RING</strong> (if hanging on a pole) ';
      text += 'to the required finished length.';
    } else if( heading === 'eyelet' ) {
      text = 'Make sure you supply length measurement from the <strong>TOP OF THE CURTAIN POLE</strong> to the required finished length.';
    } else if( heading === 'dblpin') {
      text = 'Make sure you supply length measurement from the <strong>BOTTOM OF THE CURTAIN RING</strong> to the required finished length.';
    }
    container.html(text);
  };


  var terrysFabricAddToCart = function(){

    var $j = jQuery,
        self = this;

    this.addToCartUrl = '/cart/add.js';

    this.init = function( pricingApi ){

      $j('.tf-add-to-cart').click(function(){
        $j('.tf-headings-section-error-label').text('');
        if ( $j(this).hasClass('inactive') ) { return false; }

        $j(this).addClass('inactive');
        $j(this).text('Working...');

        var productID = $j(this).attr('data-product-id');
        var productSku = shopifyProduct.sku;
        var formData = self.serializeFormData();

        var productOptions = {
          'heading_option':formData.heading_option,
          'lining_option':formData.lining_option,
          'width':pricingApi.product.width,
          'drop':pricingApi.product.drop,
          'eyelet_color':formData.eyelet_color,
          'fitting_option':pricingApi.product.fitting_option,
          'fabric_widths':pricingApi.product.fabric_widths,
          'widths_per_curtain':pricingApi.product.widths_per_curtain,
          'manufacture_option': formData.manufacture_option
        }

        if (!$j.isEmptyObject(pricingApi.productData.hidden_options)) {
          for (var key in pricingApi.productData.hidden_options) {
            if (pricingApi.productData.hidden_options.hasOwnProperty(key)) {
              productOptions[key] = pricingApi.productData.hidden_options[key];
            }
          }
        }

        if ( 'eye' === formData.heading.toLowerCase() && null == formData.eyelet_color ) {
          $j('.tf-headings-section-error-label').text('Please select a colour.');
          $j(this).removeClass('inactive');
          $(this).text('Add to Basket');
          return;
        }

        if (pricingApi.product.units == 'in') {
          productOptions.width_inches = pricingApi.product.width_units;
          productOptions.drop_inches = pricingApi.product.drop_units;
        } else if (pricingApi.product.units == 'mm') {
          productOptions.width_mm = pricingApi.product.width_units;
          productOptions.drop_mm = pricingApi.product.drop_units;
        }


        pricingApi.createShopifyProductVariant( productID, productSku, formData.heading, formData.lining_option, formData.eyelet_color, formData.manufacture_option, productOptions, function(response){

          var data = response.data;
          if ( 'undefined' !== typeof data.variant.id ) {

            var cartProperties = {};

            for ( var prop in productOptions ) {
              var key = prop.charAt(0) == "_" ? prop : capitalizeFirstLetter( prop.replace( /_/g, ' ' ) );
              cartProperties[ key ] = productOptions[ prop ];
            }

            let possibleKeys = ['discount', 'was_price', 'promo_discount', 'then_price'];
            for(let key of possibleKeys) {
              if(data.variant[key]) {
                cartProperties['_' + key] = data.variant[key];
              }
            }

            if ($("#preorder-advice-property").length > 0) {
              cartProperties["_Preorder-Advice"] = $("#preorder-advice-property").val();
            }

            if (typeof data.related_options != 'undefined' && data.related_options.length > 0) {
              for ( var i = 0; i < data.related_options.length; i++ ) {
                var ro = data.related_options[i];
                if (typeof ro['label'] != 'undefined' && ro['label'].length > 0 && typeof ro['value'] != 'undefined' && ro['value'].length > 0) {
                  cartProperties[ ro['label'] ] = ro['value'];
                }
              }
            }

            var cartData = {
              'quantity':parseInt($('#quantity').val()) || 1,
              'id':data.variant.id,
              'properties':cartProperties
            };

            self.addToCart( cartData );

          }

        });

      });

    };

    this.addToCart = function( cartData ){
      $j.ajax({
        type:'POST',
        url:self.addToCartUrl,
        data:cartData,
        success:function(data){
          var _config = {
            shopifyAjaxCartURL: "/cart.js",
            cartCountSelector: ".cart-count",
            cartTotalSelector: "#cart-price"
          };
          $.getJSON(_config.shopifyAjaxCartURL, function(cart) {
            if (_config.cartCountSelector && $(_config.cartCountSelector).size()) {
              var value = $(_config.cartCountSelector).html() || '0';
              $(_config.cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count)).removeClass('hidden-count');
            }
            if (_config.cartTotalSelector && $(_config.cartTotalSelector).size()) {
              if (typeof Currency !== 'undefined' && typeof Currency.moneyFormats !== 'undefined') {
                var newCurrency = '';
                if ($('[name="currencies"]').size()) {
                  newCurrency = $('[name="currencies"]').val();
                } else if ($('#currencies span.selected').size()) {
                  newCurrency = $('#currencies span.selected').attr('data-currency');
                }
                if (newCurrency) {
                  $(_config.cartTotalSelector).html('<span class=money>' + Shopify.formatMoney(Currency.convert(cart.total_price, "GBP", newCurrency), Currency.money_format[newCurrency]) + '</span>');
                } else {
                  $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, "£{{amount}}"));
                }
              } else {
                $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, "£{{amount}}"));
              }
            };
            toggleBasketModal();
          });

          $j('.tf-add-to-cart').text('Item Added');
        },
        dataType:'json'
      })
    }

    this.serializeFormData = function(){

      var data = {
        'heading':null,
        'heading_option':null,
        'lining_option':null,
        'manufacture_option': null,
        'eyelet_color':null
      };

      $j('.tf-variant-product').each(function(){

        var _this = $j(this);

        if ( $j(this).find('.item-price input').is(':checked') ) {

          data.heading = _this.attr('data-heading');
          data.heading_option = $j(this).find('.item-price input').val();

        }
      });

      // $j('#tf-lo-container input').each(function(){
      //   if ( $j(this).is(':checked') ) {
      //     data.lining_option = $j(this).val();
      //   }
      // });
      data.lining_option = $j('#tf-lining-option-select').find(":selected").val();

      $j('#tf-mo-container input').each(function(){
        if ( $j(this).is(':checked') ) {
          data.manufacture_option = $j(this).val();
        }
      });

      if(data.heading === 'EYE') {
        // $j('#tf-ec-container input').each(function(){
        //   if ( $j(this).is(':checked') ) {
        //     data.eyelet_color = $j(this).val();
        //   }
        // });
        data.eyelet_color = $j('#tf-eyelet-option-select').find(":selected").val();
      }
      return data;

    }

  };

  var persistentProductData = {
    data: {},
    updateData: function() {
      var self = this;
      var api = new terrysFabricAddToCart();
      setTimeout(function() {
        self.data = api.serializeFormData();
      }, 1);
    }
  };

  var productPriceApi = function() {

    var $j = jQuery,
        self = this;

    this.api = {
      'defaultUrl':`${baseApiUrl}/api/`,
      'calculatePriceUrl':''
    }

    this.productData = {
      'pencil':{},
      'eyelet':{},
      'pinch':{},
      'dblpin':{},
      'hidden_options':{}
    }

    this.product = {
      'sku':'',
      'width':71,
      'drop':122,
      'fitting_option':'',
      'units':'cm',
      'minWidth':0,
      'maxWidth':0,
      'minDrop':0,
      'maxDrop':0
    };

    this.init = function( callback ){

      this.product.minWidth = parseFloat( $j('#width').attr('data-min') );
      this.product.maxWidth = parseFloat( $j('#width').attr('data-max') );
      this.product.minDrop = parseFloat( $j('#drop').attr('data-min') );
      this.product.maxDrop = parseFloat( $j('#drop').attr('data-max') );

      $(document).on('click', measurementUnitsSelector, function() {
        var unit = $(measurementUnitsSelector + ":checked").val();
        $('.unit-label').text(unit);
        if (unit == 'in') {
          $('.width-selector').each(function () {
            $(".inch-fractions").removeClass("hidden");
            
            //placeholder and value
            if (typeof $(this).attr("data-min-inch") === 'undefined' || parseFloat($(this).attr("data-min-inch")) <= 0) {
              var minIn = cm2in($(this).attr("data-min"), "largest", 'curtains');
              $(this).attr("data-min-inch", minIn);
            }
            if (typeof $(this).attr("data-max-inch") === 'undefined' || parseFloat($(this).attr("data-max-inch")) <= 0) {
              var maxIn = cm2in($(this).attr("data-max"), "lowest", "curtains");
              $(this).attr("data-max-inch", maxIn);
            }
            $(this).attr("placeholder", $(this).attr("data-min-inch") + " - " + $(this).attr("data-max-inch"));

            if ($(this).val() > 0) {
              $(this).val("");
              $(this).parent().children(".inch-fractions").val("0").change();
            }

          });
        } else if (unit == "mm") {
          $(".inch-fractions").addClass("hidden");
          $('.width-selector').each(function(){
            $(this).attr("placeholder", $(this).attr("data-min")*10 + " - " + $(this).attr("data-max")*10 );
            if ($(this).val() > 0) {
              $(this).val("");
            }
          });

        } else {
          // unit == "cm"
          $(".inch-fractions").addClass("hidden");
          $('.width-selector').each(function(){
            $(this).attr("placeholder", $(this).attr("data-min") + " - " + $(this).attr("data-max") );
            if ($(this).val() > 0) {
              $(this).val("");
            }
          });
        }

      });

      $j('.calculate-custom-price').click(function(){
        if ( false === self.validateWidths() ) { return false; }

        if ( ! $j(this).hasClass('inactive') ) {
          self.product.sku = $j(this).attr('data-product-sku');
          self.product.fitting_option = $j('.tf-fitting-options input:checked').val();
          self.getPriceFromApi( callback );
          $j(this).addClass('tf-price-calculation-step2');
          $(".tf-add-to-cart").removeClass("inactive");
        }

      });
    };

    this.validateWidths = function(){
      $j('#width').removeClass( 'tf-error' );
      $j('#drop').removeClass( 'tf-error' );
      $j('#curtain-widths-error-message').text('');
      $j('#input-number-error-message').html('');

      var minWidth = this.product.minWidth,
          maxWidth = this.product.maxWidth,
          minHeight = this.product.minDrop,
          maxHeight = this.product.maxDrop,
          widthVal = $j('#width').val(),
          dropVal = $j('#drop').val(),
          widthOriginal = widthVal,
          dropOriginal = dropVal,
          selectedMeasurementUnit = $(measurementUnitsSelector + ":checked").val(),
          selectedMeasurementUnitFull = $(measurementUnitsSelector + ":checked").attr("data-full-name");

      if (selectedMeasurementUnit == 'in') {

        var widthInches = widthVal;
        var dropInches = dropVal;

        var widthInchesFractionText = $(".width-fraction option:selected").text();
        var widthInchesFractionVal = $(".width-fraction option:selected").val();
        var dropInchesFractionText = $(".drop-fraction option:selected").text();
        var dropInchesFractionVal = $(".drop-fraction option:selected").val();

        var widthInchesText = widthVal + (widthInchesFractionText=="0" ? "" : (" " + widthInchesFractionText));
        var widthInchesVal = parseFloat(widthVal) + parseFloat(widthInchesFractionVal);
        var dropInchesText = dropVal + (dropInchesFractionText=="0" ? "" : (" " + dropInchesFractionText));
        var dropInchesVal = parseFloat(dropVal) + parseFloat(dropInchesFractionVal);

        var widthMinInchesText = $('#width').attr('data-min-inch');
        var widthMaxInchesText = $('#width').attr('data-max-inch');
        var dropMinInchesText = $('#drop').attr('data-min-inch');
        var dropMaxInchesText = $('#drop').attr('data-max-inch');
        var widthMinInchesVal = inchesStringToNumber(widthMinInchesText);
        var widthMaxInchesVal = inchesStringToNumber(widthMaxInchesText);
        var dropMinInchesVal = inchesStringToNumber(dropMinInchesText);
        var dropMaxInchesVal = inchesStringToNumber(dropMaxInchesText);

        widthVal = in2cm(widthInchesVal, 0, 'round');
        dropVal = in2cm(dropInchesVal, 0, 'round');
        
      } else if (selectedMeasurementUnit == "mm") {
        var widthMm = widthVal;
        var dropMm = dropVal;
        
        widthVal = customRound(widthVal / 10, 'round');
        dropVal = customRound(dropVal / 10, 'round');
      }

      if ( '' == widthOriginal || isNaN(widthOriginal) ) {
        $j('#width').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('Width is required' );
        return false;
      }
      if ( '' == dropOriginal || isNaN(dropOriginal) ) {
        $j('#drop').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('Drop is required' );
        return false;
      }
      if ( ! /^\d+$/.test(widthOriginal) ) {
        $j('#width').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('Ooops, please enter numbers only' );
        return false;
      }
      if ( ! /^\d+$/.test(dropOriginal) ) {
        $j('#drop').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('Ooops, please enter numbers only' );
        return false;
      }
      if ( /^\d*\.\d*$/.test(widthOriginal) ) {
        $j('#width').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('Ooops, Measurements must be in whole ' + selectedMeasurementUnitFull );
        return false;
      }
      if ( /^\d*\.\d*$/.test(dropOriginal) ) {
        $j('#drop').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('Ooops, Measurements must be in whole ' + selectedMeasurementUnitFull );
        return false;
      }
      if ( selectedMeasurementUnit == 'cm' && (( parseFloat(widthVal) < minWidth ) || ( parseFloat(widthVal) > maxWidth )) ) {
        $j('#width').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('The width should be between ' + minWidth +'cm and ' + maxWidth + 'cm' );
        return false;
      }
      if ( selectedMeasurementUnit == 'cm' && (( parseFloat(dropVal) < minHeight ) || ( parseFloat(dropVal) > maxHeight )) ) {
        $j('#drop').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('The drop should be between ' + minHeight +'cm and ' + maxHeight + 'cm' );
        return false;
      }
      if ( selectedMeasurementUnit == 'in' && (( widthInchesVal < widthMinInchesVal ) || ( widthInchesVal > widthMaxInchesVal )) ) {
        $j('#width').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('The width should be between ' + widthMinInchesText +'in and ' + widthMaxInchesText + 'in' );
        return false;
      }
      if ( selectedMeasurementUnit == 'in' && (( dropInchesVal < dropMinInchesVal ) || ( dropInchesVal > dropMaxInchesVal )) ) {
        $j('#drop').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('The drop should be between ' + dropMinInchesText +'in and ' + dropMaxInchesText + 'in' );
        return false;
      }
      if ( selectedMeasurementUnit == 'mm' && (( parseFloat(widthVal) < minWidth ) || ( parseFloat(widthVal) > maxWidth )) ) {
        $j('#width').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('The width should be between ' + (minWidth * 10) +'mm and ' + (maxWidth * 10) + 'mm' );
        return false;
      }
      if ( selectedMeasurementUnit == 'mm' && (( parseFloat(dropVal) < minHeight ) || ( parseFloat(dropVal) > maxHeight )) ) {
        $j('#drop').addClass( 'tf-error' );
        $j('.calculate-custom-price').addClass('inactive');
        $j('#curtain-widths-error-message').text('The drop should be between ' + (minHeight * 10) +'mm and ' + (maxHeight * 10) + 'mm' );
        return false;
      }

      self.product.units = 'cm';
      self.product.width = widthVal;
      self.product.drop = dropVal;
      self.product.width_units = widthVal;
      self.product.drop_units = dropVal;

      if (selectedMeasurementUnit == 'in') {
        self.product.units = 'in';
        self.product.width_units = widthInchesText;
        self.product.drop_units = dropInchesText;
      } else if (selectedMeasurementUnit == 'mm') {
        self.product.units = 'mm';
        self.product.width_units = widthMm;
        self.product.drop_units = dropMm;
      }

      $j('.calculate-custom-price').removeClass('inactive');

      return true;
    }

    this.surchargePrice = function( price, percent ) {
      return roundTo( ( parseFloat( parseFloat( price ) + parseFloat( price ) * percent / 100 ) ), 2 );

    };

    this.populateEyeletColorsTemplate = function( options ){

      var template = '';
      var checked = false;

      var storedEyeletColor = persistentProductData.data.eyelet_color || null;
      var alreadySet = false;

      var select = $('<select>', {id: 'tf-eyelet-option-select', name:'tf-eyelet-colour', class: 'curtains-options-select'});

      options.forEach( function( option, key ){

        if ( 'Please Select' !== option.label ) {
          // var checkedAttr = '';
          var selected = false;
          if(!alreadySet) {
            if(!storedEyeletColor) {
              // checkedAttr = 'checked';
              alreadySet = true;
              selected = true;
            } else if(storedEyeletColor == option.label) {
              // checkedAttr = 'checked';
              alreadySet = true;
              selected = true;
            }
          }

          select.append( $('<option></option>').val(option.label).html(option.label).prop('selected', selected) );

          // template += '<section>' +
          //     '<div class="squaredThree">' +
          //     '<input type="radio" ' + checkedAttr + ' value="' + option.label + '" id="tf-lining-option-' + option.label + '"  name="tf-eyelet-colour" />' +
          //     option.label + '<label for="tf-lining-option-' + option.label + '"></label>' +
          //     '</div>' +
          //     '</section>';
        }

      });

      // return template;
      return select;

    };

    this.createShopifyProductVariant = function( productID, productSku, heading, lining_option, eyelet_color, manufacture_option, product_options, callback ) {

      var data = {
        product_type: "curtain",
        service: "TF",
        product_id:productID,
        product_code: productSku,
        width:self.product.width,
        drop:self.product.drop,
        heading:heading,
        product_options:product_options
      }

      if ( null !== lining_option ) {
        data.lining_option = lining_option;
      }

      if ( null !== manufacture_option ) {
        data.manufacture_option = manufacture_option;
      }

      if ( null !== eyelet_color ) {
        data.eyelet_color = eyelet_color;
      }

      $j.ajax({
        url: `${m2mBaseApiUrl}/add`,
        type: "post",
        dataType:'json',
        data:data,
        success:function(data){
          callback( data );
        },

      });
    };

    this.getPriceFromApi = function( callback ){

      var calculatePriceButtonTextData = $j('.calculate-custom-price').text();
      $j('.calculate-custom-price').text('Working...');
      
      var productData = {
        product_type:"curtain",
        sku:self.product.sku,
        width:self.product.width,
        drop:self.product.drop
      }
      
      if (self.product.units == 'in') {
        productData.width_inches = self.product.width_units;
        productData.drop_inches = self.product.drop_units;
      } else if (self.product.units == 'mm') {
        productData.width_mm = self.product.width_units;
        productData.drop_mm = self.product.drop_units;
      }

      $.ajax({
        url:`${m2mBaseApiUrl}/price`,
        type:'post',
        dataType:'json',
        data: productData,
        success:function( data ){

          if ( 1 === data.status ) {

            $j('.calculate-custom-price').text( calculatePriceButtonTextData );

            self.productData = {
              'pencil':{},
              'eyelet':{},
              'pinch':{},
              'dblpin':{},
              'hidden_options':{}
            }

            for ( var key in data.data ) {

              var product = data.data[ key ];

              if ( 'undefined' !== typeof product.price  ) {
                self.populateProductData( product );
              }
            }

            if ( 'undefined' !== typeof self.productData.pencil.lining_options ) {
              $j('#tf-lo-container').html( self.populateLiningOptionTemplate( self.productData.pencil.lining_options.options ) );
            } else if ( 'undefined' !== typeof self.productData.eyelet.lining_options ) {
              $j('#tf-lo-container').html( self.populateLiningOptionTemplate( self.productData.eyelet.lining_options.options ) );
            } else {
              $j('.tf-lining-options').fadeOut();
            }

            if ( 'undefined' !== typeof  self.productData.eyelet && 'undefined' !== typeof  self.productData.eyelet.eyelet_colours ) {
              $j('#tf-ec-container').html( self.populateEyeletColorsTemplate( self.productData.eyelet.eyelet_colours.options ) );
            }
            
            if ( 'undefined' !== typeof self.productData.pencil.express_manufacture ) {
              $j('#tf-mo-container').html( self.populateExpressManufactureTemplate( self.productData.pencil.express_manufacture.options ) );
            } else if ( 'undefined' !== typeof self.productData.eyelet.express_manufacture ) {
              $j('#tf-mo-container').html( self.populateExpressManufactureTemplate( self.productData.eyelet.express_manufacture.options ) );
            } else {
              $j('.tf-manufacture-options').fadeOut();
            }

            // $j('#tf-ec-container .squaredThree').find('label').on('click', function() {
            //   persistentProductData.updateData();
            // });

            $j('#tf-ec-container .squaredThree').on('change', '#tf-eyelet-option-select', function(){
              // var selectedEyeletOption = $j(this).find(":selected").val();
              persistentProductData.updateData();
            })

            // $j('#tf-lo-container .squaredThree').each(function(){
            //   var _this = $j(this);
            //   $j(this).find('label').on("click", function(){
            //     var selectedLiningOption = _this.find('input').val();
            //     $j('#tf-lining-option').text('( '+selectedLiningOption+' Lining )');
            //     self.updatePriceByChangedOption('lining_option', selectedLiningOption);
            //     self.updateProductPrice();
            //     persistentProductData.updateData();
            //   });
            // });

            $j('#tf-lo-container').on('change', '#tf-lining-option-select', function(){
              var selectedLiningOption = $j(this).find(":selected").val();
              self.updatePriceByChangedOption('lining_option', selectedLiningOption);
              self.updateProductPrice();
              persistentProductData.updateData();
            });

            $j('#tf-mo-container .squaredThree').each(function(){
              var _this = $j(this);
              $j(this).find('label').click(function(){
                var selectedManufactureOption = _this.find('input').val();
                self.updatePriceByChangedOption('manufacture_option', selectedManufactureOption);
                self.updateProductPrice();
                persistentProductData.updateData();
              });
            });

            callback( data );
          }
          // Dynamic discount percentage (percentage on inside of discount circle changes when a different M2M option is selected)
          // temporarily disabled
          /*
          var newPrice = data.data[0].price;
          var oldPrice = data.data[0].was_price;
          var updated_discount_circle_value = newPrice / oldPrice;
          updated_discount_circle_value = 1 - updated_discount_circle_value;
          updated_discount_circle_value = updated_discount_circle_value * 100;
          updated_discount_circle_value = Math.floor(updated_discount_circle_value);
          updated_discount_circle_value = updated_discount_circle_value.toFixed(0);

          if(isNaN(updated_discount_circle_value) == false) {
            $("#discount-from-price").text(updated_discount_circle_value + "%");
          }
          */
        },
        error:function( jqXHR, exception ){
          $j('.calculate-custom-price').text( calculatePriceButtonTextData );
          $j('.product-price-options').fadeIn();
          $j('html, body').animate({
            scrollTop:($j('.product-price-options').offset().top - $j("#StickyHeader").outerHeight())
          }, 800);


          $j('.tf-error-label').text('An error has ocurred. Please try again');
          $j('.product-standrad').addClass('hidden');
          $j('.tf-add-to-cart').hide();

        },
      })

    };

    this.updateProductPrice = function(){

      $j('.tf-variant-product').each(function(){

        var type = $j(this).attr('data-type'),
            oldPrice = parseFloat(self.productData[ type ].active_price),
            newPrice = parseFloat(self.productData[ type ].active_sale_price);

        if(typeof(oldPrice) === 'undefined' || typeof(newPrice) === 'undefined') {
          return true;
        }
        
        // Dynamic discount percentage (percentage on inside of discount circle changes when a different M2M option is selected)

        if ( ( $('#cc-pencil-pleat').is(":checked") && type == "pencil") 
            || ($('#cc-eyelet').is(":checked") && type == "eyelet")
            || ($('#cc-pin').is(":checked") && type == "pinch")
            || ($('#cc-dblpin').is(":checked") && type == "doublepinch"))
        {
          
          $("#klarna_pay_in_3").text("£" + (Math.floor(newPrice / 3 * 100) / 100).toFixed(2));
          
          var vipPriceElement = document.querySelector(".klarna_accent .vip-price");
          if (vipPriceElement != null) {
            vipPriceElement.innerHTML = "£" + (Math.floor(newPrice * 100) / 100).toFixed(2);
          }
          
          // Dynamic discount percentage (percentage on inside of discount circle changes when a different M2M option is selected)
          // temporarily disabled
          /*
          var updated_discount_circle_value = newPrice / oldPrice;
          updated_discount_circle_value = 1 - updated_discount_circle_value;
          updated_discount_circle_value = updated_discount_circle_value * 100;
          updated_discount_circle_value = Math.floor(updated_discount_circle_value);
          updated_discount_circle_value = updated_discount_circle_value.toFixed(0);
  
          if(isNaN(updated_discount_circle_value) == false) {
            if (updated_discount_circle_value > 1) {
              $("#image_discount_circle").show();
              $("#discount-from-price").text(updated_discount_circle_value + "%");
            } else {
              $("#image_discount_circle").hide();
            }
          }
          */
        }        
        $j(this).find('.item-price .price span.tf-price-value').text( '£' + newPrice.toFixed(2));

        if ( oldPrice != newPrice && null !== newPrice ) {
          $j(this).find('.item-price-old del').text('£'+oldPrice.toFixed(2));
        } else {
          $j(this).find('.item-price-old del').hide();
        }

      });
    };

    this.populateLiningOptionTemplate = function( options ){

      var template = '';
      var checkedLinigOption = persistentProductData.data.lining_option || null;

      var select = $('<select>', {id: 'tf-lining-option-select', name:'tf-lining-option', class: 'curtains-options-select'});
      options.forEach( function( option, key ){
        var selected = false;
        if(checkedLinigOption) {
          if(checkedLinigOption === option.label) {
            selected = true;
          }
        } else {
          if(key === 0) {
            selected = true;
          }
        }

        var optionName = option.label;

        if (option.surcharge != '0' && option.surcharge != '0.00') {
          if (option.type.toLowerCase() == 'absolute') {
            optionName += ' (+ &pound;' + parseFloat(option.surcharge).toFixed(2) + ')';
          } else if (o.type == 'percent') {
            optionName += ' (' + parseFloat(option.surcharge) + '% Surcharge)';
          }
        }

        var searchOptionParam = 'blackout';
        if (optionName.toLowerCase().includes(searchOptionParam) && (option.surcharge == 0 || option.surcharge == "0.00")) {
          optionName = '<span class="free-upgrade">FREE UPGRADE</span> ' + optionName;
        }

        select.append( $('<option></option>').val(option.label).html(optionName).prop('selected', selected) );

        // template += '<section>' +
        //     '<div class="squaredThree">' +
        //     '<input type="radio" value="'+ option.label +'" id="tf-lining-option-' + option.label + '" ' + checked + '  name="tf-lining-option" />' +
        //     '<label for="tf-lining-option-' + option.label + '"></label>' +
        //     optionName +
        //     '</div>' +
        //     '</section>';

      });

      // return template;
      return select;

    }

    this.populateExpressManufactureTemplate = function( options ){

      var template = '';
      var checkedManufactureOption = persistentProductData.data.manufacture_option || null;
      options.forEach( function( option, key ){
        var checked = '';
        if(checkedManufactureOption) {
          if(checkedManufactureOption === option.label) {
            checked = 'checked';
          }
        } else {
          if(key === 0) {
            checked = 'checked';
          }
        }

        var optionName = option.label;
        template += '<section>' +
            '<div class="squaredThree">' +
            '<input type="radio" value="'+ optionName +'" id="tf-manufacture-option-' + optionName + '" ' + checked + '  name="tf-manufacture-option" />' +
            '<label for="tf-manufacture-option-' + optionName + '"></label>' +
            optionName +
            '</div>' +
            '</section>';

      });

      return template;

    }

    this.populateProductData = function( product ) {
      if ( 'undefined' !== typeof product.was_price && product.was_price !== product.price ) {
        var price = product.was_price,
            sale_price = product.price;
      } else {
        var price = product.price,
            sale_price = null;
      }

      self.product.widths_per_curtain = product.widths_per_curtain;

      var productData = {
        'sku':product.product_code,
        'heading':product.heading,
        'price': convertPrice( price ),
        'sale_price': ( null !== sale_price ? convertPrice( sale_price ) : null ),
        'active_price': convertPrice( price ),
        'active_sale_price': ( null === sale_price ? convertPrice( price ) : convertPrice( sale_price ) ),
        'width':self.product.width,
        'drop':self.product.drop,
        'fabric_widths':product.fabric_widths,
        'widths_per_curtain': product.widths_per_curtain,
        'chosen_lining_option':self.product.lining_option,
        'hidden_options': null
      }


      switch ( product.heading ) {
        case 'EYE':
          self.productData.eyelet = productData;
          product.product_options.forEach( function( option ) {
            switch ( option.label.toLowerCase() ) {
              case 'lining_options':
                self.productData.eyelet.lining_options = option;
                break;
              case 'eyelet_colour':
                self.productData.eyelet.eyelet_colours = option;
                break;
              case 'express_manufacture':
                self.productData.eyelet.express_manufacture = option;
                break;
            };
            if (option.type == 'H') {
              self.productData.hidden_options[option.label] = option.options[0].label;
            }

          });
          break;
        case 'PEN':
          self.productData.pencil = productData;
          product.product_options.forEach( function( option ) {
            switch ( option.label.toLowerCase() ) {
              case 'lining_options':
                self.productData.pencil.lining_options = option;
                break;
              case 'express_manufacture':
                self.productData.pencil.express_manufacture = option;
                break;
            };
            if (option.type == 'H') {
              self.productData.hidden_options[option.label] = option.options[0].label;
            }
          });
          break;
        case 'PIN':
        case 'PIN6':
          self.productData.pinch = productData;
          product.product_options.forEach( function( option ) {
            switch ( option.label.toLowerCase() ) {
              case 'lining_options':
                self.productData.pinch.lining_options = option;
                break;
              case 'express_manufacture':
                self.productData.pinch.express_manufacture = option;
                break;
            };
            if (option.type == 'H') {
              self.productData.hidden_options[option.label] = option.options[0].label;
            }
          });
          break;
        case 'DBLPIN':
          self.productData.dblpin = productData;
          product.product_options.forEach( function( option ) {
            switch ( option.label.toLowerCase() ) {
              case 'lining_options':
                self.productData.dblpin.lining_options = option;
                break;
              case 'express_manufacture':
                self.productData.dblpin.express_manufacture = option;
                break;
            };
            if (option.type == 'H') {
              self.productData.hidden_options[option.label] = option.options[0].label;
            }
          });
          break;
      }
    }
   

    this.updatePriceByChangedOption = function(selectedOptionName, selectedOptionValue) {
      var optionList = {
        lining_options: 'lining_option',
        express_manufacture: 'manufacture_option'
      };
      for ( var key in self.productData ) { 
        // loop by heading, "key" is heading name
        var productHeading = self.productData[ key ];
        var productHeadingPrice = productHeading.price;
        var productHeadingSalePrice = productHeading.sale_price;

        for (var productOptionsName in optionList) {
          if (!productHeading.hasOwnProperty(productOptionsName)) {
            continue;
          }
          var productOptions = productHeading[productOptionsName].options;
          var valueName = optionList[productOptionsName];
          if (selectedOptionName == valueName) {
            var optionValue = selectedOptionValue;
          } else if (persistentProductData.data.hasOwnProperty(valueName)) {
            optionValue = persistentProductData.data[valueName];
          } else {
            continue;
          }
          productOptions.forEach( function( option ) {
            if ( optionValue == option.label ) {
              if ( parseFloat( option.surcharge ) > 0 && 'percent' === option.type ) {
                productHeadingSalePrice = self.surchargePrice( ( null === productHeadingSalePrice ? convertPrice( productHeadingPrice ) : convertPrice( productHeadingSalePrice ) ), parseFloat( option.surcharge ) );
                productHeadingPrice = self.surchargePrice( productHeadingPrice, parseFloat( option.surcharge ) );
              } else {
                // absolute surcharge
                productHeadingSalePrice = ( null === productHeadingSalePrice ? parseFloat( productHeadingPrice ) : parseFloat( productHeadingSalePrice ) ) + parseFloat( option.surcharge );
                productHeadingPrice = parseFloat(productHeadingPrice) + parseFloat( option.surcharge );
              }
            }
          });
          
        }
        
        self.productData[ key ].active_sale_price = productHeadingSalePrice;
        self.productData[ key ].active_price = productHeadingPrice;
      }
    }

    this.triggerHeadingClick = function() {
      var heading = persistentProductData.data.heading;
      var target = null;
      if(heading == 'PEN') {
        target = 'pencil-pleat';
      } else if (heading == 'EYE') {
        target = 'eyelet';
      } else if (heading == 'DBLPIN') {
        target = 'dblpin';
      }
      setTimeout(function() {
        $("#cc-" + target).parent().find("label").trigger("click")
      },100);
    }
  };

  var convertPrice = function(price){
    return parseFloat(Math.round(price * 100) / 100).toFixed(2);
  };


  var roundTo = function(n, digits) {
    if (digits === undefined) {
      digits = 0;
    }
    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    var test =(Math.round(n) / multiplicator);
    return +(test.toFixed(digits));
  };

  var capitalizeFirstLetter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  (function( $j ){

    var productPricing = new productPriceApi();
    var terrysFabricCart = new terrysFabricAddToCart();

    $j(document).ready(function(){

      var productSku = shopifyProduct.sku,
          productBlock = '.buying-options-curtains'
      deliveryApi.init(productSku, productBlock);

      $j('.tf-variant-product .squared-price label').on( 'click touchstart', function(){
        var parentContainer = $j(this).closest('.tf-variant-product');
        var parentContainerType = parentContainer.attr('data-type');
        
        setTimeout(function(){
          persistentProductData.updateData();

          setCurtainLenghtDynamicText(parentContainerType);
          productPricing.product.fabric_widths = productPricing.productData[ parentContainerType ].fabric_widths;
          productPricing.product.widths_per_curtain = productPricing.productData[ parentContainerType ].widths_per_curtain;
        
          if ( 'eyelet' == parentContainerType ) {
            $j('.tf-eyelet-colors').show();
          } else {
            $j('.tf-eyelet-colors').hide();
          }

          if ( 'undefined' !== typeof productPricing.productData[ parentContainerType ].lining_options ) {
            $j('.tf-lining-options').fadeIn();
            $j('#tf-lo-container').html( productPricing.populateLiningOptionTemplate( productPricing.productData[ parentContainerType ].lining_options.options ) );
          } else {
            $j('.tf-lining-options').fadeOut();
          }

          // $j('#tf-lo-container .squaredThree').each(function(){

          //   var _this = $j(this);

          //   if ( $j(this).find('input').is(':checked') ) {
          //     var selectedLiningOption = $j(this).find('input').val();
          //     $j('#tf-lining-option').text('( '+selectedLiningOption+' Lining )');
          //     productPricing.updatePriceByChangedOption('lining_option', selectedLiningOption);
          //     productPricing.updateProductPrice();
          //     $("#klarna_pay_in_3").text("£" + (Math.floor((productPricing.productData[ parentContainerType ].active_sale_price) / 3 * 100) / 100).toFixed(2));
          //   }

          //   $j(this).find('label').on('click touchstart', function(){
          //     var selectedLiningOption = _this.find('input').val();
          //     $j('#tf-lining-option').text('( '+selectedLiningOption+' Lining )');
          //     productPricing.updatePriceByChangedOption('lining_option', selectedLiningOption);
          //     productPricing.updateProductPrice();
          //     persistentProductData.updateData();
          //   });
            
          // });

          var selectedLiningOption = $j('#tf-lining-option-select').find(":selected").val();
          productPricing.updatePriceByChangedOption('lining_option', selectedLiningOption);
          productPricing.updateProductPrice();
          persistentProductData.updateData();


          $j('#tf-lo-container').off('change').on('change', '#tf-lining-option-select', function(){
              var selectedLiningOption = $j(this).find(":selected").val();
              productPricing.updatePriceByChangedOption('lining_option', selectedLiningOption);
              productPricing.updateProductPrice();
              persistentProductData.updateData();
          })


          
          $j('#tf-mo-container .squaredThree').each(function(){

            var _this = $j(this);

            if ( $j(this).find('input').is(':checked') ) {
              var selectedManufactureOption = $j(this).find('input').val();
              productPricing.updatePriceByChangedOption('manufacture_option', selectedManufactureOption);
              productPricing.updateProductPrice();
              $("#klarna_pay_in_3").text("£" + (Math.floor((productPricing.productData[ parentContainerType ].active_sale_price) / 3 * 100) / 100).toFixed(2));
            }

            $j(this).find('label').on('click touchstart', function(){
              var selectedManufactureOption = _this.find('input').val();
              productPricing.updatePriceByChangedOption('manufacture_option', selectedManufactureOption);
              productPricing.updateProductPrice();
              persistentProductData.updateData();
            });
            
          });

        }, 10);
      });

      
      productPricing.init( function( data ){
        let headingsMap = [
          {
            label: "pencil",
            value: "PEN"
          },
          {
            label: "pinch",
            value: "PIN"
          },
          {
            label: "eyelet",
            value: "EYE"
          },
          {
            label: "dblpin",
            value: "DBLPIN"
          }
        ];
        let promoDiscount = 0;

        $(".selected-units").text(productPricing.product.units);
        $(".selected-width").text(productPricing.product.width_units);
        $(".selected-drop").text(productPricing.product.drop_units);

        var resetHeading = false;
        
        $j('.tf-variant-product').each(function(){

          var type = $j(this).attr('data-type');
          var heading = $j(this).attr('data-heading');

          if ( 'undefined' !== typeof productPricing.productData[ type ] && 'undefined' !== typeof productPricing.productData[ type ].active_price ) {

            if(typeof(productPricing.product.widths_per_curtain) === 'undefined') {
              productPricing.product.widths_per_curtain = productPricing.productData[ type ].widths_per_curtain;
            }
            $(".sidebar-widths-per-curtain-" + type).text(productPricing.productData[ type ].widths_per_curtain);
            var railWidth = productPricing.product.width;
            var totalWidths = productPricing.productData[ type ].widths_per_curtain * 2;
            var fabricWidth = parseFloat($(".sidebar-fabric-width").text());
            if (railWidth>0 && totalWidths>0 && fabricWidth>0) {
              var fullnessRatio = ( totalWidths * fabricWidth ) / railWidth;
              $(".sidebar-fullness-" + type).text(fullnessRatio.toFixed(2));
            } else {
              $(".sidebar-fullness-block-" + type).addClass("hidden");
            }

            setFirstCurtainLenghtDynamicText(type);
            // var oldPrice = productPricing.productData[ type ].active_price,
            //     newPrice = (productPricing.productData[ type ].active_sale_price).toFixed(2);

            let headingValue = headingsMap.find(({label}) => label === type).value;
            let headingData = data.data.find(({heading}) => headingValue === heading);

            let oldPrice = headingData.was_price;
            let newPrice = headingData.price;

            let thenPrice = headingData.then_price || null;

            if (parseFloat(headingData.promo_discount) > 0 && promoDiscount === 0) {
              promoDiscount = parseFloat(headingData.promo_discount);
            }

            $j(this).attr({
              'data-heading':productPricing.productData[ type ].heading
            });

            if ( oldPrice !== newPrice && typeof(oldPrice) !== 'undefined' ) {
              $j(this).find('.item-price-old del').text('£'+oldPrice);
            } else {
              $j(this).find('.item-price-old del').hide();
            }

            /* displaing third crossed out price */
            // let thenPriceHandler = $j(this).find('.item-price-then');
            // thenPriceHandler.hide();
            // if(thenPrice) {
            //   thenPriceHandler.children('del').text('£' + thenPrice);
            //   thenPriceHandler.show();
            // }

            $j(this).find('.item-price .price span.tf-price-value').text( '£' + newPrice );
            if(type == "pencil") {
                $("#klarna_pay_in_3").text("£" + (Math.floor(newPrice / 3 * 100) / 100).toFixed(2));
            }
            
            $j(this).find(' .squared-price .price').on('click touchstart', function(e){
              $j(this).parent().find('label').trigger('click');
              e.stopPropagation(); e.preventDefault();
            });

            
            $j(this).addClass('pc-heading-is-available');
            
            if (['eyelet','pencil'].includes(type)) {
              $j(this).find('.squared-price').removeClass('hidden');
              $j(this).find('.size-unavailable').addClass('hidden');
              $(this).find('.tfa-info-circle').removeClass('hidden');
              $(this).find('.item-image').css('cursor', 'pointer');
              $(this).find('.item-title').css('cursor', 'pointer');
            }
          } else {
            $j(this).removeClass('pc-heading-is-available');
            if (['eyelet','pencil'].includes(type)) {
              if (Object.keys(persistentProductData.data).length !== 0 && heading.toLowerCase() == persistentProductData.data.heading.toLowerCase()) {
                resetHeading = true;
              }
              $j(this).find('.squared-price').addClass('hidden');
              $j(this).find('.size-unavailable').removeClass('hidden');
              $(this).find('.tfa-info-circle').addClass('hidden');
              $(this).find('.item-image').css('cursor', 'auto');
              $(this).find('.item-title').css('cursor', 'auto');
            } else {
              resetHeading = true;
              $j(this).hide();
            }
          }
        });

        if (promoDiscount > 0) {
          $(".promo-discount-value").html(promoDiscount);
          $(".promo-discount").removeClass("hidden");
        } else {
          $(".promo-discount-value").html('');
          $(".promo-discount").addClass("hidden");
        }
        
        if (resetHeading || Object.keys(persistentProductData.data).length === 0) {
          setTimeout(function(){
            $j('.pc-heading-is-available').eq(0).find('label').trigger('click');
          }, 100);
        } else {
            if(persistentProductData.data.heading) {
              productPricing.triggerHeadingClick();
            }
        }
        
        // $j('.pc-heading-is-available').eq(0).find('input').trigger('click');
        if ( 'eye' === $j('.pc-heading-is-available').eq(0).attr('data-heading').toLowerCase() ) {
          $j('.tf-eyelet-colors').fadeIn();
        }

        $j('.product-price-options').fadeIn();
        $j('html, body').animate({
          scrollTop:($j('.buying-options-curtains').offset().top - $j("#StickyHeader").outerHeight())
        }, 800);

        // $j( '.tf-product-widths .product-price-wrap' ).hide();
        // $j('.tf-product-widths .tf-cp-heading').text('RE-CALCULATE PRICE');

        $j('.tf-product-widths').fadeOut();

      });

      $('.btn-recalculate').on('click', function(){
        $('#width').val('');
        $('#drop').val('');

        $('.product-price-options').fadeOut();
        $('.tf-product-widths').fadeIn(1000);
        $('html, body').animate({
          scrollTop:($('.buying-options-curtains').offset().top - $("#StickyHeader").outerHeight())
        }, 800);
        
      });

      terrysFabricCart.init( productPricing );

      $(".unit-radio").removeProp("checked");
      $("#unit-cm").prop("checked", true).trigger("click");

    });

  })(jQuery);


}
/* end buying options curtains */



/* blinds m2m */
if (buyingOptionsBlindsTemplate.toLowerCase() == "on") {
  $(document).ready(function() {
    var measurementUnitsSelector = 'input.unit-radio';
    var product_options = [];
    var productOptionsCost = [];
    var productPrice = 0;
    var measurementOption = '';
    localStorage.setItem('lastPriceCheck', 0);
    localStorage.setItem('lastWasPriceCheck', 0);
    localStorage.setItem('lastThenPriceCheck', 0);

    var productSku = shopifyProduct.sku,
        productBlock = '.buying-options-blinds';

    var productSizes = {
      widthMin: parseInt($('#cWidth').attr('data-min')),
      widthMax: parseInt($('#cWidth').attr('data-max')),
      dropMin: parseInt($('#cDrop').attr('data-min')),
      dropMax: parseInt($('#cDrop').attr('data-max'))
    }
    
    deliveryApi.init(productSku, productBlock);


    function updatePriceExt(event) {
      var productSku = $('#calculatePrice').attr('data-product-sku');
      var width = parseFloat($('#cWidth').val());
      var drop = parseFloat($('#cDrop').val());
      var selectedMeasurementUnit = $(measurementUnitsSelector + ":checked").val();
      var selectedMeasurementUnitFull = $(measurementUnitsSelector + ":checked").attr("data-full-name");
      
      measurementOption = $("input[name='measurement_option']:checked").val();
      
      if (selectedMeasurementUnit == 'in') {
        var widthInches = width;
        var dropInches = drop;

        var widthInchesFractionText = $(".width-fraction option:selected").text();
        var widthInchesFractionVal = $(".width-fraction option:selected").val();
        var dropInchesFractionText = $(".drop-fraction option:selected").text();
        var dropInchesFractionVal = $(".drop-fraction option:selected").val();

        var widthInchesText = width + (widthInchesFractionText=="0" ? "" : (" " + widthInchesFractionText));
        var widthInchesVal = parseFloat(width) + parseFloat(widthInchesFractionVal);
        var dropInchesText = drop + (dropInchesFractionText=="0" ? "" : (" " + dropInchesFractionText));
        var dropInchesVal = parseFloat(drop) + parseFloat(dropInchesFractionVal);

        var widthMinInchesText = $('#cWidth').attr('data-min-inch');
        var widthMaxInchesText = $('#cWidth').attr('data-max-inch');
        var dropMinInchesText = $('#cDrop').attr('data-min-inch');
        var dropMaxInchesText = $('#cDrop').attr('data-max-inch');
        var widthMinInchesVal = inchesStringToNumber(widthMinInchesText);
        var widthMaxInchesVal = inchesStringToNumber(widthMaxInchesText);
        var dropMinInchesVal = inchesStringToNumber(dropMinInchesText);
        var dropMaxInchesVal = inchesStringToNumber(dropMaxInchesText);

        width = in2cm(widthInchesVal, 1);
        drop = in2cm(dropInchesVal, 1);
      } else if (selectedMeasurementUnit == "mm") {
        var widthMm = width;
        var dropMm = drop;
        width = width / 10;
        drop = drop / 10;
      }

      var widthMin = productSizes.widthMin;
      var widthMax = productSizes.widthMax;
      var dropMin = productSizes.dropMin;
      var dropMax = productSizes.dropMax;

      $('#cWidth, #cDrop').removeClass( 'tf-error' );
      $('#cWidthInfo, #cDropInfo').html('');
      $('#input-number-error-message').html('');

      if (!width) {
        $('#cWidth').addClass( 'tf-error' );
        $('#cWidthInfo').html('Width is required');
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if (!drop) {
        $('#cDrop').addClass( 'tf-error' );
        $('#cDropInfo').html('Drop is required');
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if ( ! /^\d+\.?\d*$/.test($('#cWidth').val()) ) {
        $('#cWidth').addClass( 'tf-error' );
        $('#cWidthInfo').text('Ooops, please enter numbers only' );
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if ( ! /^\d+\.?\d*$/.test($('#cDrop').val()) ) {
        $('#cDrop').addClass( 'tf-error' );
        $('#cDropInfo').text('Ooops, please enter numbers only' );
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if ( /^\d*\.\d{2,}$/.test($('#cWidth').val()) && selectedMeasurementUnit == 'cm') {
        $('#cWidth').addClass( 'tf-error' );
        $('#cWidthInfo').text('Ooops, Measurements must be ' + selectedMeasurementUnitFull + ' (to a max of one decimal place)' );
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if ( /^\d*\.\d{2,}$/.test($('#cDrop').val()) && selectedMeasurementUnit == 'cm') {
        $('#cDrop').addClass( 'tf-error' );
        $('#cDropInfo').text('Ooops, Measurements must be ' + selectedMeasurementUnitFull + ' (to a max of one decimal place)' );
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if ( /^\d*\.\d*$/.test($('#cWidth').val()) && selectedMeasurementUnit !== 'cm') {
        $('#cWidth').addClass( 'tf-error' );
        $('#cWidthInfo').text('Ooops, Measurements must be in whole ' + selectedMeasurementUnitFull );
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if ( /^\d*\.\d*$/.test($('#cDrop').val()) && selectedMeasurementUnit !== 'cm') {
        $('#cDrop').addClass( 'tf-error' );
        $('#cDropInfo').text('Ooops, Measurements must be in whole' + selectedMeasurementUnitFull );
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if (width && width < widthMin && selectedMeasurementUnit == 'cm') {
        $('#cWidth').addClass( 'tf-error' );
        $('#cWidthInfo').html('Min width is ' + widthMin + ' ' + selectedMeasurementUnitFull);
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if (width && width > widthMax && selectedMeasurementUnit == 'cm') {
        $('#cWidth').addClass( 'tf-error' );
        $('#cWidthInfo').html('Max width is ' + widthMax + ' ' + selectedMeasurementUnitFull);
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if (drop && drop < dropMin && selectedMeasurementUnit == 'cm') {
        $('#cDrop').addClass( 'tf-error' );
        $('#cDropInfo').html('Min drop is ' + dropMin + ' ' + selectedMeasurementUnitFull);
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if (drop && drop > dropMax && selectedMeasurementUnit == 'cm') {
        $('#cDrop').addClass( 'tf-error' );
        $('#cDropInfo').html('Max drop is ' + dropMax + ' ' + selectedMeasurementUnitFull);
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if (widthInchesVal && widthInchesVal < widthMinInchesVal && selectedMeasurementUnit == 'in') {
        $('#cWidth').addClass( 'tf-error' );
        $('#cWidthInfo').html('Min width is ' + widthMinInchesText + ' ' + selectedMeasurementUnitFull);
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if (widthInchesVal && widthInchesVal > widthMaxInchesVal && selectedMeasurementUnit == 'in') {
        $('#cWidth').addClass( 'tf-error' );
        $('#cWidthInfo').html('Max width is ' + widthMaxInchesText + ' ' + selectedMeasurementUnitFull);
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if (dropInchesVal && dropInchesVal < dropMinInchesVal && selectedMeasurementUnit == 'in') {
        $('#cDrop').addClass( 'tf-error' );
        $('#cDropInfo').html('Min drop is ' + dropMinInchesText + ' ' + selectedMeasurementUnitFull);
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else if (dropInchesVal && dropInchesVal > dropMaxInchesVal && selectedMeasurementUnit == 'in') {
        $('#cDrop').addClass( 'tf-error' );
        $('#cDropInfo').html('Max drop is ' + dropMaxInchesText + ' ' + selectedMeasurementUnitFull);
        $('#cAddToBasket').attr('disabled', 'disabled');
      } else {
        $(".selected-units").text(selectedMeasurementUnit);
        if (selectedMeasurementUnit == 'in') {
          $("#selectedWidth").text(widthInchesText);
          $("#selectedDrop").text(dropInchesText);
        } else if (selectedMeasurementUnit == 'mm'){
          $("#selectedWidth").text(widthMm);
          $("#selectedDrop").text(dropMm);
        } else {
          $("#selectedWidth").text(width);
          $("#selectedDrop").text(drop);
        }
        
        $("#selectedMeasurementOption").text(measurementOption);
        
        productOptionsCost = [];
        $('#step2').removeClass('hidden');
        $('html, body').animate({
          scrollTop: ($('.product-detail-inner').offset().top - $("#StickyHeader").outerHeight())
        }, 800);
        $('.step2').css('display', 'block');
        // $("#step1 .price").addClass("hidden");
        $("#step1").addClass("hidden");
        $(".calculate").blur();
        var productData = {
          product_type: "blind",
          sku: productSku,
          width: width,
          drop: drop
        }
        if (selectedMeasurementUnit == 'in') {
          productData.width_inches = widthInchesText;
          productData.drop_inches = dropInchesText;
        } else if (selectedMeasurementUnit == 'mm') {
          productData.width_mm = widthInchesText;
          productData.drop_mm = dropInchesText;
        }
        $.post(`${m2mBaseApiUrl}/price`, productData, function(response) {
          if (response.status > 0) {
            $('.cTotal').html('&pound;' + priceFormat(response.data.price * parseInt($('#cQuantity').val())));
            $('.cTotal').attr("id", priceFormat(response.data.price * parseInt($('#cQuantity').val())));
            
            if (response.data.was_price && response.data.discount) {
              $('.wasPrice del').html('&pound;' + response.data.was_price);
              $('.wasPrice del').attr("id", response.data.was_price);
            }

            if(response.data.then_price) {
              $('.thenPrice del').attr('id', response.data.then_price).html('&pound;' + response.data.then_price)
            }

            if (response.data.promo_discount) {
              var promoDiscount = parseFloat(response.data.promo_discount);
              if (promoDiscount > 0) {
                $(".promo-discount-value").html(promoDiscount);
                $(".promo-discount").removeClass("hidden");
              } else {
                $(".promo-discount-value").html('');
                $(".promo-discount").addClass("hidden");
              }
            }

            $('.product-price-wrap').hide();
            localStorage.setItem('lastPriceCheck', response.data.price);
            localStorage.setItem('lastWasPriceCheck', response.data.was_price);
            localStorage.setItem('lastThenPriceCheck', response.data.then_price || 0);

            productPrice = response.data.price;
            productWasPrice = response.data.was_price;
            productThenPrice = response.data.then_price;
            $('#cAddToBasket').removeClass('hidden');

            if (response.data.product_options) {
              product_options = response.data.product_options;
              var options = '<h4 style="margin: 5px 0px 20px -20px; color: #888888; text-align: center;">Select your fitting options:</h4>';
              $.each(response.data.product_options, function(index, item) {
                if (item.type == 'Y') {
                  if (item.label == 'MEASUREMENT_OPTIONS') {
                    // measurement option got entered on first step
                    // so filling productOptionsCost and continue with other options
                    productOptionsCost[index] = {
                      type: 'Y',
                      surcharge: '0.00',
                      index: index,
                      label: measurementOption,
                      title: item.label
                    };
                    return;
                  }
                  options += '<h4 style="margin: 0px 0px 8px 20px">' + item.name + '<span title="' + item.name + '" onclick="PopupSideBar(\'' + item.help_resource +'\')">' +
                      ' <span class="more-info-link">Product info</span>' +
                      '</span></h4>';
                  options += '<div class="product-options" style="margin: 0px 0px 5px 20px;">';
                  if (item.options.length <= 0) {
                    $.each(item.options, function(i, o) {
                      options += '<span data-option-type="' + o.type + '" data-option-surcharge="' + o.surcharge + '" data-option-label="' + o.label + '" data-option-title="' + item.label +
                          '" data-option-index="' + index + '">' + o.label;
                      if (o.surcharge != '0' && o.surcharge != '0.00') {
                        if (o.type == 'absolute') {
                          options += ' (+ &pound;' + parseFloat(o.surcharge).toFixed(2) + ')';
                        } else if (o.type == 'percent') {
                          options += ' (' + parseFloat(o.surcharge) + '% Surcharge)';
                        }
                      }
                      options += '</span>';
                    });
                  } else {
                    options += '<div class="styled-select slate"><select>';
                    $.each(item.options, function(i, o) {
                      if (measurementOption.toLowerCase().lastIndexOf('actual', 0) === 0 
                        && item.name.toLowerCase() === 'system'
                        && o.label.toLowerCase().lastIndexOf('no drill', 0) === 0
                      ) {
                        //selected measurement option starts with 'actual' and option set is 'Sysytem' and option is 'No drill...'
                        return; //then continue
                      }
                      options += '<option data-option-type="' + o.type + '" data-option-surcharge="' + o.surcharge + '" data-option-label="' + o.label + '" data-option-title="' + item.label +
                          '" data-option-index="' + index + '"';
                      if (i < 1) {
                        options += ' selected="selected"';
                      }
                      options += '>' + o.label;
                      if (o.surcharge != '0' && o.surcharge != '0.00') {
                        if (o.type == 'absolute') {
                          options += ' (+ &pound;' + parseFloat(o.surcharge).toFixed(2) + ')';
                        } else if (o.type == 'percent') {
                          options += ' (' + parseFloat(o.surcharge) + '% Surcharge)';
                        }
                      } else {
                        if (item.label == 'LINING_OPTIONS' && ['Blinds-M2M-Roman', 'Curtains-M2M-Wave'].includes(shopifyProduct.type)) {
                          var searchOptionParam = 'blackout';
                          if (o.label.toLowerCase().includes(searchOptionParam)) {
                            options += ' - FREE UPGRADE';
                          }
                        }
                      }
                      options += '</option>';
                    });
                    options += '</select></div>';
                  }
                  options += '</div>';
                }
                if (item.type == 'A' || item.type == 'T') {
                  var limitChars = parseInt(item.name.replace(/.*\((\d+).*\)$/, "$1"));
                  var limitText = limitChars > 0 ? " maxlength='" + limitChars + "'" : "";
                  options += '<h4 style="margin: 0px 0px 8px 20px">' + item.name + '<span title="' + item.name + '" onclick="PopupSideBar(\'' + item.help_resource +'\')">' +
                      ' <span class="more-info-link">Product info</span>' +
                      '</span></h4>';
                  options += '<div class="product-options" style="margin: 0px 0px 5px 20px;">';
                  options += '<textarea rows="2" class="option-typeA" data-option-type="' + item.type + '"  data-option-surcharge="0.00" data-option-title="' + item.label +
                      '" data-option-label="" data-option-index="' + index + '"' + limitText + '></textarea>';
                  options += '</div>';
                }

                if (item.type == 'H') {
                  productOptionsCost[index] = {
                    type: 'H',
                    surcharge: '0.00',
                    index: index,
                    label: item.options[0].label,
                    title: item.label
                  }
                }

              });
              $('#step2 .step2-container').html(options);
              if (response.data.product_options.length == 0) {
                $('#cAddToBasket').attr('disabled', false);
              }
              initializeOptions();
            } else {
              $('#cAddToBasket').attr('disabled', false);
            }
          } else {
            console.log(response.error_message);
          }
        });
      }
    }

    function updatePriceOptions() {
      var qty = parseInt($('#cQuantity').val());
      var price = parseFloat(localStorage.getItem('lastPriceCheck'));
      var wasPrice = parseFloat(localStorage.getItem('lastWasPriceCheck'));
      var thenPrice = parseFloat(localStorage.getItem('lastThenPriceCheck'));
      $.each(productOptionsCost, function(i, o) {
        if (typeof o !== 'undefined' && o.type && o.type == 'absolute') {
          if (o.surcharge != '0') {
            price = price + parseFloat(o.surcharge);
            if (wasPrice > 0) {
              wasPrice = wasPrice + parseFloat(o.surcharge);
            }
            if(thenPrice > 0) {
              thenPrice += parseFloat(o.surcharge);
            }
          }
        } else if (typeof o !== 'undefined' && o.type && o.type == 'percent') {
          if (o.surcharge != '0') {
            price = price + (parseFloat(o.surcharge) / 100 * productPrice);
            if (wasPrice > 0) {
              wasPrice = wasPrice + (parseFloat(o.surcharge) / 100 * productWasPrice);
            }
            if(thenPrice > 0) {
              thenPrice += (parseFloat(o.surcharge) / 100 * productThenPrice);
            }
          }
        }
      });
      $('.cTotal').html('&pound;' + priceFormat(price * qty));
      $('.cTotal').attr("id", priceFormat(price * qty));
      if (wasPrice > 0) {
        $('.wasPrice del').html('&pound;' + priceFormat(wasPrice * qty));
        $('.wasPrice del').attr("id", priceFormat(wasPrice * qty));
      }
      if(thenPrice > 0) {
        $('.thenPrice del').html('&pound;' + priceFormat(thenPrice * qty));
        $('.thenPrice del').attr("id", priceFormat(thenPrice * qty));
      }

      // Dynamic discount percentage (percentage on inside of discount circle changes when a different M2M option is selected)

      var actual_price = $('.cTotal').attr('id');;
      var rrp_price = $('.wasPrice del').attr('id');

      //temporarily disabled updating discount circle
      /*
      var updated_discount_circle_value = actual_price / rrp_price;
      updated_discount_circle_value = 1 - updated_discount_circle_value;
      updated_discount_circle_value = updated_discount_circle_value * 100;
      updated_discount_circle_value = Math.floor(updated_discount_circle_value);
      updated_discount_circle_value = updated_discount_circle_value.toFixed(0);
      if(updated_discount_circle_value < 1) {
        $("#image_discount_circle").hide();
      } else {
        if(isNaN(updated_discount_circle_value) == false) {
          $("#discount-from-price").text(updated_discount_circle_value + "%");
        }
        $("#image_discount_circle").show();
      }
      */
      
      var price_in_3 = (Math.floor(priceFormat(price * qty).replace(/\u00A3/g, '') / 3 * 100) / 100).toFixed(2); // Klarna price in 3
      $('#klarna_blinds').html('&pound;' + price_in_3);

      var vipPriceElement = document.querySelector(".klarna_accent .vip-price");
      if (vipPriceElement != null) {
        vipPriceElement.innerHTML = "£" + (Math.floor((price * qty) * 100) / 100).toFixed(2);
      }

      if (product_options.length == productOptionsCost.length) {
        var enabled = true;
        $.each(productOptionsCost, function(i, o) {
          if (typeof o !== 'undefined' && !o.index && o.index !== 0) {
            enabled = false;
          }
        });
        $('#cAddToBasket').attr('disabled', !enabled);
      }
    }

    $('input[type="number"]').on("keydown", function(e) {
      if (e.keyCode === 13 || e.which === 13){
        e.preventDefault();
        updatePriceExt(e);
        return;
      }
    });

    $(document).on('click', '.product-options span', function() {
      $(this).siblings('span').removeClass('selected');
      $(this).addClass('selected');
      for (var i = 0; i < parseInt($(this).attr('data-option-index')); i++) {
        if (typeof productOptionsCost[i] === 'undefined' || !productOptionsCost[i]) {
          productOptionsCost[i] = {};
        }
      }
      productOptionsCost[$(this).attr('data-option-index')] = {
        type: $(this).attr('data-option-type'),
        surcharge: $(this).attr('data-option-surcharge'),
        index: $(this).attr('data-option-index'),
        label: $(this).attr('data-option-label'),
        title: $(this).attr('data-option-title')
      };
      $('.styled-select').each(function() {
        productOptionsCost[$(this).find(':selected').attr('data-option-index')] = {
          type: $(this).find(':selected').attr('data-option-type'),
          surcharge: $(this).find(':selected').attr('data-option-surcharge'),
          index: $(this).find(':selected').attr('data-option-index'),
          label: $(this).find(':selected').attr('data-option-label'),
          title: $(this).find(':selected').attr('data-option-title')
        };
      });
      updatePriceOptions();
    });
    
    $(document).on('change', '.option-typeA', function() {
      productOptionsCost[$(this).attr('data-option-index')] = {
        type: $(this).attr('data-option-type'),
        surcharge: $(this).attr('data-option-surcharge'),
        index: $(this).attr('data-option-index'),
        label: $(this).val(),
        title: $(this).attr('data-option-title')
      };
      $('.styled-select').each(function() {
        productOptionsCost[$(this).find(':selected').attr('data-option-index')] = {
          type: $(this).find(':selected').attr('data-option-type'),
          surcharge: $(this).find(':selected').attr('data-option-surcharge'),
          index: $(this).find(':selected').attr('data-option-index'),
          label: $(this).find(':selected').attr('data-option-label'),
          title: $(this).find(':selected').attr('data-option-title')
        };
      });
      updatePriceOptions();
    });
    
    $(document).on('change', '.styled-select', function() {
      productOptionsCost[$(this).find(':selected').attr('data-option-index')] = {
        type: $(this).find(':selected').attr('data-option-type'),
        surcharge: $(this).find(':selected').attr('data-option-surcharge'),
        index: $(this).find(':selected').attr('data-option-index'),
        label: $(this).find(':selected').attr('data-option-label'),
        title: $(this).find(':selected').attr('data-option-title')
      };
      updatePriceOptions();
    });

    $(document).on('click', measurementUnitsSelector, function() {
      var unit = $(measurementUnitsSelector + ":checked").val();
      $('.unit-label').text(unit);
      if (unit == 'in') {
        $('.width-selector').each(function () {
          $(".inch-fractions").removeClass("hidden");
          //placeholder and value
          if (typeof $(this).attr("data-min-inch") === 'undefined' || parseFloat($(this).attr("data-min-inch")) <= 0) {
            var minIn = cm2in($(this).attr("data-min"), 'largest');
            $(this).attr("data-min-inch", minIn);
          }
          if (typeof $(this).attr("data-max-inch") === 'undefined' || parseFloat($(this).attr("data-max-inch")) <= 0) {
            var maxIn = cm2in($(this).attr("data-max"), 'lowest');
            $(this).attr("data-max-inch", maxIn);
          }
          $(this).attr("placeholder", $(this).attr("data-min-inch") + " - " + $(this).attr("data-max-inch"));

          if ($(this).val() > 0) {
            $(this).val("");
            $(this).parent().children(".inch-fractions").val("0").change();
          }
          
        });
      } else if (unit == "mm") {
        $(".inch-fractions").addClass("hidden");
          $('.width-selector').each(function(){
            $(this).attr("placeholder", $(this).attr("data-min")*10 + " - " + $(this).attr("data-max")*10 );
            if ($(this).val() > 0) {
              $(this).val("");
            }
          });

      } else {
        // unit == "cm"
        $(".inch-fractions").addClass("hidden");
        $('.width-selector').each(function(){
          $(this).attr("placeholder", $(this).attr("data-min") + " - " + $(this).attr("data-max") );
          if ($(this).val() > 0) {
            $(this).val("");
          }
        });
      }

    });

    function initializeOptions() {
      $('.styled-select').each(function() {
        productOptionsCost[$(this).find(':selected').attr('data-option-index')] = {
          type: $(this).find(':selected').attr('data-option-type'),
          surcharge: $(this).find(':selected').attr('data-option-surcharge'),
          index: $(this).find(':selected').attr('data-option-index'),
          label: $(this).find(':selected').attr('data-option-label'),
          title: $(this).find(':selected').attr('data-option-title')
        };
      });
      updatePriceOptions();
    }

    function updatePriceLoc() {
      var lastPriceCheck = localStorage.getItem('lastPriceCheck');
      var qty = parseInt($('#cQuantity').val());
      $('.cTotal').html('&pound;' + priceFormat(lastPriceCheck * qty));
    }

    function cAddToBasket() {
      $('.AddToCartText').html('working...');
      var productId = shopifyProduct.id;
      var productSku = shopifyProduct.sku;
      var width = $('#cWidth').val();
      var drop = $('#cDrop').val();
      var quantity = $('#cQuantity').val();

      var payload = {
        service: "TF",
        product_type: "blind",
        product_id: productId,
        product_code: productSku,
        width: width,
        drop: drop,
        quantity: quantity,
        product_options: productOptionsCost
      };
      
      var selectedMeasurementUnit = $(measurementUnitsSelector + ":checked").val();
      var measurementProps = {};
      if (selectedMeasurementUnit == 'in') {
        var widthInches = width;
        var dropInches = drop;

        var widthInchesFractionText = $(".width-fraction option:selected").text();
        var widthInchesFractionVal = $(".width-fraction option:selected").val();
        var dropInchesFractionText = $(".drop-fraction option:selected").text();
        var dropInchesFractionVal = $(".drop-fraction option:selected").val();

        var widthInchesText = width + (widthInchesFractionText=="0" ? "" : (" " + widthInchesFractionText));
        var widthInchesVal = parseFloat(width) + parseFloat(widthInchesFractionVal);
        var dropInchesText = drop + (dropInchesFractionText=="0" ? "" : (" " + dropInchesFractionText));
        var dropInchesVal = parseFloat(drop) + parseFloat(dropInchesFractionVal);

        payload.width = in2cm(widthInchesVal, 1);
        payload.drop = in2cm(dropInchesVal, 1);
        payload.width_inches = widthInchesText;
        payload.drop_inches = dropInchesText;
        measurementProps.width_inches = widthInchesText;
        measurementProps.drop_inches = dropInchesText;
      } else if (selectedMeasurementUnit == "mm") {
        var widthMm = width;
        var dropMm = drop;
        payload.width = width / 10;
        payload.drop = drop / 10;
        payload.width_mm = widthMm;
        payload.drop_mm = dropMm;
        measurementProps.width_mm = widthMm;
        measurementProps.drop_mm = dropMm;
      }
      
      $.post(`${m2mBaseApiUrl}/add`, payload, function(response) {

        payload.img = featuredImage;
        localStorage.setItem('variant_' + response.data.variant.id, JSON.stringify(payload));
        localStorage.setItem('options_' + response.data.variant.id, JSON.stringify(productOptionsCost));

        var props = {
          'Width': payload.width,
          'Drop': payload.drop
        };
        $.each(productOptionsCost, function(index, item) {
          props[item.title] = item.label
        });

        if ($("#preorder-advice-property").length > 0) {
          props["_Preorder-Advice"] = $("#preorder-advice-property").val();
        }

        for (var prop in measurementProps) {
          props[prop] = measurementProps[prop];
        }
        
        if (typeof response.data.related_options !== 'undefined' && response.data.related_options.length > 0) {
          for ( var i = 0; i < response.data.related_options.length; i++ ) {
            var ro = response.data.related_options[i];
            if (typeof ro['label'] !== 'undefined' && ro['label'].length > 0 && typeof ro['value'] !== 'undefined' && ro['value'].length > 0) {
              props[ ro['label'] ] = ro['value'];
            }
          }
        }

        let possibleKeys = ['discount', 'was_price', 'promo_discount', 'then_price'];
        for(let key of possibleKeys) {
          if(response.data.variant[key]) {
            props['_' + key] = response.data.variant[key];
          }
        }

        jQuery.post(
            '/cart/add.js', {
              quantity: quantity,
              id: response.data.variant.id,
              properties: props
            },

            function(res) {
              var _config = {
                shopifyAjaxCartURL: "/cart.js",
                cartCountSelector: ".cart-count",
                cartTotalSelector: "#cart-price"
              };
              $.getJSON(_config.shopifyAjaxCartURL, function(cart) {
                if (_config.cartCountSelector && $(_config.cartCountSelector).size()) {
                  var value = $(_config.cartCountSelector).html() || '0';
                  $(_config.cartCountSelector).html(value.replace(/[0-9]+/, cart.item_count)).removeClass('hidden-count');
                }
                if (_config.cartTotalSelector && $(_config.cartTotalSelector).size()) {
                  if (typeof Currency !== 'undefined' && typeof Currency.moneyFormats !== 'undefined') {
                    var newCurrency = '';
                    if ($('[name="currencies"]').size()) {
                      newCurrency = $('[name="currencies"]').val();
                    } else if ($('#currencies span.selected').size()) {
                      newCurrency = $('#currencies span.selected').attr('data-currency');
                    }
                    if (newCurrency) {
                      $(_config.cartTotalSelector).html('<span class=money>' + Shopify.formatMoney(Currency.convert(cart.total_price, shopCurrency, newCurrency), Currency.money_format[newCurrency]) + '</span>');
                    } else {
                      $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, shopMoneyFormat));
                    }
                  } else {
                    $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, shopMoneyFormat));
                  }
                };
                toggleBasketModal();
              });
            },
            'json'
        );

        $('#CartCount').text(parseInt($('#CartCount').text()) + 1);
        $('.AddToCartText').html('Item added');
//         $('#cAddToBasket').attr('disabled', 'disabled');
      });
    }

    function cAddToBasketDirectly() {
      jQuery.post('/cart/add.js', {
        quantity: 1,
        id: productOrg.variants[0].id
      });
      $('.AddToCartText').html('Product added');
      $('#cAddToBasketDirectly').attr('disabled', 'disabled');
    }

    $('#productSizes').on('keydown', '#cWidth, #cDrop, #cQuantity', function(e) {
      -1 !== $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) || /65|67|86|88/.test(e.keyCode) && (!0 === e.ctrlKey || !0 === e.metaKey) || 35 <= e.keyCode && 40 >= e.keyCode || (e.shiftKey || 48 > e.keyCode || 57 < e.keyCode) &&
      (96 > e.keyCode || 105 < e.keyCode) && e.preventDefault()
    });

    $(document).on('click', '#calculatePrice', function(e) {
      updatePriceExt(e);
    });

    $(document).on('click', '#cAddToBasket', function() {
      cAddToBasket();
    });
    $(document).on('click', '#cAddToBasketDirectly', function() {
      cAddToBasketDirectly();
    });

    $("#step1 input").keyup(function(event) {
      if (event.keyCode === 13) {
        $("#calculatePrice").trigger("click");
        event.preventDefault();
      }
    });

    $(".unit-radio").removeProp("checked");
    $("#unit-cm").prop("checked", true).trigger("click");
  });

  var priceFormat = function(total) {
    return parseFloat(total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
  }



  var selectCallback = function(variant, selector) {
    var addToCart = $("#AddToCart"),
        productPrice = $(".product-right-column #ProductPrice"),
        comparePrice = $(".product-right-column .price-product-detail .old-price");

    if (variant) {
      if (variant.available) {
        addToCart.removeClass('disabled').removeAttr('disabled');
        $(addToCart).find("span").text(productsSettings.addToCart);
      } else {
        addToCart.addClass('disabled').attr('disabled', 'disabled');
        $(addToCart).find("span").text(productsSettings.sold_out);
      }
      productPrice.html(Shopify.formatMoney(variant.price, shopMoneyFormat));
      if (variant.compare_at_price > variant.price) {
        productPrice.addClass("sale-price")
        comparePrice
            .html(Shopify.formatMoney(variant.compare_at_price, shopMoneyFormat))
            .show();
      } else {
        comparePrice.hide();
        productPrice.removeClass("sale-price");
      }
      var form = $('#' + selector.domIdPrefix).closest('form');
      for (var i = 0, length = variant.options.length; i < length; i++) {
        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
        if (radioButton.size()) {
          radioButton.get(0).checked = true;
        }
      }
      //     updatePricing();

      if (shopifySettings['enable_multiple_currencies']) {
        Currency.convertAll(shopCurrency, $('#currencies').val(), 'span.money', 'money_format');
      }

      if (variant.available) {
        $('.product .availability').html("<p class='available instock'>" + productsSettings.available + "</p>");
      } else {
        $('.product .availability').html("<p class='available outstock'>" + productsSettings.unavailable + "</p>");
      }
    } else {
      addToCart.addClass('disabled').attr('disabled', 'disabled');
      $(addToCart).find("span").text(productsSettings.unavailable);
    }

    if (variant && variant.featured_image) {
      var originalImage = $("#view_full_size img");
      var newImage = variant.featured_image;
      var element = originalImage[0];
      Shopify.Image.switchImage(newImage, element, function(newImageSizedSrc, newImage, element) {
        $('#thumbs_list img').each(function() {
          var parentThumbImg = $(this).parent();
          var idProductImage = $(this).parent().data("imageid");
          if (idProductImage == newImage.id) {
            $(this).parent().trigger('click');
            return false;
          }
        });
      });
    }
  }

      $('.btn-recalculate').on('click', function(){
        $('#cWidth').val('');
        $('#cDrop').val('');
        
        $('html, body').animate({
          scrollTop: ($('.product-detail-inner').offset().top - $("#StickyHeader").outerHeight())
        }, 800);
        $('#step2').addClass('hidden');
        $('#step1').removeClass('hidden');        
      });

  
}
/* end blinds m2m */







$(document).ready(function() {
  $('input[type="number"]')
      .on("keydown", function(e) {

        // Allow: backspace, delete, tab, escape, enter, both dots, ctrl, shift, alt
        var allowedCodes = [46, 8, 9, 27, 13, 17, 16, 18];
        if ($(this).parents(".blinds_quote_boxes").length) {
          // adding dots for decimals only for blinds
          allowedCodes = allowedCodes.concat([110,190]);
        }
        if ($.inArray(e.keyCode, allowedCodes) !== -1 ||
            // Allow: Ctrl+A,Ctrl+C,Ctrl+V, Command+A
            ((e.keyCode == 65 || e.keyCode == 86 || e.keyCode == 67) && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
          // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if ($(this).parents(".curtains_quote_boxes").length && $.inArray(e.keyCode, [110,190]) !== -1) {
          $(this).closest('div').find('#input-number-error-message, .input-number-error-message').text("Ooops, measurements must be in whole centimetres");
          e.preventDefault();
        } else if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          $(this).closest('div').find('#input-number-error-message, .input-number-error-message').text("Ooops, please enter numbers only");
          e.preventDefault();
        } else {
          $(this).closest('div').find('#input-number-error-message, .input-number-error-message').text("");
        }
      })
      .on("paste", function(e) {
        var clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
        var pastedData = clipboardData.getData('text');
        $(this).closest('div').find('#input-number-error-message, .input-number-error-message').text("");
        var numbersPattern = /^\d+\.?\d*$/;
        if ($(this).parents(".curtains_quote_boxes").length) {
          //dot is not allowed for curtains
          numbersPattern = /^\d+$/;
        }
        if ( ! numbersPattern.test(this.value + pastedData) ) {
          $(this).closest('div').find('#input-number-error-message, .input-number-error-message').text("Ooops, please enter numbers only");
          e.preventDefault();
        }
      })
      .on("input", function(e){
        var decimalsPattern = /^\d+\.\d{2,}$/,
            substrDotOffset = 2,
            errorMessage = "Ooops, Measurements must be centimetres (to a max of one decimal place)";
        if ($(this).parents(".curtains_quote_boxes").length) {
          //dot is not allowed for curtains
          decimalsPattern = /^\d+\.\d*$/;
          substrDotOffset = 0;
          errorMessage = "Ooops, Measurements must be in whole centimetres";
        }
        if (decimalsPattern.test(this.value)) {
          this.value = this.value.substr(0, this.value.indexOf(".") + substrDotOffset);
          $(this).closest('div').find('#input-number-error-message, .input-number-error-message').text(errorMessage);
          e.preventDefault();
        }
      });
});






/* js-ajax-cart.js */
/**
 * Module to ajaxify all add to cart forms on the page.
 *
 * Copyright (c) 2015 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
Shopify.AjaxifyCart = (function($) {

  // Some configuration options.
  // I have separated what you will never need to change from what
  // you might change.

  var _config = {

    // What you might want to change
    addToCartBtnLabel:             'Add to basket',
    addedToCartBtnLabel:           'Item added!',
    addingToCartBtnLabel:          'Adding...',
    soldOutBtnLabel:               'Sold Out',
    howLongTillBtnReturnsToNormal: 1000, // in milliseconds.
    cartCountSelector:             '.cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count',
    cartTotalSelector:             '.cart-price, #cart-price',
    // 'aboveForm' for top of add to cart form,
    // 'belowForm' for below the add to cart form, and
    // 'nextButton' for next to add to cart button.
    feedbackPosition:              'nextButton',

    // What you will never need to change
    addToCartBtnSelector:          '[type="submit"]',
    addToCartFormSelector:         'form[action="/cart/add"]',
    shopifyAjaxAddURL:             '/cart/add.js',
    shopifyAjaxCartURL:            '/cart.js'
  };

  // We need some feedback when adding an item to the cart.
  // Here it is.
  var _showFeedback = function(success, html, $addToCartForm) {
    $('.ajaxified-cart-feedback').remove();
    var feedback = '';
    switch (_config.feedbackPosition) {
      case 'aboveForm':
        $addToCartForm.before(feedback);
        break;
      case 'belowForm':
        $addToCartForm.after(feedback);
        break;
      case 'nextButton':
      default:
        $addToCartForm.find(_config.addToCartBtnSelector).after(feedback);
        break;
    }
    // If you use animate.css
    // $('.ajaxified-cart-feedback').addClass('animated bounceInDown');
    $('.ajaxified-cart-feedback').slideDown();
  };
  var _setText = function($button, label) {
    $button.html(label);
  };
  var _init = function() {
    $(document).ready(function() {
      $(document).off('submit', _config.addToCartFormSelector).on('submit', _config.addToCartFormSelector, function(e) {
        e.preventDefault();
        var $addToCartForm = $(this);
        var $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
        var $addToCartBtnOriginalText = $addToCartBtn.html();
        _setText($addToCartBtn, _config.addingToCartBtnLabel);
        $addToCartBtn.addClass('disabled').prop('disabled', true);
        // Add to cart.
        $.ajax({
          url: _config.shopifyAjaxAddURL,
          dataType: 'json',
          type: 'post',
          data: $addToCartForm.serialize(),
          success: function(itemData) {
            // Re-enable add to cart button.
            $addToCartBtn.addClass('inverted');
            _setText($addToCartBtn, _config.addedToCartBtnLabel);
            _showFeedback('success','<i class="tfa tfa-check"></i> Added to cart! <a href="/cart">View cart</a> or <a href="/collections/all">continue shopping</a>.',$addToCartForm);
            window.setTimeout(function(){
              $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
              _setText($addToCartBtn,$addToCartBtnOriginalText);
            }, _config.howLongTillBtnReturnsToNormal);
            // Update cart count and show cart link.
            $.getJSON(_config.shopifyAjaxCartURL, function(cart) {
              if (_config.cartCountSelector && $(_config.cartCountSelector).size()) {
                var value = $(_config.cartCountSelector).html() || '0';
                $(_config.cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count)).removeClass('hidden-count');
              }
              if (_config.cartTotalSelector && $(_config.cartTotalSelector).size()) {
                if (typeof Currency !== 'undefined' && typeof Currency.moneyFormats !== 'undefined') {
                  var newCurrency = '';
                  if ($('[name="currencies"]').size()) {
                    newCurrency = $('[name="currencies"]').val();
                  }
                  else if ($('#currencies span.selected').size()) {
                    newCurrency = $('#currencies span.selected').attr('data-currency');
                  }
                  if (newCurrency) {
                    $(_config.cartTotalSelector).html('<span class=money>' + Shopify.formatMoney(Currency.convert(cart.total_price, shopCurrency, newCurrency), Currency.money_format[newCurrency]) + '</span>');
                  }
                  else {
                    $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, shopMoneyFormat));
                  }
                }
                else {
                  $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, shopMoneyFormat));
                }
              };

              if (document.querySelector('.terrys-basket-modal').classList.contains('mod-show')) {
                setTimeout(function(){
                    hideBasketModal();
                }, 3000);
              } else {
                showBasketModal();
              }
              
            });
          },
          error: function(XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            if (response.slice(0,4) === 'All ') {
              _showFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
              $addToCartBtn.prop('disabled', false);
              _setText($addToCartBtn, _config.soldOutBtnLabel);
              $addToCartBtn.prop('disabled',true);
            }
            else {
              _showFeedback('error', '<i class="tfa tfa-warning"></i> ' + response, $addToCartForm);
              $addToCartBtn.prop('disabled', false).removeClass('disabled');
              _setText($addToCartBtn, _config.$addToCartBtnOriginalText);
            }
          }
        });
        return false;
      });
    });
  };
  return {
    init: function(params) {
      // Configuration
      params = params || {};
      // Merging with defaults.
      $.extend(_config, params);
      // Action
      $(function() {
        _init();
      });
    },
    getConfig: function() {
      return _config;
    }
  }
})(jQuery);

Shopify.AjaxifyCart.init();
/* end js-ajax-cart.js */




const showBasketModal = () => {
    const modal = document.querySelector(".terrys-basket-modal");
    if (!modal)
        return;
    if (!modal.classList.contains("mod-show")) {
        modal.classList.add("mod-show");
    }
};
const hideBasketModal = () => {
    const modal = document.querySelector(".terrys-basket-modal");
    if (!modal)
        return;
    if (modal.classList.contains("mod-show")) {
        modal.classList.remove("mod-show");
    }
};
const toggleBasketModal = () => {
    const modal = document.querySelector(".terrys-basket-modal");
    if (!modal)
        return;

    if (modal.classList.contains("mod-show")) {
        modal.classList.remove("mod-show");
    } else {
        modal.classList.add("mod-show");
    }
};

const closeBtn = document.querySelector(".terrys-basket-modal .modal-close");
if (closeBtn !== null) {
  closeBtn.addEventListener("click", () => {
      toggleBasketModal();
  });
}

document.querySelectorAll(".terrys-basket-modal .modal-basket-cont-btn").forEach((contBtn) => {
  if (contBtn !== null) {
    contBtn.addEventListener("click", () => {
        toggleBasketModal();
    });
  }
});

document.querySelectorAll(".terrys-basket-modal .modal-basket-view-btn").forEach((viewBtn) => {
  if (viewBtn !== null) {
    viewBtn.addEventListener("click", (event) => {
        setTimeout( () => {
            window.location.href = "/cart";
        }
        , 300);
    });
  }
});



/* M2M From Fabric */
if (m2mFromFabricTemplate.toLowerCase() === "on") {

  var apiURL = {
    params: `${m2mBaseApiUrl}/bespoke_params/`,
    price: `${m2mBaseApiUrl}/price`,
    variant: `${m2mBaseApiUrl}/add`
  };

  var fabricOptions = {
    sku: $("#product_code").text(),
    name: $("#product_name").text(),
    width: parseInt( $("#meta_fabric_width").text().replace(/[^\d.]/g,"") ) || 0,
    patternRepeat: parseInt( $("#meta_pattern_repeat").text().replace(/[^\d.]/g,"") ) || 0,
    price: parseFloat( $(".price.price-t11-fabric h3").text().replace(/[^\d.]/g,"") ) || 0,
    compare_at_price: parseFloat( $(".price.price-t11-fabric del").text().replace(/[^\d.]/g,"") ) || 0
  };
  
  var measurementUnitsSelector = 'input.unit-radio';

  var discountCircle = $("#image_discount_circle");
  var discountPercent = $("#discount-from-price");
  var discountPercentFabric = discountPercent.text().replace("%", "");
  var productSizes = {};

  var productParams = {
    load: function() {
      return $.getJSON(apiURL.params + fabricOptions.width + "/" + fabricOptions.sku);
    },

    render: function(options) {
      var curtainSizes = options.curtain,
          blindSizes = options.blind,
          linking = Object.keys(options.linking),
          self = this;

      if (curtainSizes.width.min < m2mFromFabricProduct.curtain.minWidth) {
        curtainSizes.width.min = m2mFromFabricProduct.curtain.minWidth;
      }

      productSizes.curtain = curtainSizes;
      productSizes.blind = blindSizes;

      $("#curtain_width")
          .data("min", curtainSizes.width.min)
          .data("max", curtainSizes.width.max)
          .attr("min", curtainSizes.width.min)
          .attr("max", curtainSizes.width.max)
          .attr("data-min", curtainSizes.width.min)
          .attr("data-max", curtainSizes.width.max)
          .attr("data-min-inch", cm2in(curtainSizes.width.min, "largest", "curtains"))
          .attr("data-max-inch", cm2in(curtainSizes.width.max, "lowest", "curtains"))
          .attr("placeholder", curtainSizes.width.min + " - " + curtainSizes.width.max);

      $("#curtain_drop")
          .data("min", curtainSizes.height.min)
          .data("max", curtainSizes.height.max)
          .attr("min", curtainSizes.height.min)
          .attr("max", curtainSizes.height.max)
          .attr("data-min", curtainSizes.height.min)
          .attr("data-max", curtainSizes.height.max)
          .attr("data-min-inch", cm2in(curtainSizes.height.min, "largest", "curtains"))
          .attr("data-max-inch", cm2in(curtainSizes.height.max, "lowest", "curtains"))
          .attr("placeholder", curtainSizes.height.min + " - " + curtainSizes.height.max);

      if (typeof curtainSizes.min_price !== 'undefined') {
        $(".curtains_from_price .from").html("from £" + curtainSizes.min_price);
        $(".curtains_from_price .compare_at del").html("");
        
        if (typeof curtainSizes.min_was_price !== 'undefined') {
          $(".curtains_from_price .compare_at del").html("£" + curtainSizes.min_was_price + " RRP");
        }
      }

      $("#blind_width")
          .data("min", blindSizes.width.min)
          .data("max", blindSizes.width.max)
          .attr("min", blindSizes.width.min)
          .attr("max", blindSizes.width.max)
          .attr("data-min", blindSizes.width.min)
          .attr("data-max", blindSizes.width.max)
          .attr("data-min-inch", cm2in(blindSizes.width.min, "largest"))
          .attr("data-max-inch", cm2in(blindSizes.width.max, "lowest"))
          .attr("placeholder", blindSizes.width.min + " - " + blindSizes.width.max);

      $("#blind_drop")
          .data("min", blindSizes.height.min)
          .data("max", blindSizes.height.max)
          .attr("min", blindSizes.height.min)
          .attr("max", blindSizes.height.max)
          .attr("data-min", blindSizes.height.min)
          .attr("data-max", blindSizes.height.max)
          .attr("data-min-inch", cm2in(blindSizes.height.min, "largest"))
          .attr("data-max-inch", cm2in(blindSizes.height.max, "lowest"))
          .attr("placeholder", blindSizes.height.min + " - " + blindSizes.height.max);
      
      if (typeof blindSizes.min_price !== 'undefined') {
        $(".blinds_from_price .from").html("from £" + blindSizes.min_price);
        $(".blinds_from_price .compare_at del").html("");
        
        if (typeof blindSizes.min_was_price !== 'undefined') {
          $(".blinds_from_price .compare_at del").html("£" + blindSizes.min_was_price + " RRP");
        }
      }

      if ($(".bespoke-tabs").hasClass("hidden") && linking.length > 0) {
        linking.forEach(function(linkingType) {
          self.revealLinkingType(linkingType);
          if (linkingType == "curtain") {
            self.revealLinkingType("accessories");
          }
          $(".bespoke-tabs").removeClass("hidden");
        });
      }
    },
      
    revealLinkingType: function(type) {
      $(".bespoke-header-" + type).removeClass("hidden");
      $(".bespoke-tab-" + type).removeClass("hidden");
    },

    fill: function(){
      var self = this;
      self.load().then( function(result){
        self.render(result.data);
      });
    }

  };

  var validateSizes = function(type) {
    var widthSelector = "#" + type + "_width",
        dropSelector = "#" + type + "_drop",
        blockId = "#" + type + "s-product ", // curtains-product, blinds-product
        widthField = $(blockId + widthSelector),
        dropField  = $(blockId + dropSelector),
        width = {
          "min": productSizes[type].width.min, //parseFloat(widthField.data("min")),
          "max": productSizes[type].width.max, //parseFloat(widthField.data("max")),
          "val": widthField.val()
        },
        drop = {
          "min": productSizes[type].height.min, //parseFloat(dropField.data("min")),
          "max": productSizes[type].height.max, //parseFloat(dropField.data("max")),
          "val": dropField.val()
        },
        selectedMeasurementUnit = $(blockId + measurementUnitsSelector + ":checked").val(),
        selectedMeasurementUnitFull = $(blockId + measurementUnitsSelector + ":checked").attr("data-full-name");
    
    errorMessage = $("#" + type + "-widths-error-message");

    $(widthSelector + ", " + dropSelector).removeClass("tf-error");
    errorMessage.text("");

    if ("" == width.val) {
      widthField.addClass("tf-error");
      errorMessage.text("Width is required");
      return false;
    }
    if ("" == drop.val) {
      dropField.addClass("tf-error");
      errorMessage.text("Drop is required");
      return false;
    }
    if ( ! /^\d+\.?\d*$/.test(width.val) ) {
      widthField.addClass("tf-error");
      errorMessage.text('Ooops, please enter numbers only' );
      return false;
    }
    if ( ! /^\d+\.?\d*$/.test(drop.val) ) {
      dropField.addClass("tf-error");
      errorMessage.text('Ooops, please enter numbers only' );
      return false;
    }
    if (selectedMeasurementUnit == 'cm') {
      if (type == 'blind') {
        if (/^\d*\.\d{2,}$/.test(width.val)) {
          widthField.addClass("tf-error");
          errorMessage.text('Ooops, Measurements must be centimetres (to a max of one decimal place)');
          return false;
        }
        if (/^\d*\.\d{2,}$/.test(drop.val)) {
          dropField.addClass("tf-error");
          errorMessage.text('Ooops, Measurements must be centimetres (to a max of one decimal place)');
          return false;
        }
      } else if (type == 'curtain') {
        if (/^\d*\.\d+$/.test(width.val)) {
          widthField.addClass("tf-error");
          errorMessage.text('Ooops, Measurements must be in whole centimetres');
          return false;
        }
        if (/^\d*\.\d+$/.test(drop.val)) {
          dropField.addClass("tf-error");
          errorMessage.text('Ooops, Measurements must be in whole centimetres');
          return false;
        }
      }
      if ((parseFloat(width.val) < width.min) || (parseFloat(width.val) > width.max)) {
        widthField.addClass("tf-error");
        errorMessage.text('The width should be between ' + width.min + 'cm and ' + width.max + 'cm');
        return false;
      }
      if ((parseFloat(drop.val) < drop.min) || (parseFloat(drop.val) > drop.max)) {
        dropField.addClass("tf-error");
        errorMessage.text('The drop should be between ' + drop.min + 'cm and ' + drop.max + 'cm');
        return false;
      }
    } else if (selectedMeasurementUnit == 'mm') {
      var widthValCm = customRound(width.val / 10, 'round'),
          dropValCm = customRound(drop.val / 10, 'round');

      if (/^\d*\.\d+$/.test(width.val)) {
        widthField.addClass("tf-error");
        errorMessage.text('Ooops, Measurements must be in whole milimeters');
        return false;
      }
      if (/^\d*\.\d+$/.test(drop.val)) {
        dropField.addClass("tf-error");
        errorMessage.text('Ooops, Measurements must be in whole milimeters');
        return false;
      }
      if ((parseFloat(widthValCm) < width.min) || (parseFloat(widthValCm) > width.max)) {
        widthField.addClass("tf-error");
        errorMessage.text('The width should be between ' + (width.min * 10) + 'mm and ' + (width.max * 10) + 'mm');
        return false;
      }
      if ((parseFloat(dropValCm) < drop.min) || (parseFloat(dropValCm) > drop.max)) {
        dropField.addClass("tf-error");
        errorMessage.text('The drop should be between ' + (drop.min * 10) + 'mm and ' + (drop.max * 10) + 'mm');
        return false;
      }
    } else if (selectedMeasurementUnit == 'in') {
      var widthInches = width.val;
      var dropInches = drop.val;

      var widthInchesFractionText = $(blockId + ".width-fraction option:selected").text();
      var widthInchesFractionVal = $(blockId + ".width-fraction option:selected").val();
      var dropInchesFractionText = $(blockId + ".drop-fraction option:selected").text();
      var dropInchesFractionVal = $(blockId + ".drop-fraction option:selected").val();

      var widthInchesText = widthInches + (widthInchesFractionText=="0" ? "" : (" " + widthInchesFractionText));
      var widthInchesVal = parseFloat(widthInches) + parseFloat(widthInchesFractionVal);
      var dropInchesText = dropInches + (dropInchesFractionText=="0" ? "" : (" " + dropInchesFractionText));
      var dropInchesVal = parseFloat(dropInches) + parseFloat(dropInchesFractionVal);

      var widthMinInchesText = $(blockId + '#' + type + '_width').attr('data-min-inch');
      var widthMaxInchesText = $(blockId + '#' + type + '_width').attr('data-max-inch');
      var dropMinInchesText = $(blockId + '#' + type + '_drop').attr('data-min-inch');
      var dropMaxInchesText = $(blockId + '#' + type + '_drop').attr('data-max-inch');
      var widthMinInchesVal = inchesStringToNumber(widthMinInchesText);
      var widthMaxInchesVal = inchesStringToNumber(widthMaxInchesText);
      var dropMinInchesVal = inchesStringToNumber(dropMinInchesText);
      var dropMaxInchesVal = inchesStringToNumber(dropMaxInchesText);

      widthValCm = in2cm(widthInchesVal, 0, 'round');
      dropValCm = in2cm(dropInchesVal, 0, 'round');

      if (/^\d*\.\d+$/.test(widthInches)) {
        widthField.addClass("tf-error");
        errorMessage.text('Ooops, Measurements must be in whole inches');
        return false;
      }
      if (/^\d*\.\d+$/.test(dropInches)) {
        dropField.addClass("tf-error");
        errorMessage.text('Ooops, Measurements must be in whole inches');
        return false;
      }
      if ((parseFloat(widthInchesVal) < widthMinInchesVal) || (parseFloat(widthInchesVal) > widthMaxInchesVal)) {
        widthField.addClass("tf-error");
        errorMessage.text('The width should be between ' + widthMinInchesText + 'in and ' + widthMaxInchesText + 'in');
        return false;
      }
      if ((parseFloat(dropInchesVal) < dropMinInchesVal) || (parseFloat(dropInchesVal) > dropMaxInchesVal)) {
        dropField.addClass("tf-error");
        errorMessage.text('The drop should be between ' + dropMinInchesText + 'in and ' + dropMaxInchesText + 'in');
        return false;
      }

    }


    return true;
  };

  var convertPrice = function(price){
    return parseFloat(Math.round(price * 100) / 100).toFixed(2);
  };

  var priceFormat = function(total) {
    return parseFloat(total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
  };

  var roundTo = function(n, digits) {
    if (digits === undefined) {
      digits = 0;
    }
    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    var test =(Math.round(n) / multiplicator);
    return +(test.toFixed(digits));
  };

  var surchargePrice = function( price, percent ) {
    return roundTo( ( parseFloat( parseFloat( price ) + parseFloat( price ) * percent / 100 ) ), 2 );
  };

  var capitalizeFirstLetter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  var addToCart = function( cartData, addButton ){
    addButton.text('Working...');
    $.ajax({
      type:'POST',
      url:'/cart/add.js',
      data:cartData,
      success:function(data){
        var _config = {
          shopifyAjaxCartURL: "/cart.js",
          cartCountSelector: ".cart-count",
          cartTotalSelector: "#cart-price"
        };
        $.getJSON(_config.shopifyAjaxCartURL, function(cart) {
          if (_config.cartCountSelector && $(_config.cartCountSelector).size()) {
            var value = $(_config.cartCountSelector).html() || '0';
            $(_config.cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count)).removeClass('hidden-count');
          }
          if (_config.cartTotalSelector && $(_config.cartTotalSelector).size()) {
            if (typeof Currency !== 'undefined' && typeof Currency.moneyFormats !== 'undefined') {
              var newCurrency = '';
              if ($('[name="currencies"]').size()) {
                newCurrency = $('[name="currencies"]').val();
              } else if ($('#currencies span.selected').size()) {
                newCurrency = $('#currencies span.selected').attr('data-currency');
              }
              if (newCurrency) {
                $(_config.cartTotalSelector).html('<span class=money>' + Shopify.formatMoney(Currency.convert(cart.total_price, "GBP", newCurrency), Currency.money_format[newCurrency]) + '</span>');
              } else {
                $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, "£{{amount}}"));
              }
            } else {
              $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, "£{{amount}}"));
            }
          };
          toggleBasketModal();
        });

        addButton.text('Item Added');
      },
      dataType:'json'
    })
  };

  var calculateDiscount = function(price, wasPrice) {
    var discount = Math.floor( (1 - (price / wasPrice)) * 100 );
    return discount;
  };

  var updateDiscount = function(discountValue){
    // temporaily disabled
    /*
    if (discountValue > 0) {
      discountPercent.text(discountValue + "%");
      discountCircle.removeClass("hidden");
    } else {
      discountCircle.addClass("hidden");
    }
    */
  };

  var handleUrlParam = function(){
    var urlParams = new URLSearchParams(window.location.search);
    var bespokeTabs = document.querySelectorAll('.bespoke-tabs li');
    var allowedParams = [
      'curtains',
      'blinds',
      'accessories'
    ];

    for(var [ key, value ] of urlParams) {
      var urlParamText = key.toLowerCase();
      if (allowedParams.indexOf(urlParamText) !== -1) {

        for (var t=0; t < bespokeTabs.length; t++) {
          var tabText = bespokeTabs[t].innerText.toLowerCase();
          if (tabText == urlParamText) {
            bespokeTabs[t].querySelector('a').click();
            break;
          }
        }
      }
    }
  }



  var curtain = {

    payloadData: {},

    productData: {},

    selectedData: {
      data: {},
      updateData: function() {
        var self = this;
        setTimeout(function() {
          self.data = curtain.serializeFormData();
        }, 1);
      }
    },

    serializeFormData: function(){

      var data = {
        'heading':null,
        'heading_option':null,
        'lining_option':null,
        'eyelet_colour':null
      };

      $('.buying-options-curtains .tf-variant-product').each(function(){
        if ( $(this).find('.item-price input').is(':checked') ) {
          data.heading = $(this).attr('data-type');
          data.heading_option = $(this).find('.item-price input').val();
        }
      });

      data.lining_option = $('#tf-lining-option-select').find(":selected").val();

      if(data.heading === 'EYE') {
        data.eyelet_colour = $('#tf-eyelet-option-select').find(":selected").val();
      }

      return data;
    },

    setCurtainLenghtDynamicText: function( heading ) {
      var text = '';
      if( heading === 'PEN') {
        text = 'Make sure you supply length measurement from either: ';
        text += 'the <strong>TOP OF THE CURTAIN TRACK</strong> (if using a curtain track) ';
        text += ' <strong>OR</strong>';
        text += ' the <strong>BOTTOM OF THE CURTAIN RING</strong> (if hanging on a pole) ';
        text += 'to the required finished length.';
      } else if( heading === 'EYE' ) {
        text = 'Make sure you supply length measurement from the <strong>TOP OF THE CURTAIN POLE</strong> to the required finished length.';
      } else if( heading === 'DBLPIN' || heading === 'PIN') {
        text = 'Make sure you supply length measurement from the <strong>BOTTOM OF THE CURTAIN RING</strong> to the required finished length.';
      }
      $('.text-note').html(text);
    },

    setFirstCurtainLenghtDynamicText: function(heading) {
      if( $('.text-note').html().length == 0 ) {
        this.setCurtainLenghtDynamicText(heading);
      }
    },

    fillHeadings: function() {
      var self = this;
      var type_found = false;
      var resetHeading = false;
      $('.buying-options-curtains .tf-variant-product').each(function(){

        var type = $(this).attr('data-type');

        if ( 'undefined' !== typeof self.productData[ type ] && 'undefined' !== typeof self.productData[ type ].active_price ) {

          $(this).removeClass("hidden");
          
          if(typeof(self.selectedData.data.widths_per_curtain) === 'undefined') {
            self.selectedData.data.widths_per_curtain = self.productData[ type ].widths_per_curtain;
          }
          var popupType = null;
          if (type == "PEN") {
            popupType = "pencil";
          } else if (type == "EYE") {
            popupType = "eyelet";
          } else if (type == "DBLPIN") {
            popupType = "dblpin";
          } else if (type == "PIN") {
            popupType = "pinch";
          }
          $(".sidebar-widths-per-curtain-" + popupType).text(self.productData[ type ].widths_per_curtain);
          var railWidth = curtain.payloadData.width;
          var totalWidths = self.productData[ type ].widths_per_curtain * 2
          var fabricWidth = parseFloat($(".sidebar-fabric-width").text());
          if (railWidth>0 && totalWidths>0 && fabricWidth>0) {
            var fullnessRatio = ( totalWidths * fabricWidth ) / railWidth;
            $(".sidebar-fullness-" + popupType).text(fullnessRatio.toFixed(2));
          } else {
            $(".sidebar-fullness-block-" + popupType).addClass("hidden");
          }

          self.setFirstCurtainLenghtDynamicText(type);
          var oldPrice = self.productData[ type ].active_price,
              newPrice = self.productData[ type ].active_sale_price;

          if ( oldPrice != newPrice ) {
            $(this).find('.item-price-old del').text('£'+oldPrice);
          } else {
            $(this).find('.item-price-old del').hide();
          }

          var viewPrice = newPrice;
          if (typeof(m2mFromFabricViewPriceModifier) !== 'undefined' && m2mFromFabricViewPriceModifier > 0) {
            viewPrice = newPrice * m2mFromFabricViewPriceModifier;
          }
          $(this).find('.item-price .price span.tf-price-value').text( '£' + priceFormat(viewPrice) );
		  if(type == "PEN") {
            if(type_found == false) {
              $("#klarna_pay_in_3").text("£" + (Math.floor(newPrice / 3 * 100) / 100).toFixed(2));
              type_found = true;
            }
          } else if(type == "EYE") {
          	if(type_found == false) {
              $("#klarna_pay_in_3").text("£" + (Math.floor(newPrice / 3 * 100) / 100).toFixed(2));
              type_found = true;
            }
          } else if(type == "PIN") {
          	if(type_found == false) {
              $("#klarna_pay_in_3").text("£" + (Math.floor(newPrice / 3 * 100) / 100).toFixed(2));
              type_found = true;
            }
          }
          $(this).find(' .squared-price .price').on('click touchstart', function(e){
            $(this).parent().find('label').trigger('click');
            e.stopPropagation(); e.preventDefault();
          });
          $(this).addClass('pc-heading-is-available');
          if(self.selectedData.data.heading) {
            var heading = self.selectedData.data.heading,
                target = null;
            if(heading == 'PEN') {
              target = 'pencil-pleat';
            } else if (heading == 'EYE') {
              target = 'eyelet';
            } else if (heading == 'DBLPIN') {
              target = 'dblpin';
            } else if (heading == 'PIN') {
              target = 'pin';
            }
            setTimeout(function() {
              $("#cc-" + target).click()
            },100);
          }
          if (['EYE','PEN'].includes(type)) {
            $(this).find('.squared-price').removeClass('hidden');
            $(this).find('.size-unavailable').addClass('hidden');
            $(this).find('.tfa-info-circle').removeClass('hidden');
            $(this).find('.item-image').css('cursor', 'pointer');
            $(this).find('.item-title').css('cursor', 'pointer');
          }

        } else {
            if (['EYE','PEN'].includes(type)) {
              if (self.selectedData.data.hasOwnProperty('heading') && type.toLowerCase() == self.selectedData.data.heading.toLowerCase()) {
                resetHeading = true;
              }
              $(this).removeClass('pc-heading-is-available');
              $(this).find('.squared-price').addClass('hidden');
              $(this).find('.size-unavailable').removeClass('hidden');
              $(this).find('.tfa-info-circle').addClass('hidden');
              $(this).find('.item-image').css('cursor', 'auto');
              $(this).find('.item-title').css('cursor', 'auto');
            } else {
              $(this).addClass('hidden');
            }

          // $(this).hide();
        }

      });

      if (resetHeading || !self.selectedData.data.hasOwnProperty('heading')) {
        // setTimeout(function(){
          $('.pc-heading-is-available').eq(0).find('input').trigger('click');
        // }, 100);
      }

      // $('.buying-options-curtains .pc-heading-is-available').eq(0).find('input').trigger('click');
      
      if ( 'eye' === $('.buying-options-curtains .pc-heading-is-available').eq(0).attr('data-type').toLowerCase() ) {
        $('.tf-eyelet-colors').fadeIn();
      }


    },

    populateLiningOptionTemplate: function( options ){
      var template = '';
      var checkedLinigOption = this.selectedData.data.lining_option || null;

      var select = $('<select>', {id: 'tf-lining-option-select', name:'tf-lining-option', class: 'curtains-options-select'});
      options.forEach( function( option, key ){
        var selected = false;
        if(checkedLinigOption) {
          if(checkedLinigOption === option.label) {
            selected = true;
          }
        } else {
          if(key === 0) {
            selected = true;
          }
        }

        var optionName = option.label;
        if (option.surcharge != '0' && option.surcharge != '0.00') {
            if (option.type.toLowerCase() == 'absolute') {
                optionName += ' (+ &pound;' + parseFloat(option.surcharge).toFixed(2) + ')';
            } else if (o.type == 'percent') {
                optionName += ' (' + parseFloat(option.surcharge) + '% Surcharge)';
            }
        }

        select.append( $('<option></option>').val(option.label).html(optionName).prop('selected', selected) );

      });

      return select;
    },

    populateEyeletColorsTemplate: function(options){
      var template = '';
      var checked = false;

      var storedEyeletColor = this.selectedData.data.eyelet_color || null;
      var alreadySet = false;

      var select = $('<select>', {id: 'tf-eyelet-option-select', name:'tf-eyelet-colour', class: 'curtains-options-select'});

      options.forEach( function( option, key ){

        if ( 'Please Select' !== option.label ) {
          var selected = false;
          if(!alreadySet) {
            if(!storedEyeletColor) {
              // checkedAttr = 'checked';
              alreadySet = true;
              selected = true;
            } else if(storedEyeletColor == option.label) {
              // checkedAttr = 'checked';
              alreadySet = true;
              selected = true;
            }
          }

          select.append( $('<option></option>').val(option.label).html(option.label).prop('selected', selected) );

        }

      });

      return select;
    },

    updatePriceByLiningOption: function( lining_option ) {
      var self = this;
      for ( var key in self.productData ) {
        if ( 'undefined' !== typeof self.productData[ key ].product_options.Lining_Options ) {
          var product = self.productData[ key ];
          product.product_options.Lining_Options.options.forEach( function( option ) {
            if ( lining_option == option.label ) {
              if ( parseFloat( option.surcharge ) > 0 && 'percent' === option.type ) {
                self.productData[ key ].active_price = surchargePrice( product.price, parseFloat( option.surcharge ) );
                self.productData[ key ].active_sale_price = surchargePrice( ( null === product.sale_price ? convertPrice( product.price ) : convertPrice( product.sale_price ) ), parseFloat( option.surcharge ) );
              } else {
                self.productData[ key ].active_price = parseFloat(product.price) + parseFloat( option.surcharge );
                self.productData[ key ].active_sale_price = ( null === product.sale_price ? parseFloat( product.price ) : parseFloat( product.sale_price ) ) + parseFloat( option.surcharge );
              }
            }
          });
        }
      }
    },
    // changeme: fabric-1
    updateProductPrice: function(){
      var self = this;
      $('.buying-options-curtains .tf-variant-product.pc-heading-is-available').each(function(){
        var type = $(this).attr('data-type'),
            oldPrice = self.productData[ type ].active_price,
            newPrice = self.productData[ type ].active_sale_price;
        if(typeof(oldPrice) === 'undefined' || typeof(newPrice) === 'undefined') {
          return true;
        }

        var viewPrice = newPrice;
        if (typeof(m2mFromFabricViewPriceModifier) !== 'undefined' && m2mFromFabricViewPriceModifier > 0) {
          viewPrice = newPrice * m2mFromFabricViewPriceModifier;
        }
        if($('#cc-pencil-pleat').is(":checked") && type == "PEN") {
            $("#klarna_pay_in_3").text("£" + (Math.floor(viewPrice / 3 * 100) / 100).toFixed(2));
        } else if($('#cc-eyelet').is(":checked") && type == "EYE") {
        	$("#klarna_pay_in_3").text("£" + (Math.floor(viewPrice / 3 * 100) / 100).toFixed(2));
        } else if($('#cc-pin').is(":checked") && type == "PIN") {
        	$("#klarna_pay_in_3").text("£" + (Math.floor(viewPrice / 3 * 100) / 100).toFixed(2));
        } else if($('#cc-dblpin').is(":checked") && type == "doublepinch") {
          $("#klarna_pay_in_3").text("£" + (Math.floor(viewPrice / 3 * 100) / 100).toFixed(2));
        }

        $(this).find('.item-price .price span.tf-price-value').text( '£' + viewPrice.toFixed(2));
        if ( oldPrice != newPrice && null !== newPrice ) {
          $(this).find('.item-price-old del').text('£'+parseFloat(oldPrice).toFixed(2));
        } else {
          $(this).find('.item-price-old del').hide();
        }
      });
    },

    fillOptions: function() {
      if ( 'undefined' !== typeof this.productData.PEN && 'undefined' !== typeof this.productData.PEN.product_options.Lining_Options ) {
        $('#tf-lo-container').html( this.populateLiningOptionTemplate( this.productData.PEN.product_options.Lining_Options.options ) );
      } else if ( 'undefined' !== typeof  this.productData.EYE && 'undefined' !== typeof this.productData.EYE.product_options.Lining_Options ) {
        $('#tf-lo-container').html( this.populateLiningOptionTemplate( this.productData.EYE.product_options.Lining_Options.options ) );
      } else {
        $('.tf-lining-options').fadeOut();
      }

      if ( 'undefined' !== typeof  this.productData.EYE && 'undefined' !== typeof  this.productData.EYE.product_options.Eyelet_Colour ) {
        $('#tf-ec-container').html( this.populateEyeletColorsTemplate( this.productData.EYE.product_options.Eyelet_Colour.options ) );
      }
    },

    fillProductData: function(data) {
      
      this.productData = {};
      
      for (var i in data) {
        if (!data.hasOwnProperty(i)) continue;
        var product = data[i],
            price,
            salePrice;

        if ( 'undefined' !== typeof product.was_price && product.was_price !== product.price ) {
          price = product.was_price;
          salePrice = product.price;
        } else {
          price = product.price;
          salePrice = null;
        }

        var _data = {
          "sku": m2mFromFabricProduct.curtain.sku,
          "heading":product.heading,
          "price": convertPrice( price ),
          "sale_price": ( null !== salePrice ? convertPrice( salePrice ) : null ),
          "active_price": convertPrice( price ),
          "active_sale_price": ( null === salePrice ? convertPrice( price ) : convertPrice( salePrice ) ),
          "width": this.payloadData.width,
          "drop": this.payloadData.drop,
          "fabric_widths": fabricOptions.width,
          "widths_per_curtain": product.widths_per_curtain,
          "no_meters_fabric": product.no_meters_fabric,
          "product_options": {},
          "hidden_options": {}
        };

        if ('undefined' !== typeof product.discount) {
          _data.discount = parseInt(product.discount);
        }

        if ('linking_product_id' in product) {
          _data['linking_product_id'] = product['linking_product_id'];
          _data['linking'] = true;
        }

        product.product_options.forEach(function(option) {
          if (option.label == "Eyelet_Colour" && product.heading != "EYE") {
            return;
          }
          if (option.type == "H") {
            _data.hidden_options[ option.label ] = option;
          } else {
            _data.product_options[ option.label ] = option;
          }
        });

        this.productData[ product.heading ] = _data;
      }
    },

    fillStep2: function() {
      $(".buying-options-curtains .selected-units").text(this.payloadData.units);
      $(".buying-options-curtains .selected-width").text(this.payloadData.width_units);
      $(".buying-options-curtains .selected-drop").text(this.payloadData.drop_units);

      this.fillHeadings();
      this.fillOptions();

      if (typeof(this.selectedData.data.heading) !== 'undefined') {
        $('.pc-heading-is-available[data-type="' + this.selectedData.data.heading + '"]').find('label').trigger('click');
      }

      // displaying step 2
      $('.buying-options-curtains .product-price-options').fadeIn();
      $('.buying-options-curtains .tf-product-widths .product-price-wrap' ).hide();
      $('.buying-options-curtains .tf-product-widths .tf-cp-heading').text('RE-CALCULATE PRICE');

      $('html, body').animate({
        scrollTop:($('.tab-content').offset().top - $("#StickyHeader").outerHeight())
      }, 400);

      $('.buying-options-curtains .tf-product-widths').fadeOut();

      $('.calculate-custom-price').addClass('tf-price-calculation-step2');
      $("#add_curtain").removeClass("inactive");

      this.updateDeliveryMessage();
    },

    handleHeadingClick: function() {
      var self = this;
      $('.buying-options-curtains .tf-variant-product').each(function(){
        var type = $(this).attr('data-type');
        $(this).find(' .squared-price .price').off('click touchstart').on('click touchstart', function(e){
          $(this).parent().find('label').trigger('click');
          e.stopPropagation(); e.preventDefault();
        });

        $(this).find('.squared-price label').off( 'click touchstart').on( 'click touchstart', function(){
          self.selectedData.updateData();

          var parentContainer = $(this).closest('.tf-variant-product');
          var parentContainerType = parentContainer.attr('data-type');
          self.setCurtainLenghtDynamicText(parentContainerType);
          if ( 'EYE' == parentContainerType ) {
            $('.tf-eyelet-colors').show();
          } else {
            $('.tf-eyelet-colors').hide();
          }

          if ( 'undefined' !== self.productData[ parentContainerType ].product_options.Lining_Options ) {
            $('.tf-lining-options').fadeIn();
            $('#tf-lo-container').html( self.populateLiningOptionTemplate( self.productData[ parentContainerType ].product_options.Lining_Options.options ) );
          } else {
            $('.tf-lining-options').fadeOut();
          }

          // $('#tf-lo-container .squaredThree').each(function(){

          //   var _this = $(this);

          //   if ( $(this).find('input').is(':checked') ) {
          //     var selectedLiningOption = $(this).find('input').val();
          //     $('#tf-lining-option').text('( '+selectedLiningOption+' Lining )');
          //     self.updatePriceByLiningOption( selectedLiningOption );
          //     self.updateProductPrice();
              
          //     $("#klarna_pay_in_3").text("£" + (Math.floor((self.productData[parentContainerType].active_sale_price) / 3 * 100) / 100).toFixed(2));
          //   }

          //   $(this).find('label').on('click touchstart', function(){


          //     var selectedLiningOption = _this.find('input').val();

          //     $('#tf-lining-option').text('( '+selectedLiningOption+' Lining )');

          //     self.updatePriceByLiningOption( selectedLiningOption );
          //     self.updateProductPrice();
          //     self.selectedData.updateData();
          //   });
          // });

          var selectedLiningOption = $('#tf-lining-option-select').find(":selected").val();
          self.updatePriceByLiningOption(selectedLiningOption);
          self.updateProductPrice();
          self.selectedData.updateData();


          $('#tf-lo-container').off('change').on('change', '#tf-lining-option-select', function(){
              var selectedLiningOption = $(this).find(":selected").val();
              self.updatePriceByLiningOption(selectedLiningOption);
              self.updateProductPrice();
              self.selectedData.updateData();
          })


          self.updateDeliveryMessage();
          
          setTimeout(function(){
            self.updateDiscountCircle();
          }, 10)
          

        });
      });
    },

    handleEvents: function() {
      var self = this;

      this.handleHeadingClick();

      $('#tf-ec-container').off('change').on('change', '#tf-eyelet-option-select', function(){
          self.selectedData.updateData();
      })


      $('#tf-lo-container').off('change').on('change', '#tf-lining-option-select', function(){
          var selectedLiningOption = $(this).find(":selected").val();
          self.updatePriceByLiningOption(selectedLiningOption);
          self.updateProductPrice();
          self.selectedData.updateData();
      })

      $("#curtain_quantity").off('change').on("change", function(){
        self.updateDeliveryMessage();
      });

      $('.btn-recalculate').off('click').on('click', function(){
        $('#curtain_width').val('');
        $('#curtain_drop').val('');

        $('.buying-options-curtains .product-price-options').fadeOut();
        $('.buying-options-curtains .tf-product-widths').fadeIn(1000);
        $('html, body').animate({
            scrollTop:($('.tab-content').offset().top - $("#StickyHeader").outerHeight())
        }, 800);
      });

    },

    updateDeliveryMessage: function(){
      var our_stock = parseInt($(".our_stock").text());
      var incoming_timestamp = parseInt($(".incoming_timestamp").text());
      var current_timestamp = parseInt($(".current_timestamp").text());
      var selected_type = $('.item-price input:checked').closest(".tf-variant-product").attr("data-type");
      var quantity = parseInt($("#curtain_quantity").val());
      var no_meters = this.productData[ selected_type].no_meters_fabric;
      var needed_quantity = quantity * no_meters;
      this.hideAllDeliverySections();
      if (needed_quantity > our_stock && incoming_timestamp > current_timestamp) {
        $(".buying-options-curtains .section_pre_order").removeClass("hidden");
        $("#preorder-advice-property").removeAttr("disabled");
      } else {
        $(".buying-options-curtains .section_lead_time").removeClass("hidden");
      }
    },

    hideAllDeliverySections: function(){
      $(".buying-options-curtains .section_next_day").addClass("hidden");
      $(".buying-options-curtains .section_pre_order").addClass("hidden");
      $(".buying-options-curtains .section_lead_time").addClass("hidden");
      $("#preorder-advice-property").attr("disabled", "disabled");
    },

    updateDiscountCircle: function(){
      var priceBox = $('.buying-options-curtains input[type="radio"]:checked').parent().find('.price');
      var wasPriceElement = priceBox.find('.item-price-old del');
      if (!wasPriceElement.length) {
        // no discounted products
        return;
      }

      var wasPrice = parseFloat(priceBox.find('.item-price-old del').text().replace("£", ""));
      var price = parseFloat(priceBox.find('.tf-price-value').text().replace("£", ""));
      if (wasPrice > 0 && price > 0 && price < wasPrice) {
        var discountValue = calculateDiscount(price, wasPrice);
        if (discountValue > 0) {
          updateDiscount(discountValue);
        }
      }

    }

  };

  var blind = {

    payloadData: {},

    productData: {},

    selectedData: {
      options: []
    },

    measurementOption: '',

    updatePriceOptions: function() {
      var self = this,
          qty = parseInt($('#blind_quantity').val()),
          price = this.productData.price,
          wasPrice = this.productData.was_price;
      $.each(this.selectedData.options, function(i, o) {
        if (typeof o !== 'undefined' && o.type && o.type == 'absolute') {
          if (o.surcharge != '0') {
            price = parseFloat(price) + parseFloat(o.surcharge);
            wasPrice = parseFloat(wasPrice) + parseFloat(o.surcharge);
          }
        } else if (typeof o !== 'undefined' && o.type && o.type == 'percent') {
          if (o.surcharge != '0') {
            price = parseFloat(price) + (parseFloat(o.surcharge) / 100 * self.productData.price);
            wasPrice = parseFloat(wasPrice) + (parseFloat(o.surcharge) / 100 * self.productData.was_price);
          }
        }
      });

      var viewPrice = price;
      if (typeof(m2mFromFabricViewPriceModifier) !== 'undefined' && m2mFromFabricViewPriceModifier > 0) {
        viewPrice = price * m2mFromFabricViewPriceModifier;
      }
      $('.priceTotal').html('&pound;' + priceFormat(viewPrice * qty));
      if (wasPrice > 0) {
        $('.buying-options-blinds .wasPrice del').html('&pound;' + priceFormat(wasPrice * qty));
      } else {
        $('.buying-options-blinds .wasPrice del').html('');
      }

      this.updateDiscountCircle();
      
      var price_in_3 = (Math.floor(priceFormat(viewPrice * qty).replace(/\u00A3/g, '') / 3 * 100) / 100).toFixed(2); // Klarna price in 3
      $('#klarna_blinds').html('&pound;' + price_in_3);
      if (this.productData.product_options.length == this.selectedData.options.length) {
        var enabled = true;
        $.each(this.selectedData.options, function(i, o) {
          if (!o.index && o.index !== 0) {
            enabled = false;
          }
        });
        $('#add_blind').attr('disabled', !enabled);
      }
    },

    fillStep2: function() {
      var self = this;

      var viewPrice = this.productData.price;
      if (typeof(m2mFromFabricViewPriceModifier) !== 'undefined' && m2mFromFabricViewPriceModifier > 0) {
        viewPrice = this.productData.price * m2mFromFabricViewPriceModifier;
      }
      $('.priceTotal').html('&pound;' + priceFormat(viewPrice * parseInt($('#cQuantity').val())));
      if (this.productData.was_price && this.productData.discount) {
        $('.buying-options-blinds .wasPrice del').html('&pound;' + this.productData.was_price);
      } else {
        $('.buying-options-blinds .wasPrice del').html('');
      }
      $("#add_blind").removeClass("hidden");

      if (this.productData.product_options) {
        var options = '<h4 style="margin: 5px 0px 20px -20px; color: #888888; text-align: center;">Select your fitting options:</h4>';
        $.each(this.productData.product_options, function(index, option){
          if (option.type == "Y") {
            if (option.label == 'MEASUREMENT_OPTIONS') {
              // measurement option got entered on first step
              // so filling self.selectedData.options and continue with other options
              self.selectedData.options[index] = {
                type: 'Y',
                surcharge: '0.00',
                index: index,
                label: blind.measurementOption,
                title: option.label
              };
              return;
            }
            
            options += '<h4 style="margin: 0px 0px 8px 20px">' + option.name + '<span title="' + option.name + '" onclick="PopupSideBar(\'' + option.help_resource +'\')">' +
                ' <span class="more-info-link">Product info</span>' +
                '</span></h4>';
            options += '<div class="product-options" style="margin: 0px 0px 5px 20px;">';
            if (option.options.length <= 0) {
              $.each(option.options, function(i, o) {
                options += '<span data-option-type="' + o.type + '" data-option-surcharge="' + o.surcharge + '" data-option-label="' + o.label + '" data-option-title="' + option.label +
                    '" data-option-index="' + index + '">' + o.label;
                if (parseFloat(o.surcharge) != 0) {
                  if (o.type == 'absolute') {
                    options += ' (+ &pound;' + parseFloat(o.surcharge).toFixed(2) + ')';
                  } else if (o.type == 'percent') {
                    options += ' (' + parseFloat(o.surcharge) + '% Surcharge)';
                  }
                }
                options += '</span>';
              });
            } else {
              options += '<div class="styled-select slate"><select>';
              $.each(option.options, function(i, o) {
                options += '<option data-option-type="' + o.type + '" data-option-surcharge="' + o.surcharge + '" data-option-label="' + o.label + '" data-option-title="' + option.label +
                    '" data-option-index="' + index + '"';
                if (i < 1) {
                  options += ' selected="selected"';
                }
                options += '>' + o.label;
                if (parseFloat(o.surcharge) != 0) {
                  if (o.type == 'absolute') {
                    options += ' (+ &pound;' + parseFloat(o.surcharge).toFixed(2) + ')';
                  } else if (o.type == 'percent') {
                    options += ' (' + parseFloat(o.surcharge) + '% Surcharge)';
                  }
                }
                options += '</option>';
              });
              options += '</select></div>';
            }
            options += "</div>";
          }
          if (option.type == "A" || option.type == "T") {
            var limitChars = parseInt(item.name.replace(/.*\((\d+).*\)$/, "$1"));
            var limitText = limitChars > 0 ? " maxlength='" + limitChars + "'" : "";
            options += '<h4>' + option.name + ' <em class="tfa tfa-question-circle show-help" data-popupId="' + option.help_resource + '"></em>' + '</h4>';
            options += '<textarea rows="2" class="option-typeA" data-option-type="' + option.type + '"  data-option-surcharge="0.00" data-option-title="' + option.label +
                '" data-option-label="" data-option-index="' + index + '"' + limitText + '></textarea>';
          }
          if (option.type == "H") {
            self.selectedData.options[index] = {
              type: "absolute",
              surcharge: '0.00',
              index: index,
              label: option.options[0].label,
              title: option.label
            }
          }

        });

        $('.buying-options-blinds .options-container').html(options);
        if (this.productData.product_options.length == 0) {
          $('#add_blind').attr('disabled', false);
        }

        $('.styled-select').each(function() {
          self.selectedData.options[$(this).find(':selected').attr('data-option-index')] = {
            type: $(this).find(':selected').attr('data-option-type'),
            surcharge: $(this).find(':selected').attr('data-option-surcharge'),
            index: $(this).find(':selected').attr('data-option-index'),
            label: $(this).find(':selected').attr('data-option-label'),
            title: $(this).find(':selected').attr('data-option-title')
          };
        });
        self.updatePriceOptions();


      } else {
        $('#add_blind').attr('disabled', false);
      }

      $(".buying-options-blinds .selected-units").text(this.payloadData.units);
      $(".buying-options-blinds #selectedWidth").text(this.payloadData.width_units);
      $(".buying-options-blinds #selectedDrop").text(this.payloadData.drop_units);
      
      $(".buying-options-blinds #selectedMeasurementOption").text(this.measurementOption);

      $('.buying-options-blinds .step2').removeClass('hidden');
      // $(".buying-options-blinds .step1 .price").addClass("hidden");
      $("#calculate_blind").blur();
      $("#add_blind").removeClass("inactive");

      self.updateDeliveryMessage();

      $('html, body').animate({
        scrollTop:($('.tab-content').offset().top - $("#StickyHeader").outerHeight())
      }, 400);

      $('.buying-options-blinds .step1').addClass('hidden');

    },

    handleEvents: function(){
      var self = this;

      $(document).on('click', '.product-options span', function() {
        $(this).siblings('span').removeClass('selected');
        $(this).addClass('selected');
        for (var i = 0; i < parseInt($(this).attr('data-option-index')); i++) {
          if (typeof self.selectedData.options[i] === 'undefined' || !self.selectedData.options[i]) {
            self.selectedData.options[i] = {};
          }
        }
        self.selectedData.options[$(this).attr('data-option-index')] = {
          type: $(this).attr('data-option-type'),
          surcharge: $(this).attr('data-option-surcharge'),
          index: $(this).attr('data-option-index'),
          label: $(this).attr('data-option-label'),
          title: $(this).attr('data-option-title')
        };
        $('.styled-select').each(function() {
          self.selectedData.options[$(this).find(':selected').attr('data-option-index')] = {
            type: $(this).find(':selected').attr('data-option-type'),
            surcharge: $(this).find(':selected').attr('data-option-surcharge'),
            index: $(this).find(':selected').attr('data-option-index'),
            label: $(this).find(':selected').attr('data-option-label'),
            title: $(this).find(':selected').attr('data-option-title')
          };
        });
        self.updatePriceOptions();
      });

      $(document).on('change', '.option-typeA', function() {
        self.selectedData.options[$(this).attr('data-option-index')] = {
          type: $(this).attr('data-option-type'),
          surcharge: $(this).attr('data-option-surcharge'),
          index: $(this).attr('data-option-index'),
          label: $(this).attr('data-option-label'),
          title: $(this).attr('data-option-title')
        };
        $('.styled-select').each(function() {
          self.selectedData.options[$(this).find(':selected').attr('data-option-index')] = {
            type: $(this).find(':selected').attr('data-option-type'),
            surcharge: $(this).find(':selected').attr('data-option-surcharge'),
            index: $(this).find(':selected').attr('data-option-index'),
            label: $(this).find(':selected').attr('data-option-label'),
            title: $(this).find(':selected').attr('data-option-title')
          };
        });
        self.updatePriceOptions();
      });

      $(document).on('change', '.styled-select', function() {
        self.selectedData.options[$(this).find(':selected').attr('data-option-index')] = {
          type: $(this).find(':selected').attr('data-option-type'),
          surcharge: $(this).find(':selected').attr('data-option-surcharge'),
          index: $(this).find(':selected').attr('data-option-index'),
          label: $(this).find(':selected').attr('data-option-label'),
          title: $(this).find(':selected').attr('data-option-title')
        };
        self.updatePriceOptions();
      });

      $("#blind_quantity").on("change", function(){
        self.updateDeliveryMessage();
      });

      $('.btn-recalculate').off('click').on('click', function(){
        $('#blind_width').val('');
        $('#blind_drop').val('');

        $('html, body').animate({
            scrollTop:($('.tab-content').offset().top - $("#StickyHeader").outerHeight())
        }, 800);
        $('.buying-options-blinds .step2').addClass('hidden');
        $('.buying-options-blinds .step1').removeClass('hidden');

      });

    },

    updateDeliveryMessage: function(){
      var our_stock = parseInt($(".our_stock").text());
      var incoming_timestamp = parseInt($(".incoming_timestamp").text());
      var current_timestamp = parseInt($(".current_timestamp").text());
      var quantity = parseInt($("#blind_quantity").val());
      var no_meters = this.productData.no_meters_fabric;
      var needed_quantity = quantity * no_meters;
      this.hideAllDeliverySections();
      if (needed_quantity > our_stock && incoming_timestamp > current_timestamp) {
        $(".buying-options-blinds .section_pre_order").removeClass("hidden");
        $("#preorder-advice-property").removeAttr("disabled");
      } else {
        $(".buying-options-blinds .section_lead_time").removeClass("hidden");
      }
    },

    hideAllDeliverySections: function(){
      $(".buying-options-blinds .section_next_day").addClass("hidden");
      $(".buying-options-blinds .section_pre_order").addClass("hidden");
      $(".buying-options-blinds .section_lead_time").addClass("hidden");
      $("#preorder-advice-property").attr("disabled", "disabled");
    },

    updateDiscountCircle: function(){
      var wasPriceElement = $(".buying-options-blinds .wasPrice:visible");
      if (!wasPriceElement.length) {
        // no discounted products
        return;
      }

      var wasPrice = parseFloat(wasPriceElement.text().replace("£", ""));
      var price = parseFloat(wasPriceElement.parent().find(".priceTotal").text().replace("£", ""));
      if (wasPrice > 0 && price > 0 && price < wasPrice) {
        var discountValue = calculateDiscount(price, wasPrice);
        if (discountValue > 0) {
          updateDiscount(discountValue);
        }
      }

    }

  };

  var accessory = {

    selectedType: "",

    payloadData: {},

    productData: {},

    preparePayloadData: function() {
      this.payloadData = {
        "product_type": "m2mf",
        "product_code": "ACCESSORIES",
        "fabric_sku": fabricOptions.sku,
        "fabric_name": fabricOptions.name,
        "fabric_width": fabricOptions.width,
        "pattern_repeat": fabricOptions.patternRepeat,
        "price": fabricOptions.price,
        "compare_at_price": fabricOptions.compare_at_price,
        "width": "",
        "drop": "",
      }
    },

    fillProductData: function(data) {
      this.productData = {};
      this.productData.linked = data.linked;
      if (data.linked === 1) {
        this.fillLinkedAccessoriesData(data.accessories);
      } else {
        this.fillM2mfAccessoriesData(data.accessories);
        this.updateDiscountCircle();
      }
    },
    
    fillLinkedAccessoriesData: function(data){
      var tiebacks = [],
          cushions = [],
          self = this;

      for (var acc in data) {
        if (data.hasOwnProperty(acc)) {
          var accessory = data[acc];
          if (/\/cush[^\/]*$/i.test(accessory["sku"]) || /cushion/i.test(accessory["title"])) {
            cushions.push(accessory);
          }
          if (/\/tb[^\/]*$/i.test(accessory["sku"]) || /tieback/i.test(accessory["title"]) ) {
            tiebacks.push(accessory);
          }
        }
      }

      if (tiebacks.length == 0 && cushions.length == 0) {
        $(".no-accessories-text").removeClass("hidden");
        return;
      }

      if (tiebacks.length == 1) {
        $(".linked-accessories .tieback-title").text(tiebacks[0].title);
        $(".linked-accessories .tieback-price .price").text("£" + tiebacks[0].price);
        $(".linked-accessories .tieback-form input[name='id']").val(tiebacks[0].variantid);
        $(".linked-accessories .product-detail-inner-dropdown").addClass("hidden");
        $(".linked-accessories .tieback-price").css("margin-bottom", "58px");
        $(".linked-accessories .tiebacks-block").removeClass("hidden");
      } else if (tiebacks.length > 1) {
        var $options = $(".linked-accessories .tieback-options");
        for (var i in tiebacks) {
          if (tiebacks.hasOwnProperty(i)) {
            var tb = tiebacks[i],
                optionVal = tb.sku +"|" + tb.variantid + "|" + tb.title + "|" + tb.price + "|" + tb.rrp,
                optionHtml = tb.title;
            $options.append($('<option></option>').val(optionVal).html(optionHtml));
          }
        }
        this.populateLinkedTiebackOption();
        $options.on("change", function(){
          self.populateLinkedTiebackOption();
        });
        $(".linked-accessories .tiebacks-block").removeClass("hidden");
      }

      if (cushions.length > 0) {
        $(".linked-accessories .cushion-title").text(cushions[0].title);
        $(".linked-accessories .cushion-price .price").text("£" + cushions[0].price);
        $(".linked-accessories .cushion-form input[name='id']").val(cushions[0].variantid);
        $(".linked-accessories .cushion-block").removeClass("hidden");
      }
      
      $(".linked-accessories").removeClass("hidden");
    },

    populateLinkedTiebackOption: function() {
      var tb = $(".linked-accessories .tieback-options").val().split("|");
      $(".linked-accessories .tieback-title").text(tb[2]);
      $(".linked-accessories .tieback-form input[name='id']").val(tb[1]);
      $(".linked-accessories .tieback-price .price").text("£" + tb[3]);
    },


    fillM2mfAccessoriesData: function(data){
      this.productData = data;
      var discountIsSet = false;
      for (var accType in data) { //cushions, tiebacks
        if (!data.hasOwnProperty(accType)) continue;
        for (var accHeading in data[accType]) { //plain, piped
          if (!data[accType].hasOwnProperty(accHeading)) continue;
          var productOptions = data[accType][accHeading],
              productOptionsLength = productOptions.length,
              typeSelector = "." + accType + "-block",
              headingSelector = "." + accHeading + "-block",
              accBlockSelector = (typeSelector + headingSelector).toLowerCase(),
              accBlock = $(accBlockSelector);
          
          for (var i = 0; i < productOptionsLength; i++) {
            if (i == 0) {
              accBlock.find("input.product-code").val(productOptions[i]["product_code"]);
              accBlock.find("input.product-heading").val(productOptions[i]["heading"]);
              accBlock.find("span.price").text("£" + convertPrice(productOptions[i]["price"]));
              if (productOptions[i]["was_price"] > 0) {
                accBlock.find("span.wasPrice del").text("£" + convertPrice(productOptions[i]["was_price"]));
              }
              accBlock.find("input.no-meters-fabric").val(productOptions[i]["no_meters_fabric"]);
              if ('undefined' !== typeof productOptions[i]["discount"] && !discountIsSet) {
                var discountValue = parseInt(productOptions[i]["discount"]);
                if (discountValue > 0) {
                  updateDiscount(discountValue);
                  discountIsSet = true;
                }
              }
            }
            if (accType == "tiebacks" && productOptionsLength > 1) {
              var optVal = 
              accBlock.find("select.tieback-options").append($('<option></option>')
                  .val(productOptions[i]["price"] + "|" + productOptions[i]["no_meters_fabric"] + "|" + productOptions[i]["was_price"])
                  .text(productOptions[i]["rail_width"]));
            }
          }
          accBlock.removeClass("hidden");
        }
      }
      $(".m2mf-accessories").removeClass("hidden");
    },

    updateDiscountCircle: function() {
      var wasPriceElement = $(".bespoke-tab-accessories .wasPrice:visible").first();
      if (!wasPriceElement.length) {
        // no discounted products
        return;
      }

      var wasPrice = parseFloat(wasPriceElement.text().replace("£", ""));
      var price = parseFloat(wasPriceElement.parent().find(".price").text().replace("£", ""));
      if (wasPrice > 0 && price > 0 && price < wasPrice) {
        var discountValue = calculateDiscount(price, wasPrice);
        if (discountValue > 0) {
          updateDiscount(discountValue);
        }
      }
    },

    handleEvents: function() {
      var self = this;
      $(".m2mf-accessories .accessory_quantity").on("change", function(){
        var block = $(this).closest(".accessory-block");
        self.updateDeliveryMessage(block);
      });
      $(".m2mf-accessories .tieback-options").on("change", function(){
        var block = $(this).closest(".accessory-block");
        var tbVals = $(this).val().split("|");
        var price = convertPrice(tbVals[0]);
        var noMeters = tbVals[1];
        var wasPrice = typeof(tbVals[2]) !== 'undefined' ? convertPrice(tbVals[2]) : '';
        block.find(".price").text("£" + price);
        block.find(".no-meters-fabric").val(noMeters);
        if (wasPrice.length > 0) {
          block.find(".wasPrice del").text("£" + wasPrice);
        }
        self.updateDiscountCircle();
      });
      $(".m2mf-accessories .cart-button").on("click", function() {
        var block = $(this).closest(".accessory-block");
        self.addToCart(block);
      });
    },

    updateDeliveryMessage: function(block){
      var our_stock = parseInt($(".our_stock").text());
      var incoming_timestamp = parseInt($(".incoming_timestamp").text());
      var current_timestamp = parseInt($(".current_timestamp").text());
      var quantity = parseInt(block.find(".accessory_quantity").val());
      var no_meters = parseInt(block.find(".no-meters-fabric").val());
      var needed_quantity = quantity * no_meters;
      this.hideAllDeliverySections();
      if (needed_quantity > our_stock && incoming_timestamp > current_timestamp) {
        $(".buying-options-accessories .section_pre_order").removeClass("hidden");
        $("#preorder-advice-property").removeAttr("disabled");
      } else {
        $(".buying-options-accessories .section_lead_time").removeClass("hidden");
      }
    },

    hideAllDeliverySections: function(){
      $(".buying-options-accessories .section_next_day").addClass("hidden");
      $(".buying-options-accessories .section_pre_order").addClass("hidden");
      $(".buying-options-accessories .section_lead_time").addClass("hidden");
      $("#preorder-advice-property").attr("disabled", "disabled");
    },
    
    addToCart: function(block){
      var cartButton = block.find(".cart-button");
      if ( cartButton.hasClass('inactive') ) { return false; }
      cartButton.addClass('inactive');
      cartButton.text('working...');

      var selectedType = block.hasClass("tiebacks-block") ? "tiebacks" : "cushion";
      var variantData = accessory.payloadData;
      variantData.product_id = m2mFromFabricProduct[ selectedType ].id;
      variantData.product_code = block.find(".product-code").val();
      variantData.selected_heading = block.find(".product-heading").val();
      variantData.type = variantData.selected_heading.charAt(0).toUpperCase() + variantData.selected_heading.slice(1).toLowerCase();
      variantData.service = "TF";
      if (block.hasClass("tiebacks-block")) {
        variantData.rail_width = block.find("select.tieback-options option:selected").text();
      } else if ('undefined' !== typeof variantData.rail_width) {
        delete variantData.rail_width;
      }
      
      $.post(apiURL.variant, variantData, function(response) {

        if ( 'undefined' !== typeof response.data.variant.id ) {
          cartProperties = {
            "Fabric SKU": variantData.fabric_sku,
            "Fabric Name": variantData.fabric_name,
            "Type": variantData.type,
            "Fabric Width": variantData.fabric_width,
            "Pattern Repeat": variantData.pattern_repeat,
            "Price": variantData.price,
            "_NO_METERS_FABRIC": block.find(".no-meters-fabric").val()
          };

          if ('undefined' !== typeof variantData.rail_width) {
            cartProperties["Tiebacks size"] = variantData.rail_width;
          }

          var ourStock = parseInt($(".our_stock").text());
          var incomingTimestamp = parseInt($('.incoming_timestamp').text());
          var currentTimestamp = parseInt($('.current_timestamp').text());
          var accessoryQuantity = parseInt(block.find(".accessory_quantity").val()) || 1;
          var totalNoMeters = blind.productData.no_meters_fabric * accessoryQuantity;
          if (totalNoMeters > ourStock && incomingTimestamp > currentTimestamp && $("#preorder-advice-property").length > 0) {
            cartProperties["_Preorder-Advice"] = $("#preorder-advice-property").val();
          }

          cartData = {
            "quantity": accessoryQuantity,
            "id": response.data.variant.id,
            "properties": cartProperties
          };
          addToCart(cartData, cartButton);
        }

        $('#CartCount').text(parseInt($('#CartCount').text()) + 1);
        $('#cAddToBasket').attr('disabled', 'disabled');
      });

    }

  };



  $(document).ready(function(){

    productParams.fill();

    deliveryApi.init(m2mFromFabricProduct.curtain.sku + "|" + fabricOptions.sku, ".buying-options-curtains", true);
    deliveryApi.init(m2mFromFabricProduct.blind.sku + "|" + fabricOptions.sku, ".buying-options-blinds", true);

    $(document).on('click', measurementUnitsSelector, function() {
      var blockId = "#" + $(this).parents(".tab-pane").attr("id") + " ";
      var unit = $(blockId + measurementUnitsSelector + ":checked").val();
      $(blockId + '.unit-label').text(unit);
      if (unit == 'in') {
        $(blockId + '.width-selector').each(function () {
          $(blockId + ".inch-fractions").removeClass("hidden");
          //placeholder and value
          if (typeof $(this).attr("data-min-inch") === 'undefined' || parseFloat($(this).attr("data-min-inch")) <= 0) {
            var minIn = cm2in($(this).attr("data-min"), 'largest');
            $(this).attr("data-min-inch", minIn);
          }
          if (typeof $(this).attr("data-max-inch") === 'undefined' || parseFloat($(this).attr("data-max-inch")) <= 0) {
            var maxIn = cm2in($(this).attr("data-max"), 'lowest');
            $(this).attr("data-max-inch", maxIn);
          }
          $(this).attr("placeholder", $(this).attr("data-min-inch") + " - " + $(this).attr("data-max-inch"));

          if ($(this).val() > 0) {
            $(this).val("");
            $(this).parent().children(".inch-fractions").val("0").change();
          }

        });
      } else if (unit == "mm") {
        $(blockId + ".inch-fractions").addClass("hidden");
        $(blockId + '.width-selector').each(function(){
          $(this).attr("placeholder", $(this).attr("data-min")*10 + " - " + $(this).attr("data-max")*10 );
          if ($(this).val() > 0) {
            $(this).val("");
          }
        });

      } else {
        // unit == "cm"
        $(blockId + ".inch-fractions").addClass("hidden");
        $(blockId + '.width-selector').each(function(){
          $(this).attr("placeholder", $(this).attr("data-min") + " - " + $(this).attr("data-max") );
          if ($(this).val() > 0) {
            $(this).val("");
          }
        });
      }

    });


    $("#calculate_curtain").on("click", function(){
      if (!validateSizes("curtain")) return false;
      
      var blockId = "#curtains-product ";
      var selectedMeasurementUnit = $(blockId + measurementUnitsSelector + ":checked").val();
      //changeme - fabric-curtains
      curtain.payloadData = {
        "product_type": "m2mf",
        "product_code": m2mFromFabricProduct.curtain.sku,
        "fabric_sku": fabricOptions.sku,
        "fabric_name": fabricOptions.name,
        "fabric_width": fabricOptions.width,
        "pattern_repeat": fabricOptions.patternRepeat,
        "price": fabricOptions.price,
        "compare_at_price": fabricOptions.compare_at_price,
        "width": parseFloat( $("#curtain_width").val() ),
        "drop": parseFloat( $("#curtain_drop").val() ),
        "rail_width": "",
        "fabric_hash": "",
        "units": selectedMeasurementUnit,
        "width_units": parseFloat( $("#curtain_width").val() ),
        "drop_units": parseFloat( $("#curtain_drop").val() ),
        "linking": true
      };


      if (selectedMeasurementUnit == 'in') {
        var widthInches = curtain.payloadData.width;
        var dropInches = curtain.payloadData.drop;

        var widthInchesFractionText = $(blockId + ".width-fraction option:selected").text();
        var widthInchesFractionVal = $(blockId + ".width-fraction option:selected").val();
        var dropInchesFractionText = $(blockId + ".drop-fraction option:selected").text();
        var dropInchesFractionVal = $(blockId + ".drop-fraction option:selected").val();

        var widthInchesText = widthInches + (widthInchesFractionText=="0" ? "" : (" " + widthInchesFractionText));
        var widthInchesVal = parseFloat(widthInches) + parseFloat(widthInchesFractionVal);
        var dropInchesText = dropInches + (dropInchesFractionText=="0" ? "" : (" " + dropInchesFractionText));
        var dropInchesVal = parseFloat(dropInches) + parseFloat(dropInchesFractionVal);

        widthValCm = in2cm(widthInchesVal, 0, 'round');
        dropValCm = in2cm(dropInchesVal, 0, 'round');

        curtain.payloadData.width = widthValCm;
        curtain.payloadData.drop = dropValCm;
        curtain.payloadData.width_units = widthInchesText;
        curtain.payloadData.drop_units = dropInchesText;

      } else if (selectedMeasurementUnit == 'mm') {
        var widthValCm = customRound(curtain.payloadData.width / 10, 'round'),
            dropValCm = customRound(curtain.payloadData.drop / 10, 'round');

        curtain.payloadData.width_units = curtain.payloadData.width;
        curtain.payloadData.drop_units = curtain.payloadData.drop;
        curtain.payloadData.width = widthValCm;
        curtain.payloadData.drop = dropValCm;
      }

      var calculatePriceButtonTextData = $('#calculate_curtain').text();
      $('#calculate_curtain').text('Working...');

      $.post(apiURL.price, curtain.payloadData, function(response){
        if (response.status !== 1) return;
        $('#calculate_curtain').text( calculatePriceButtonTextData );
        curtain.fillProductData(response.data);
        curtain.fillStep2();
        curtain.handleEvents();
        curtain.updateDiscountCircle();
      });

    });

    $("#add_curtain").on("click", function(){

      if ( $(this).hasClass('inactive') ) { return false; }
      $(this).addClass('inactive');
      $(this).text('Working...');

      var blockId = "#curtains-product ";
      var selectedMeasurementUnit = $(blockId + measurementUnitsSelector + ":checked").val();

      //collect payload data
      var formData = curtain.serializeFormData(),
          selectedHeading = formData.heading,
          productData = curtain.productData[selectedHeading],
          productOptions = {
            "lining_option": formData.lining_option
          };
      if ("EYE" == selectedHeading) {
        productOptions.eyelet_colour = formData.eyelet_colour;
      }
      if (!$.isEmptyObject(productData.hidden_options)) {
        for (var option in productData.hidden_options) {
          var hOpt = productData.hidden_options[option];
          productOptions[hOpt.label] = hOpt.options[0].label;
        }
      }

      var variantData = curtain.payloadData;
      variantData.product_id = m2mFromFabricProduct.curtain.id;
      if ('linking_product_id' in productData) {
        variantData.product_id = productData.linking_product_id;
        variantData.linking = true;
      }
      variantData.selected_heading = selectedHeading;
      variantData.heading_option = formData.heading_option;
      variantData.product_options = productOptions;
      variantData.service = "TF";
      variantData.widths_per_curtain = productData.widths_per_curtain;

      //send create variant request
      $.post(apiURL.variant, variantData, function(response){
        if ( 'undefined' !== typeof response.data.variant.id ) {
          cartProperties = {
            "Fabric SKU": variantData.fabric_sku,
            "Fabric Name": variantData.fabric_name,
            "Rail width": variantData.width,
            "Curtain Drop": variantData.drop,
            "Heading Option": variantData.heading_option,
            "Fabric Width": variantData.fabric_width,
            "Pattern Repeat": variantData.pattern_repeat,
            "Price": variantData.price,
            "Widths per curtain": productData.widths_per_curtain,
            "_NO_METERS_FABRIC": productData.no_meters_fabric
          };

          if ('linking_product_id' in productData) {
            cartProperties = {
              "Heading Option": variantData.heading_option,
              "Widths per curtain": productData.widths_per_curtain,
              "Width": variantData.width,
              "Drop": variantData.drop,
            }
          }


          if (typeof response.data.related_options != 'undefined' && response.data.related_options.length > 0) {
            for ( var i = 0; i < response.data.related_options.length; i++ ) {
              var ro = response.data.related_options[i];
              if (typeof ro['label'] !== 'undefined' && ro['label'].length > 0 && typeof ro['value'] !== 'undefined' && ro['value'].length > 0) {
                cartProperties[ ro['label'] ] = ro['value'];
              }
            }
          }
          
          if (curtain.payloadData.units == "in") {
            if ('linking_product_id' in productData) {
              cartProperties["Width inches"] = curtain.payloadData.width_units;
              cartProperties["Drop inches"] = curtain.payloadData.drop_units;
            } else {
              cartProperties["Rail width inches"] = curtain.payloadData.width_units;
              cartProperties["Curtain Drop inches"] = curtain.payloadData.drop_units;
            }
          } else if (curtain.payloadData.units == "mm") {
            if ('linking_product_id' in productData) {
              cartProperties["Width mm"] = curtain.payloadData.width_units;
              cartProperties["Drop mm"] = curtain.payloadData.drop_units;
            } else {
              cartProperties["Rail width mm"] = curtain.payloadData.width_units;
              cartProperties["Curtain Drop mm"] = curtain.payloadData.drop_units;
            }
          }

          for (var key in productOptions) {
            if (!productOptions.hasOwnProperty(key)) continue;
            var keyName = key.charAt(0) == "_" ? key : capitalizeFirstLetter( key.replace( /_/g, ' ' ) );
            cartProperties[keyName] = productOptions[key];
          }

          var ourStock = parseInt($(".our_stock").text());
          var incomingTimestamp = parseInt($('.incoming_timestamp').text());
          var currentTimestamp = parseInt($('.current_timestamp').text());
          var quantity = parseInt($('#curtain_quantity').val()) || 1;
          var totalNoMeters = productData.no_meters_fabric * quantity;
          if (totalNoMeters > ourStock && incomingTimestamp > currentTimestamp && $("#preorder-advice-property").length > 0) {
            cartProperties["_Preorder-Advice"] = $("#preorder-advice-property").val();
          }

          cartData = {
            "quantity": quantity,
            "id": response.data.variant.id,
            "properties": cartProperties
          };

          addToCart(cartData, $("#add_curtain"));
        }
      });

    });


    $("#calculate_blind").on("click", function(){
      if (!validateSizes("blind")) return false;

      var blockId = "#blinds-product ";
      var selectedMeasurementUnit = $(blockId + measurementUnitsSelector + ":checked").val();

      blind.measurementOption = $(blockId + "input[name='measurement_option']:checked").val();

      blind.payloadData = {
        "product_type": "m2mf",
        "product_code": m2mFromFabricProduct.blind.sku,
        "fabric_sku": fabricOptions.sku,
        "fabric_name": fabricOptions.name,
        "fabric_width": fabricOptions.width,
        "pattern_repeat": fabricOptions.patternRepeat,
        "price": fabricOptions.price,
        "compare_at_price": fabricOptions.compare_at_price,
        "width": parseFloat( $("#blind_width").val() ),
        "drop": parseFloat( $("#blind_drop").val() ),
        "rail_width": "",
        "fabric_hash": "",
        "units": selectedMeasurementUnit,
        "width_units": parseFloat( $("#blind_width").val() ),
        "drop_units": parseFloat( $("#blind_drop").val() ),
        "linking": true
      };

      if (selectedMeasurementUnit == 'in') {
        var widthInches = blind.payloadData.width;
        var dropInches = blind.payloadData.drop;

        var widthInchesFractionText = $(blockId + ".width-fraction option:selected").text();
        var widthInchesFractionVal = $(blockId + ".width-fraction option:selected").val();
        var dropInchesFractionText = $(blockId + ".drop-fraction option:selected").text();
        var dropInchesFractionVal = $(blockId + ".drop-fraction option:selected").val();

        var widthInchesText = widthInches + (widthInchesFractionText=="0" ? "" : (" " + widthInchesFractionText));
        var widthInchesVal = parseFloat(widthInches) + parseFloat(widthInchesFractionVal);
        var dropInchesText = dropInches + (dropInchesFractionText=="0" ? "" : (" " + dropInchesFractionText));
        var dropInchesVal = parseFloat(dropInches) + parseFloat(dropInchesFractionVal);

        widthValCm = in2cm(widthInchesVal, 0, 'round');
        dropValCm = in2cm(dropInchesVal, 0, 'round');

        blind.payloadData.width = widthValCm;
        blind.payloadData.drop = dropValCm;
        blind.payloadData.width_units = widthInchesText;
        blind.payloadData.drop_units = dropInchesText;

      } else if (selectedMeasurementUnit == 'mm') {
        var widthValCm = customRound(blind.payloadData.width / 10, 'round'),
            dropValCm = customRound(blind.payloadData.drop / 10, 'round');

        blind.payloadData.width_units = blind.payloadData.width;
        blind.payloadData.drop_units = blind.payloadData.drop;
        blind.payloadData.width = widthValCm;
        blind.payloadData.drop = dropValCm;
      }

      var calculatePriceButtonTextData = $('#calculate_blind').text();
      $('#calculate_blind').text('Working...');

      $.post(apiURL.price, blind.payloadData, function(response){
        if (response.status !== 1) {
          console.log(response.error_message);
          return;
        }
        $('#calculate_blind').text( calculatePriceButtonTextData );
        blind.productData = response.data;
        blind.fillStep2();
        blind.handleEvents();
        blind.updateDiscountCircle();
      });

    });

    $("#add_blind").on("click", function() {

      if ( $(this).hasClass('inactive') ) { return false; }
      $(this).addClass('inactive');
      $(this).text('Working...');

      var blockId = "#blinds-product ";
      var selectedMeasurementUnit = $(blockId + measurementUnitsSelector + ":checked").val();


      var selectedOptions = {};
      blind.selectedData.options.forEach(function(option){
        selectedOptions[option.title] = option.label;
      });

      var variantData = blind.payloadData;
      variantData.product_id = m2mFromFabricProduct.blind.id;
      if ('linking_product_id' in blind.productData) {
        variantData.product_id = blind.productData.linking_product_id;
        variantData.linking = true;
      }
      variantData.product_options = selectedOptions;
      variantData.service = "TF";

      $.post(apiURL.variant, variantData, function(response) {

        if ( 'undefined' !== typeof response.data.variant.id ) {
          if ('linking_product_id' in blind.productData) {
            cartProperties = {
              "Width": variantData.width,
              "Drop": variantData.drop
            }
          }else {
            cartProperties = {
              "Fabric SKU": variantData.fabric_sku,
              "Fabric Name": variantData.fabric_name,
              "Blind width": variantData.width,
              "Blind length": variantData.drop,
              "Fabric Width": variantData.fabric_width,
              "Pattern Repeat": variantData.pattern_repeat,
              "Price": variantData.price,
              "_NO_METERS_FABRIC": blind.productData.no_meters_fabric
            };
          }

          if (typeof response.data.related_options != 'undefined' && response.data.related_options.length > 0) {
            for ( var i = 0; i < response.data.related_options.length; i++ ) {
              var ro = response.data.related_options[i];
              if (typeof ro['label'] !== 'undefined' && ro['label'].length > 0 && typeof ro['value'] !== 'undefined' && ro['value'].length > 0) {
                cartProperties[ ro['label'] ] = ro['value'];
              }
            }
          }
          
          if (blind.payloadData.units == "in") {
            if ('linking_product_id' in blind.productData) {
              cartProperties["Width inches"] = blind.payloadData.width_units;
              cartProperties["Drop inches"] = blind.payloadData.drop_units;
            } else {
              cartProperties["Blind width inches"] = blind.payloadData.width_units;
              cartProperties["Blind length inches"] = blind.payloadData.drop_units;
            }
          } else if (blind.payloadData.units == "mm") {
            if ('linking_product_id' in blind.productData) {
              cartProperties["Width mm"] = blind.payloadData.width_units;
              cartProperties["Drop mm"] = blind.payloadData.drop_units;
            } else {
              cartProperties["Blind width mm"] = blind.payloadData.width_units;
              cartProperties["Blind length mm"] = blind.payloadData.drop_units;
            }
          }

          for (var key in selectedOptions) {
            if (!selectedOptions.hasOwnProperty(key)) continue;
            var keyName = key.charAt(0) == "_" ? key : capitalizeFirstLetter( key.replace( /_/g, ' ' ) );
            cartProperties[keyName] = selectedOptions[key];
          }

          var ourStock = parseInt($(".our_stock").text());
          var incomingTimestamp = parseInt($('.incoming_timestamp').text());
          var currentTimestamp = parseInt($('.current_timestamp').text());
          var blindQuantity = parseInt($('#blind_quantity').val()) || 1;
          var totalNoMeters = blind.productData.no_meters_fabric * blindQuantity;
          if (totalNoMeters > ourStock && incomingTimestamp > currentTimestamp && $("#preorder-advice-property").length > 0) {
            cartProperties["_Preorder-Advice"] = $("#preorder-advice-property").val();
          }

          cartData = {
            "quantity": blindQuantity,
            "id": response.data.variant.id,
            "properties": cartProperties
          };
          addToCart(cartData, $("#add_blind"));
        }

        $('#CartCount').text(parseInt($('#CartCount').text()) + 1);
//         $('#cAddToBasket').attr('disabled', 'disabled');
      });
    });


    $("#add_accessory").on("click", function(){
/*
      if ( $(this).hasClass('inactive') ) { return false; }
      $(this).addClass('inactive');

      var variantData = accessory.payloadData,
          selected_heading = $("input[name=heading-" + accessory.selectedType + "]:checked").val();
      variantData.product_id = m2mFromFabricProduct[ accessory.selectedType ].id;
      variantData.selected_heading = selected_heading;
      variantData.type = variantData.selected_heading.charAt(0).toUpperCase() + variantData.selected_heading.slice(1).toLowerCase();
      variantData.service = "TF";

      $.post(apiURL.variant, variantData, function(response) {

        if ( 'undefined' !== typeof response.data.variant.id ) {
          cartProperties = {
            "Fabric SKU": variantData.fabric_sku,
            "Fabric Name": variantData.fabric_name,
            "Type": variantData.type,
            "Fabric Width": variantData.fabric_width,
            "Pattern Repeat": variantData.pattern_repeat,
            "Price": variantData.price,
            "_NO_METERS_FABRIC": accessory.productData[selected_heading].no_meters_fabric
          };

          if (variantData.rail_width.length > 0) {
            cartProperties["Tiebacks size"] = variantData.rail_width;
          }

          var ourStock = parseInt($(".our_stock").text());
          var incomingTimestamp = parseInt($('.incoming_timestamp').text());
          var currentTimestamp = parseInt($('.current_timestamp').text());
          var accessoryQuantity = parseInt($('#accessory_quantity').val()) || 1;
          var totalNoMeters = blind.productData.no_meters_fabric * accessoryQuantity;
          if (totalNoMeters > ourStock && incomingTimestamp > currentTimestamp && $("#preorder-advice-property").length > 0) {
            cartProperties["_Preorder-Advice"] = $("#preorder-advice-property").val();
          }

          cartData = {
            "quantity": accessoryQuantity,
            "id": response.data.variant.id,
            "properties": cartProperties
          };
          addToCart(cartData, $("#add_accessory"));
        }

        $('#CartCount').text(parseInt($('#CartCount').text()) + 1);
        $('#cAddToBasket').attr('disabled', 'disabled');
      });
*/
    });

    $(".unit-radio").removeProp("checked");
    $("#curtains-unit-cm").prop("checked", true).trigger("click");
    $("#blinds-unit-cm").prop("checked", true).trigger("click");


    var accessoriesPricesRecieved = false;
    $("li[role='accessory-product'] a").on("click", function() {
      if (!accessoriesPricesRecieved) {
        accessory.preparePayloadData();

        $.post(apiURL.price, accessory.payloadData, function(response){
          if (response.status !== 1) {
            console.log(response.error_message);
            $(".accessory-container.tiebacks").addClass("hidden");
            $(".error-container").removeClass("hidden");
            $("#add_accessory").addClass("inactive");
            return;
          }
          accessory.fillProductData( response.data );
          accessory.handleEvents();
        });
        accessoriesPricesRecieved = true;
      }
    });

    $("li.bespoke-tab a").on("click", function(){
      var parentLi = $(this).parent("li");
      if (parentLi.hasClass("bespoke-header-fabric")) {
        updateDiscount(discountPercentFabric);
      } else if (parentLi.hasClass("bespoke-header-curtain")) {
        if (Object.keys(curtain.productData).length == 0) {
          // discountCircle.addClass("hidden");
        } else {
          setTimeout(function(){
            curtain.updateDiscountCircle();
          }, 10)
        }
      } else if (parentLi.hasClass("bespoke-header-blind")) {
        if (Object.keys(blind.productData).length == 0) {
          // price is not calculated yet
          // discountCircle.addClass("hidden");
        } else {
          setTimeout(function(){
            blind.updateDiscountCircle();
          }, 10)
        }
      } else if (parentLi.hasClass("bespoke-header-accessories")) {
        if (Object.keys(accessory.productData).length == 0) {
          // price is not calculated yet
          // discountCircle.addClass("hidden");
        } else {
          setTimeout(function(){
            accessory.updateDiscountCircle();
          }, 10)
        }
      }

      var vipPriceBaner = document.querySelector(".banner-product-vip");
      if (vipPriceBaner != null) {
        if (parentLi.hasClass("bespoke-header-fabric")) {
          vipPriceBaner.style.visibility = "visible";
        } else {
          vipPriceBaner.style.visibility = "hidden";
        }
      }
    });

    handleUrlParam();

  });
}
/* M2M From Fabric end */








$(document).ready(function(){
  $("#Quantity:not(.variant-quantity)").on("change", function(){

    var our_stock = parseInt($(".our_stock").text());
    var total_stock_initial = parseInt($(".total_stock_initial").text()) || 0;
    var incoming_timestamp = parseInt($(".incoming_timestamp").text());
    var current_timestamp = parseInt($(".current_timestamp").text());
    var leadTimeForce = parseInt($(".section-lead-time-force").text()) || 0;

    hideAllDeliverySections();

    // logic moved to function create_dates()  (increased number of days in section_next_day instead of hiding it)
    // if (leadTimeForce) {
    //   $(".fabric-stock-message").addClass("hidden");
    //   $(".section_lead_time").removeClass("hidden");
    //   return;
    // }
    
    if ($(this).val() > our_stock) {
      // $(".fabric-stock-message").addClass("hidden");
      if (incoming_timestamp > current_timestamp && $(this).val() > total_stock_initial) {
        $(".section_pre_order").removeClass("hidden");
        $("#preorder-advice-property").removeAttr("disabled");
      } else {
        $(".section_lead_time").removeClass("hidden");
      }
    } else {
      $(".fabric-stock-message").removeClass("hidden");
      $(".section_next_day").removeClass("hidden");
    }
  });
  
});



(function(){
  var klevuCounter = 0;
  var klevuRecsInterval = setInterval(function(){
    if (++klevuCounter >= 50) { //5 seconds with interval 100ms
      clearInterval(klevuRecsInterval);
      return;
    }
    
    var recsInner = document.querySelector(".kcResultsContainer");
    if (!recsInner) {
      return;
    }
    
    if (recsInner.innerHTML.trim().length > 0) {
      document.querySelector(".klevu-recs-container").classList.remove("hidden");
    } else {
      document.querySelector(".colour-choices-container:not(.klevu-recs-container)").classList.remove("col-md-6");
    }      
    
    
    clearInterval(klevuRecsInterval);

  }, 100);
})();



// Instantiate EasyZoom instances
var $easyzoom = $(".easyzoom").easyZoom();

var ezImages = $easyzoom.filter(".easyzoom--with-toggle");
ezImages.each(function () {
    var ezApi = $(this).data("easyZoom");
    ezApi.teardown();
});

var old_image = 0;
var active_image = 0;
var product_zoom_icon_state = false;

$(".toggle").on("click", function () {
    var $thisButton = $(this);
    if ($thisButton.data("active") === true) {
        $thisButton.data("active", false);
        ezImages.each(function () {
            var ezApi = $(this).data("easyZoom");
            ezApi.teardown();
            ezApi.hide();
        });
    } else {
        $thisButton.data("active", true);
        ezImages.each(function () {
            var ezApi = $(this).data("easyZoom");
            ezApi._init();
          ezApi.show();
        });
    }
  
  	if(product_zoom_icon_state) {
		document.getElementById("product_zoom_icon").classList.remove("tfa-quickview-out");
      	document.getElementById("product_zoom_icon").classList.add("tfa-quickview");
      	product_zoom_icon_state = false;
      	var $carousel = $('#sync1');
        var carouselData = $carousel.data();
        var carouselOptions = carouselData['owl.carousel'].options;
        carouselOptions.mouseDrag = true;
        carouselOptions.touchDrag = true;
        if(active_image != old_image) {
  			old_image = active_image;
		}
        $carousel.trigger('destroy.owl.carousel');
        $carousel.owlCarousel(carouselOptions);
      	$carousel.trigger('to.owl.carousel',[old_image,0,true]);
	} else {
      	document.getElementById("product_zoom_icon").classList.remove("tfa-quickview");
      	document.getElementById("product_zoom_icon").classList.add("tfa-quickview-out");
      	product_zoom_icon_state = true;
     	var $carousel = $('#sync1');
        var carouselData = $carousel.data();
        var carouselOptions = carouselData['owl.carousel'].options;
        carouselOptions.mouseDrag = false;
        carouselOptions.touchDrag = false;
      	old_image = active_image;
        $carousel.trigger('destroy.owl.carousel');
        $carousel.owlCarousel(carouselOptions);
      	$carousel.trigger('to.owl.carousel',[old_image,0,true]);
	}

});

window.dispatchEvent(new Event('resize'));



// retrieving supplier lead time
(function(){
  var visible_lead_time = "7-10 working days";
  if (supplierLeadTimes != null && supplierHandle != null) {
    var json_content = supplierLeadTimes["json"];
    var zero_array = json_content[0];
    var supplier_value = zero_array[supplierHandle];
    var default_value = zero_array["default-leadtime"];
  
    if (supplier_value != null && supplier_value.length > 3) {
      visible_lead_time = supplier_value;
    } else if (default_value != null && default_value.length > 3) {
      visible_lead_time = default_value;
    } else {
      visible_lead_time = "7-10 working days";
    }
  
  }

  document.querySelectorAll('.lead_time').forEach(function(element) {
    element.innerHTML = visible_lead_time;
  });

})();




function process_lead_time() {
  var element = document.getElementById("lead_time_specific_date");
  if(element) {
    var text = document.getElementById("lead_time_specific_date").innerHTML;
    if(text.includes("working days") || text.includes("working day")) {
      text = text.replace(" working days","");
      text = text.replace(" working day","");
      var amount_days;
      if(text.includes("-")) {
        var numbers = text.split("-");
        amount_days = parseInt(numbers[1]);
      } else {
        amount_days = parseInt(text);
      }
      document.getElementById("lead_time_specific_date").innerHTML = "Estimate: " + day[usable_dates[amount_days].getDay()] + " " + usable_dates[amount_days].getDate() + nth(usable_dates[amount_days].getDate()) + " " + month[usable_dates[amount_days].getMonth()];
    }
  }
}
process_lead_time();





var processIncomingDates = {

  processDate: function(selector, monthFormatOptions, elementPart) {
    var dateElements = document.querySelectorAll(selector);
    if (dateElements.length == 0) {
      return;
    }
    dateElements.forEach((el) => {
      if (elementPart == 'html') {
        var dateHtml = el.innerHTML;
      } else if (elementPart == 'value') {
        dateHtml = el.value;
      } else {
        return;
      }
      var datePattern = /(\d{1,2})\/(\d{1,2})\/(\d{1,2})/;
      if (datePattern.test(dateHtml)) {
        var matches = dateHtml.match(datePattern);
        var day = matches[1];
        var daySuffix = nth(parseInt(day));
        var dayFormatted = parseInt(day) + daySuffix;
        var month = matches[2];
        var year = "20" + matches[3];
        var dateParsed = new Date(year + "-" + month + "-" + day);
        var monthFormatted = dateParsed.toLocaleString('en-GB', monthFormatOptions);
        var dateFormatted = dayFormatted + " " + monthFormatted;
        
        if (elementPart == 'html') {
          el.innerHTML = dateHtml.replace(datePattern, dateFormatted);
        } else if (elementPart == 'value') {
          el.value = dateHtml.replace(datePattern, dateFormatted);
        }

      }
    });
  },

  processDateShort: function(){
    var selector = ".incoming-date";
    var format = {month:"short"};
    this.processDate(selector, format, 'html');
  },

  processDateLong: function(){
    var selector = ".incoming-date-long";
    var format = {month:"long", year:"numeric"};
    this.processDate(selector, format, 'html');
  },

  processPreorderAdvice: function(){
    var selector = "#preorder-advice-property";
    var format = {month:"short"};
    this.processDate(selector, format, 'value');
  },

  run: function(){
    this.processDateShort();
    this.processDateLong();
    this.processPreorderAdvice();
  }
}
processIncomingDates.run();


/* START - PRODUCT TABS */
var calculatorSliderRefreshed = false;
var product_tab_active = "none";
var window_width = $(window).width();
var viewMode = 'mobile';
if(window_width >= 768) {
  product_tab_active = "product_tab_section_description";
  viewMode = 'mobile';
  $(".tf_product_tabs .tab").first().css('background-color', 'rgb(242, 245, 246)');
}
$("#" + product_tab_active).show();

$(".tf_product_tabs .tab").click(function() {
  if(product_tab_active == this.dataset.section) {
  } else {
    $("[data-section=" + product_tab_active + "] i").removeClass("tfa-chevron-up");
    $("[data-section=" + product_tab_active + "] i").addClass("tfa-chevron-down");
    $("[data-section=" + product_tab_active + "]").css("background-color", "transparent");
    $("#" + product_tab_active).hide();
    $(this).css("background-color", "#F2F5F6");
    $("[data-section=" + this.dataset.section + "] i").removeClass("tfa-chevron-down");
    $("[data-section=" + this.dataset.section + "] i").addClass("tfa-chevron-up");
    $("[data-section=" + this.dataset.section + "]").css("background-color", "#F2F5F6");
    $("#" + this.dataset.section).slideDown(1000);
    product_tab_active = this.dataset.section;
    
    if (product_tab_active == 'product_tab_section_size_calculator' && !calculatorSliderRefreshed) {
      $("#b, #f").slider('refresh');
      calculatorSliderRefreshed = true;
    }
    window.dispatchEvent(new Event('resize'));
  }
});

$(".tf_product_tabs_mobile").click(function() {
  if(product_tab_active == this.dataset.section) {
    $("#" + product_tab_active).slideUp();
    $("[data-section=" + product_tab_active + "]").css("background-color", "transparent");
    $("[data-section=" + this.dataset.section + "] i").removeClass("tfa-chevron-up");
    $("[data-section=" + this.dataset.section + "] i").addClass("tfa-chevron-down");
    $(this).css("background-color", "transparent");
    product_tab_active = "none";
  } else {
    $("[data-section=" + product_tab_active + "] i").removeClass("tfa-chevron-up");
    $("[data-section=" + product_tab_active + "] i").addClass("tfa-chevron-down");
    $("[data-section=" + product_tab_active + "]").css("background-color", "transparent");
    $("#" + product_tab_active).hide();
    $(this).css("background-color", "#F2F5F6");
    $("[data-section=" + this.dataset.section + "]").css("background-color", "#F2F5F6");
    $("[data-section=" + this.dataset.section + "] i").removeClass("tfa-chevron-down");
    $("[data-section=" + this.dataset.section + "] i").addClass("tfa-chevron-up");
    $("#" + this.dataset.section).slideDown(1000);
   	this.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    product_tab_active = this.dataset.section;
    
    if (product_tab_active == 'product_tab_section_size_calculator' && !calculatorSliderRefreshed) {
      $("#b, #f").slider('refresh');
      calculatorSliderRefreshed = true;
    }
    window.dispatchEvent(new Event('resize'));
  }
});

$(window).resize(function() {
  var window_width = $(window).width();
  if(window_width >= 768) {
    if (viewMode == 'mobile') {
      viewMode = 'desktop';
      $(".read-more-content").removeAttr("style");
      $(".btn-read-more").removeClass("hidden").attr("data-hidden", false);
      $(".btn-read-less").addClass("hidden").attr("data-hidden", true);
      if(product_tab_active == "none") {
        product_tab_active = "product_tab_section_description";
        $("#product_tab_section_description").slideDown(500);
        $("[data-section=" + product_tab_active + "]").css("background-color", "#F2F5F6");
      }
    }
  } else {
    if (viewMode == 'desktop') {
      viewMode = 'mobile';
      $(".read-more-content").css("max-height", "none");
    }
  }
});


$(".specification-advice").click(function(){
  // open Specification tab
  $(".tab[data-section=product_tab_section_specifications]").trigger("click");
  // scroll to Specification content
  var target = $(".tf_product_tabs_container");
  $('html, body').animate({ scrollTop: target.offset().top}, 1000);
});

$(".returns-message").click(function(){
  // open Returns tab
  $(".tab[data-section=product_tab_section_returns]").trigger("click");
  // scroll to Returns content
  var target = $(".tf_product_tabs_container");
  $('html, body').animate({ scrollTop: target.offset().top}, 1000);
});

/* FINISH - PRODUCT TABS */

// BACK IN STOCK

var bis_error = false;
            var bis_input = document.getElementById('bis_input');
            
            function handle_input() {
              if(bis_error) {
                $("#bis_input").css("border", "1px solid black");
                $("#bis_error").hide();
                bis_error = false;
              }
            }

            if (bis_input !== null) {
              bis_input.addEventListener('input', handle_input);
            }
            
            function validateEmail(e) {
              return String(e).toLowerCase().match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              );
            };

            var clicked_button = false;
            
            function sendIt() {
              if(clicked_button == false) {
                clicked_button = true;
                try {
                  var res = $("#variants-list").val().split("|");
                  variant = res[0];
                } catch(e) {
                  variant = document.getElementById("bis_input_variant").value;
                }
                var email = $("#bis_input").val();
                if(email) {
                  if(validateEmail(email)) {
                    var endpoint = `${wsBaseApiUrl}/notify_in_stock`;
                    var email = $('#bis_input').val();
                    $.ajax({
                        type: "POST",
                        url: endpoint,
                        data: {
                          variant: variant,
                          email: email
                        },
                        success: function (res) {
                          $("#bis_input_container").hide();
                          $("#bis_input_container").value = "";
                          $("#bis_button").removeClass("bis_button");
                          $("#bis_button").addClass("bis_button_success");
                          $("#bis_button").text("Thanks, you're in the queue");
                          setTimeout(function() {
                            $("#bis_input_container").show();
                            clicked_button = false;
                            $("#bis_button").removeClass("bis_button_success");
                            $("#bis_button").addClass("bis_button");
                            $("#bis_button").text("Notify me when back in stock");
                          }, 5000);
                        }
                    });
                  } else {
                    bis_error = true;
                    $("#bis_input").css("border","1px solid #d4404a");
                    $("#bis_error").text("Invalid email address");
                    $("#bis_error").show();
                    clicked_button = false;
                  }
                } else {
                  bis_error = true;
                  $("#bis_input").css("border","1px solid #d4404a");
                  $("#bis_error").text("Please enter your email address");
                  $("#bis_error").show();
                  clicked_button = false;
                }
              }
            }



function m2mCurtainHeaderPopup(popupId) {
  var element = event.target;
  var headerBlock = $(element).closest(".tf-variant-product");
  if (headerBlock.length > 0 && headerBlock.hasClass("pc-heading-is-available")) {
    PopupSideBar(popupId);
  }
}








function processLocationsFabricAndSingle() {
  var ourStock = parseInt(document.querySelector('.add .our_stock').innerHTML);
  var initialStock = parseInt(document.querySelector('.add .total_stock_initial').innerHTML);

  document.querySelectorAll('.sidebar-our-stock').forEach((el) => {
    el.innerHTML = ourStock;
  });
  document.querySelectorAll('.sidebar-total-stock').forEach((el) => {
    el.innerHTML = initialStock;
  });
  document.querySelectorAll('.PopupSideBar .stock-message').forEach((el) => {
    el.classList.add('hidden');
  });

  if (document.querySelector('.buying-options-fabric')) {
    if (initialStock == 0) {
      document.querySelector('#FabricDeliveryPreOrder .no-stock').classList.remove('hidden');
    } else {
      if (initialStock == 1) {
        document.querySelector('#FabricDeliveryPreOrder .one-in-stock').classList.remove('hidden');
      } else {
        document.querySelector('#FabricDeliveryPreOrder .in-stock').classList.remove('hidden');
      }
    }
    if (ourStock == 0) {
      document.querySelector('#FabricDeliveryLeadTime .no-stock').classList.remove('hidden');
    } else {
      document.querySelector('#FabricDeliveryLeadTime .in-stock').classList.remove('hidden');
    }
  } else if (document.querySelector('.buying-options-single')) {
    if (initialStock == 0) {
      document.querySelector('#SingleDeliveryPreOrder .no-stock').classList.remove('hidden');
    } else {
      document.querySelector('#SingleDeliveryPreOrder .in-stock').classList.remove('hidden');
    }
    if (ourStock == 0) {
      document.querySelector('#SingleDeliveryLeadTime .no-stock').classList.remove('hidden');
    } else {
      document.querySelector('#SingleDeliveryLeadTime .in-stock').classList.remove('hidden');
    }
  }
}

document.addEventListener('jtcVariantLocationsLoaded', function(){
  // console.log('jtcProductInventoryInfo.data.variants: ', jtcProductInventoryInfo.data.variants);
  var ourStockElement = document.querySelector('.add .our_stock');
  if (ourStockLocationNames && ourStockLocationNames.length > 0) {
    if (ourStockElement) {
      // fabric or single
      var variant = Object.values(jtcProductInventoryInfo.data.variants)[0];
      var ourStockResult = 0;
      for (var i in variant.locations) {
        var location = variant.locations[i];
        if (ourStockLocationNames.includes(location.name)) {
          ourStockResult += location.stock;
        }
      }
      ourStockElement.innerHTML = ourStockResult;
      document.getElementById('Quantity').dispatchEvent(new Event('change'));

      if (document.querySelector('.buying-options-fabric,.buying-options-single')) {
        processLocationsFabricAndSingle();
      }
      
    }
  }
});

if (!document.getElementById('variants-list')) {
  var stockIntervalCounter = 0;
  var stockInterval = setInterval(function(){
    if (++stockIntervalCounter > 50) {
      clearInterval(stockInterval);
      document.getElementById('Quantity').dispatchEvent(new Event('change'));
      return;
    }
    if (typeof(jtcProductInventoryInfo) !== 'undefined' && typeof(jtcProductInventoryInfo.data.variants) !== 'undefined') {
      clearInterval(stockInterval);
      return;
    }
  }, 100);
}



function scrollToReturnsInfo() {
  document.querySelector('div[data-section="product_tab_section_returns"]').click();
  document.querySelector('#product_tab_section_returns').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
}



